const AllBookPage = 


[


  
{
  "_id": {
    "$oid": "01formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP01",
  "pagename": "01formulaphy1",

},
{
  "_id": {
    "$oid": "01formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP01",
  "pagename": "01formulaphy2",

},
{
  "_id": {
    "$oid": "01formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP01",
  "pagename": "01formulaphy3",

},
{
  "_id": {
    "$oid": "01formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP01",
  "pagename": "01formulaphy4",

},
{
  "_id": {
    "$oid": "02formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02formulaphy1",

},
{
  "_id": {
    "$oid": "02formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02formulaphy2",

},
{
  "_id": {
    "$oid": "02formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02formulaphy3",

},
{
  "_id": {
    "$oid": "02formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02formulaphy4",

},
{
  "_id": {
    "$oid": "02formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02formulaphy5",

},
{
  "_id": {
    "$oid": "02formulaphy6"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02formulaphy6",

},
{
  "_id": {
    "$oid": "02formulaphy7"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02formulaphy7",

},
{
  "_id": {
    "$oid": "03formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP03",
  "pagename": "03formulaphy1",

},
{
  "_id": {
    "$oid": "03formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP03",
  "pagename": "03formulaphy2",

},
{
  "_id": {
    "$oid": "03formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP03",
  "pagename": "03formulaphy3",

},
{
  "_id": {
    "$oid": "03formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP03",
  "pagename": "03formulaphy4",

},
{
  "_id": {
    "$oid": "03formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP03",
  "pagename": "03formulaphy5",

},
{
  "_id": {
    "$oid": "03formulaphy6"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP03",
  "pagename": "03formulaphy6",

},
{
  "_id": {
    "$oid": "04formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP04",
  "pagename": "04formulaphy1",

},
{
  "_id": {
    "$oid": "04formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP04",
  "pagename": "04formulaphy2",

},
{
  "_id": {
    "$oid": "04formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP04",
  "pagename": "04formulaphy3",

},
{
  "_id": {
    "$oid": "04formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP04",
  "pagename": "04formulaphy4",

},
{
  "_id": {
    "$oid": "05formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05formulaphy1",

},
{
  "_id": {
    "$oid": "05formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05formulaphy2",

},
{
  "_id": {
    "$oid": "05formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05formulaphy3",

},
{
  "_id": {
    "$oid": "05formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05formulaphy4",

},
{
  "_id": {
    "$oid": "05formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05formulaphy5",

},
{
  "_id": {
    "$oid": "05formulaphy6"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05formulaphy6",

},
{
  "_id": {
    "$oid": "05formulaphy7"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05formulaphy7",

},
{
  "_id": {
    "$oid": "06formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP06",
  "pagename": "06formulaphy1",

},
{
  "_id": {
    "$oid": "06formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP06",
  "pagename": "06formulaphy2",

},{
  "_id": {
    "$oid": "06formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP06",
  "pagename": "06formulaphy3",

},{
  "_id": {
    "$oid": "06formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP06",
  "pagename": "06formulaphy4",

},
{
  "_id": {
    "$oid": "07formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07formulaphy1",
},
{
  "_id": {
    "$oid": "07formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07formulaphy2",
},
{
  "_id": {
    "$oid": "07formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07formulaphy3",
},
{
  "_id": {
    "$oid": "07formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07formulaphy4",
},
{
  "_id": {
    "$oid": "07formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07formulaphy5",
},
{
  "_id": {
    "$oid": "08formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08formulaphy1",

},
{
  "_id": {
    "$oid": "08formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08formulaphy2",

},
{
  "_id": {
    "$oid": "09formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09formulaphy1",

},
{
  "_id": {
    "$oid": "09formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09formulaphy2",

},
{
  "_id": {
    "$oid": "09formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09formulaphy3",

},
{
  "_id": {
    "$oid": "10formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10formulaphy1",

},
{
  "_id": {
    "$oid": "10formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10formulaphy2",

},
{
  "_id": {
    "$oid": "10formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10formulaphy3",

},
{
  "_id": {
    "$oid": "10formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10formulaphy4",

},
{
  "_id": {
    "$oid": "10formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10formulaphy5",

},
{
  "_id": {
    "$oid": "11formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11formulaphy1",

},
{
  "_id": {
    "$oid": "11formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11formulaphy2",

},
{
  "_id": {
    "$oid": "11formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11formulaphy3",

},
{
  "_id": {
    "$oid": "12formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12formulaphy1",

},
{
  "_id": {
    "$oid": "12formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12formulaphy2",

},
{
  "_id": {
    "$oid": "12formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12formulaphy3",

},
{
  "_id": {
    "$oid": "12formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12formulaphy4",

},
{
  "_id": {
    "$oid": "12formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12formulaphy5",

},
{
  "_id": {
    "$oid": "13formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13formulaphy1",

},
{
  "_id": {
    "$oid": "13formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13formulaphy2",

},
{
  "_id": {
    "$oid": "13formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13formulaphy3",

},
{
  "_id": {
    "$oid": "13formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13formulaphy4",

},
{
  "_id": {
    "$oid": "13formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13formulaphy5",

},
{
  "_id": {
    "$oid": "14formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14formulaphy1",

},
{
  "_id": {
    "$oid": "14formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14formulaphy2",

},
{
  "_id": {
    "$oid": "14formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14formulaphy3",

},
{
  "_id": {
    "$oid": "14formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14formulaphy4",

},
{
  "_id": {
    "$oid": "14formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14formulaphy5",

},
{
  "_id": {
    "$oid": "1formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15formulaphy1",
},
{
  "_id": {
    "$oid": "1formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15formulaphy2",
},
{
  "_id": {
    "$oid": "1formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15formulaphy3",
},
{
  "_id": {
    "$oid": "1formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15formulaphy4",
},
{
  "_id": {
    "$oid": "1formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15formulaphy5",
},
{
  "_id": {
    "$oid": "16formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16formulaphy1",
},
 {
  "_id": {
    "$oid": "16formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16formulaphy2",
},
 {
  "_id": {
    "$oid": "16formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16formulaphy3",
},
{
  "_id": {
    "$oid": "17formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17formulaphy1",
},
{
  "_id": {
    "$oid": "17formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17formulaphy2",
},
{
  "_id": {
    "$oid": "17formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17formulaphy3",
},
{
  "_id": {
    "$oid": "17formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17formulaphy4",
},
{
  "_id": {
    "$oid": "17formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17formulaphy5",
},
{
  "_id": {
    "$oid": "17formulaphy6"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17formulaphy6",
},
{
  "_id": {
    "$oid": "18formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18formulaphy1",
},
{
  "_id": {
    "$oid": "18formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18formulaphy2",
},
{
  "_id": {
    "$oid": "18formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18formulaphy3",
},
{
  "_id": {
    "$oid": "18formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18formulaphy4",
},
{
  "_id": {
    "$oid": "18formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18formulaphy5",
},
{
  "_id": {
    "$oid": "19formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19formulaphy1",
},
 {
  "_id": {
    "$oid": "19formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19formulaphy2",
},
 {
  "_id": {
    "$oid": "19formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19formulaphy3",
},
 {
  "_id": {
    "$oid": "19formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19formulaphy4",
},
{
  "_id": {
    "$oid": "20formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20formulaphy1",
},
{
  "_id": {
    "$oid": "20formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20formulaphy2",
},
{
  "_id": {
    "$oid": "20formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20formulaphy3",
},
{
  "_id": {
    "$oid": "20formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20formulaphy4",
},
{
  "_id": {
    "$oid": "20formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20formulaphy5",
},
{
  "_id": {
    "$oid": "21formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21formulaphy1",
},
{
  "_id": {
    "$oid": "21formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21formulaphy2",
},
{
  "_id": {
    "$oid": "21formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21formulaphy3",
},
{
  "_id": {
    "$oid": "21formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21formulaphy4",
},
{
  "_id": {
    "$oid": "21formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21formulaphy5",
},
{
  "_id": {
    "$oid": "22formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP22",
  "pagename": "22formulaphy1",
},
{
  "_id": {
    "$oid": "22formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP22",
  "pagename": "22formulaphy2",
},
{
  "_id": {
    "$oid": "22formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP22",
  "pagename": "22formulaphy3",
},
{
  "_id": {
    "$oid": "22formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP22",
  "pagename": "22formulaphy4",
},
{
  "_id": {
    "$oid": "23formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23formulaphy1",
},
{
  "_id": {
    "$oid": "23formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23formulaphy2",
},
{
  "_id": {
    "$oid": "23formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23formulaphy3",
},
{
  "_id": {
    "$oid": "23formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23formulaphy4",
},
{
  "_id": {
    "$oid": "23formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23formulaphy5",
},
{
  "_id": {
    "$oid": "23formulaphy6"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23formulaphy6",
},
{
  "_id": {
    "$oid": "23formulaphy7"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23formulaphy7",
},
{
  "_id": {
    "$oid": "23formulaphy8"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23formulaphy8",
},
{
  "_id": {
    "$oid": "24formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP24",
  "pagename": "24formulaphy1",
},
{
  "_id": {
    "$oid": "24formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP24",
  "pagename": "24formulaphy2",
},
{
  "_id": {
    "$oid": "24formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP24",
  "pagename": "24formulaphy3",
},
{
  "_id": {
    "$oid": "24formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP24",
  "pagename": "24formulaphy4",
},
{
  "_id": {
    "$oid": "24formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP24",
  "pagename": "24formulaphy5",
},
{
  "_id": {
    "$oid": "25formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP25",
  "pagename": "25formulaphy1",
},
{
  "_id": {
    "$oid": "25formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP25",
  "pagename": "25formulaphy2",
},
{
  "_id": {
    "$oid": "25formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP25",
  "pagename": "25formulaphy3",
},
{
  "_id": {
    "$oid": "25formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP25",
  "pagename": "25formulaphy4",
},
{
  "_id": {
    "$oid": "26formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP26",
  "pagename": "26formulaphy1",
},
{
  "_id": {
    "$oid": "26formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP26",
  "pagename": "26formulaphy2",
},
{
  "_id": {
    "$oid": "26formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP26",
  "pagename": "26formulaphy3",
},
{
  "_id": {
    "$oid": "26formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP26",
  "pagename": "26formulaphy4",
},
{
  "_id": {
    "$oid": "27formulaphy1"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP27",
  "pagename": "27formulaphy1",
},
{
  "_id": {
    "$oid": "27formulaphy2"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP27",
  "pagename": "27formulaphy2",
},
{
  "_id": {
    "$oid": "27formulaphy3"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP27",
  "pagename": "27formulaphy3",
},
{
  "_id": {
    "$oid": "27formulaphy4"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP27",
  "pagename": "27formulaphy4",
},
{
  "_id": {
    "$oid": "27formulaphy5"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP27",
  "pagename": "27formulaphy5",
},
{
  "_id": {
    "$oid": "27formulaphy6"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP27",
  "pagename": "27formulaphy6",
},
{
  "_id": {
    "$oid": "27formulaphy7"
  },
  "type": "formula",
  "subject": "physics",
  "topic": "CP27",
  "pagename": "27formulaphy7",
},
{
  "_id": {
    "$oid": "01formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01formulache1",
},
{
  "_id": {
    "$oid": "01formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01formulache2",
},
{
  "_id": {
    "$oid": "01formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01formulache3",
},
{
  "_id": {
    "$oid": "01formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01formulache4",
},
{
  "_id": {
    "$oid": "01formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01formulache5",
},
{
  "_id": {
    "$oid": "01formulache6"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01formulache6",
},
{
  "_id": {
    "$oid": "01formulache7"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01formulache7",
},
{
  "_id": {
    "$oid": "02formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02formulache1",
},
{
  "_id": {
    "$oid": "02formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02formulache2",
},
{
  "_id": {
    "$oid": "02formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02formulache3",
},
{
  "_id": {
    "$oid": "02formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02formulache4",
},
{
  "_id": {
    "$oid": "02formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02formulache5",
},
{
  "_id": {
    "$oid": "02formulache6"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02formulache6",
},
{
  "_id": {
    "$oid": "02formulache7"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02formulache7",
},
{
  "_id": {
    "$oid": "03formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03formulache1",
},
{
  "_id": {
    "$oid": "03formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03formulache2",
},
{
  "_id": {
    "$oid": "03formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03formulache3",
},
{
  "_id": {
    "$oid": "03formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03formulache4",
},
{
  "_id": {
    "$oid": "03formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03formulache5",
},
{
  "_id": {
    "$oid": "03formulache6"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03formulache6",
},
{
  "_id": {
    "$oid": "04formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04formulache1",
},
{
  "_id": {
    "$oid": "04formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04formulache2",
},
{
  "_id": {
    "$oid": "04formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04formulache3",
},
{
  "_id": {
    "$oid": "04formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04formulache4",
},
{
  "_id": {
    "$oid": "05formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05formulache1",
},
{
  "_id": {
    "$oid": "05formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05formulache2",
},
{
  "_id": {
    "$oid": "05formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05formulache3",
},
{
  "_id": {
    "$oid": "05formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05formulache4",
},
{
  "_id": {
    "$oid": "05formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05formulache5",
},
{
  "_id": {
    "$oid": "05formulache6"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05formulache6",
},
{
  "_id": {
    "$oid": "05formulache7"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05formulache7",
},
{
  "_id": {
    "$oid": "06formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06formulache1",
},
{
  "_id": {
    "$oid": "06formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06formulache2",
},
{
  "_id": {
    "$oid": "06formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06formulache3",
},
{
  "_id": {
    "$oid": "06formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06formulache4",
},
{
  "_id": {
    "$oid": "07formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07formulache1",
},
{
  "_id": {
    "$oid": "07formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07formulache2",
},
{
  "_id": {
    "$oid": "07formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07formulache3",
},
{
  "_id": {
    "$oid": "07formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07formulache4",
},
{
  "_id": {
    "$oid": "07formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07formulache5",
},
{
  "_id": {
    "$oid": "08formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08formulache1",
},
{
  "_id": {
    "$oid": "08formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08formulache2",
},
{
  "_id": {
    "$oid": "09formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09formulache1",
},
{
  "_id": {
    "$oid": "09formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09formulache2",
},
{
  "_id": {
    "$oid": "09formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09formulache3",
},
{
  "_id": {
    "$oid": "10formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10formulache1",
},
{
  "_id": {
    "$oid": "10formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10formulache2",
},
{
  "_id": {
    "$oid": "10formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10formulache3",
},
{
  "_id": {
    "$oid": "10formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10formulache4",
},
{
  "_id": {
    "$oid": "10formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10formulache5",
},
{
  "_id": {
    "$oid": "11formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11formulache1",
},
{
  "_id": {
    "$oid": "11formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11formulache2",
},
{
  "_id": {
    "$oid": "11formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11formulache3",
},
{
  "_id": {
    "$oid": "12formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12formulache1",
},
{
  "_id": {
    "$oid": "12formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12formulache2",
},
{
  "_id": {
    "$oid": "12formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12formulache3",
},
{
  "_id": {
    "$oid": "12formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12formulache4",
},
{
  "_id": {
    "$oid": "12formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12formulache5",
},
{
  "_id": {
    "$oid": "13formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13formulache1",
},
{
  "_id": {
    "$oid": "13formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13formulache2",
},
{
  "_id": {
    "$oid": "13formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13formulache3",
},
{
  "_id": {
    "$oid": "13formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13formulache4",
},
{
  "_id": {
    "$oid": "13formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13formulache5",
},
{
  "_id": {
    "$oid": "14formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14formulache1",
},
{
  "_id": {
    "$oid": "14formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14formulache2",
},
{
  "_id": {
    "$oid": "14formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14formulache3",
},
{
  "_id": {
    "$oid": "14formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14formulache4",
},
{
  "_id": {
    "$oid": "14formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14formulache5",
},
{
  "_id": {
    "$oid": "15formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15formulache1",
},
{
  "_id": {
    "$oid": "15formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15formulache2",
},
{
  "_id": {
    "$oid": "15formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15formulache3",
},
{
  "_id": {
    "$oid": "15formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15formulache4",
},
{
  "_id": {
    "$oid": "15formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15formulache5",
},
{
  "_id": {
    "$oid": "16formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16formulache1",
},
{
  "_id": {
    "$oid": "16formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16formulache2",
},
{
  "_id": {
    "$oid": "16formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16formulache3",
},
{
  "_id": {
    "$oid": "17formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17formulache1",
},
{
  "_id": {
    "$oid": "17formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17formulache2",
},
{
  "_id": {
    "$oid": "17formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17formulache3",
},
{
  "_id": {
    "$oid": "17formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17formulache4",
},
{
  "_id": {
    "$oid": "17formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17formulache5",
},
{
  "_id": {
    "$oid": "17formulache6"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17formulache6",
},
{
  "_id": {
    "$oid": "18formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18formulache1",
},
{
  "_id": {
    "$oid": "18formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18formulache2",
},
{
  "_id": {
    "$oid": "18formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18formulache3",
},
{
  "_id": {
    "$oid": "18formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18formulache4",
},
{
  "_id": {
    "$oid": "18formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18formulache5",
},
{
  "_id": {
    "$oid": "19formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC19",
  "pagename": "19formulache1",
},
{
  "_id": {
    "$oid": "19formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC19",
  "pagename": "19formulache2",
},
{
  "_id": {
    "$oid": "19formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC19",
  "pagename": "19formulache3",
},
{
  "_id": {
    "$oid": "20formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20formulache1",
},
{
  "_id": {
    "$oid": "20formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20formulache2",
},
{
  "_id": {
    "$oid": "20formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20formulache3",
},
{
  "_id": {
    "$oid": "20formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20formulache4",
},
{
  "_id": {
    "$oid": "20formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20formulache5",
},
{
  "_id": {
    "$oid": "21formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21formulache1",
},
{
  "_id": {
    "$oid": "21formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21formulache2",
},
{
  "_id": {
    "$oid": "21formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21formulache3",
},
{
  "_id": {
    "$oid": "21formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21formulache4",
},
{
  "_id": {
    "$oid": "21formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21formulache5",
},
{
  "_id": {
    "$oid": "22formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC22",
  "pagename": "22formulache1",
},
{
  "_id": {
    "$oid": "22formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC22",
  "pagename": "22formulache2",
},
{
  "_id": {
    "$oid": "22formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC22",
  "pagename": "22formulache3",
},
{
  "_id": {
    "$oid": "22formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC22",
  "pagename": "22formulache4",
},
{
  "_id": {
    "$oid": "23formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23formulache1",
},
{
  "_id": {
    "$oid": "23formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23formulache2",
},
{
  "_id": {
    "$oid": "23formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23formulache3",
},
{
  "_id": {
    "$oid": "23formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23formulache4",
},
{
  "_id": {
    "$oid": "23formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23formulache5",
},
{
  "_id": {
    "$oid": "23formulache6"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23formulache6",
},
{
  "_id": {
    "$oid": "23formulache7"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23formulache7",
},
{
  "_id": {
    "$oid": "23formulache8"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23formulache8",
},
{
  "_id": {
    "$oid": "24formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC24",
  "pagename": "24formulache1",
},
{
  "_id": {
    "$oid": "24formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC24",
  "pagename": "24formulache2",
},
{
  "_id": {
    "$oid": "24formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC24",
  "pagename": "24formulache3",
},
{
  "_id": {
    "$oid": "24formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC24",
  "pagename": "24formulache4",
},
{
  "_id": {
    "$oid": "24formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC24",
  "pagename": "24formulache5",
},
{
  "_id": {
    "$oid": "25formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC25",
  "pagename": "25formulache1",
},
{
  "_id": {
    "$oid": "25formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC25",
  "pagename": "25formulache2",
},
{
  "_id": {
    "$oid": "25formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC25",
  "pagename": "25formulache3",
},
{
  "_id": {
    "$oid": "25formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC25",
  "pagename": "25formulache4",
},
{
  "_id": {
    "$oid": "26formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC26",
  "pagename": "26formulache1",
},
{
  "_id": {
    "$oid": "26formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC26",
  "pagename": "26formulache2",
},
{
  "_id": {
    "$oid": "26formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC26",
  "pagename": "26formulache3",
},
{
  "_id": {
    "$oid": "26formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC26",
  "pagename": "26formulache4",
},
{
  "_id": {
    "$oid": "27formulache1"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27formulache1",
},
{
  "_id": {
    "$oid": "27formulache2"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27formulache2",
},
{
  "_id": {
    "$oid": "27formulache3"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27formulache3",
},
{
  "_id": {
    "$oid": "27formulache4"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27formulache4",
},
{
  "_id": {
    "$oid": "27formulache5"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27formulache5",
},
{
  "_id": {
    "$oid": "27formulache6"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27formulache6",
},
{
  "_id": {
    "$oid": "27formulache7"
  },
  "type": "formula",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27formulache7",
},
{
  "_id": {
    "$oid": "01formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01formulabio1",
},
{
  "_id": {
    "$oid": "01formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01formulabio2",
},
{
  "_id": {
    "$oid": "01formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01formulabio3",
},
{
  "_id": {
    "$oid": "01formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01formulabio4",
},
{
  "_id": {
    "$oid": "02formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02formulabio1",
},
{
  "_id": {
    "$oid": "02formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02formulabio2",
},
{
  "_id": {
    "$oid": "02formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02formulabio3",
},
{
  "_id": {
    "$oid": "02formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02formulabio4",
},
{
  "_id": {
    "$oid": "02formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02formulabio5",
},
{
  "_id": {
    "$oid": "03formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03formulabio1",
},
{
  "_id": {
    "$oid": "03formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03formulabio2",
},
{
  "_id": {
    "$oid": "03formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03formulabio3",
},
{
  "_id": {
    "$oid": "03formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03formulabio4",
},
{
  "_id": {
    "$oid": "03formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03formulabio5",
},
{
  "_id": {
    "$oid": "04formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04formulabio1",
},
{
  "_id": {
    "$oid": "04formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04formulabio2",
},
{
  "_id": {
    "$oid": "04formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04formulabio3",
},
{
  "_id": {
    "$oid": "04formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04formulabio4",
},
{
  "_id": {
    "$oid": "04formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04formulabio5",
},
{
  "_id": {
    "$oid": "04formulabio6"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04formulabio6",
},
{
  "_id": {
    "$oid": "05formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05formulabio1",
},
{
  "_id": {
    "$oid": "05formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05formulabio2",
},
{
  "_id": {
    "$oid": "05formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05formulabio3",
},
{
  "_id": {
    "$oid": "05formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05formulabio4",
},
{
  "_id": {
    "$oid": "05formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05formulabio5",
},
{
  "_id": {
    "$oid": "05formulabio6"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05formulabio6",
},
{
  "_id": {
    "$oid": "05formulabio7"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05formulabio7",
},
{
  "_id": {
    "$oid": "05formulabio8"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05formulabio8",
},
{
  "_id": {
    "$oid": "06formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06formulabio1",
},
{
  "_id": {
    "$oid": "06formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06formulabio2",
},
{
  "_id": {
    "$oid": "06formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06formulabio3",
},
{
  "_id": {
    "$oid": "06formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06formulabio4",
},
{
  "_id": {
    "$oid": "07formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07formulabio1",
},
{
  "_id": {
    "$oid": "07formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07formulabio2",
},
{
  "_id": {
    "$oid": "07formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07formulabio3",
},
{
  "_id": {
    "$oid": "07formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07formulabio4",
},
{
  "_id": {
    "$oid": "07formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07formulabio5",
},
{
  "_id": {
    "$oid": "07formulabio6"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07formulabio6",
},
{
  "_id": {
    "$oid": "07formulabio7"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07formulabio7",
},
{
  "_id": {
    "$oid": "07formulabio8"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07formulabio8",
},
{
  "_id": {
    "$oid": "07formulabio9"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07formulabio9",
},
{
  "_id": {
    "$oid": "08formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08formulabio1",
},
{
  "_id": {
    "$oid": "08formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08formulabio2",
},
{
  "_id": {
    "$oid": "08formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08formulabio3",
},
{
  "_id": {
    "$oid": "08formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08formulabio4",
},
{
  "_id": {
    "$oid": "08formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08formulabio5",
},
{
  "_id": {
    "$oid": "09formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09formulabio1",
},
{
  "_id": {
    "$oid": "09formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09formulabio2",
},
{
  "_id": {
    "$oid": "09formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09formulabio3",
},
{
  "_id": {
    "$oid": "09formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09formulabio4",
},
{
  "_id": {
    "$oid": "09formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09formulabio5",
},
{
  "_id": {
    "$oid": "09formulabio6"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09formulabio6",
},
{
  "_id": {
    "$oid": "10formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10formulabio1",
},
{
  "_id": {
    "$oid": "10formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10formulabio2",
},
{
  "_id": {
    "$oid": "10formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10formulabio3",
},
{
  "_id": {
    "$oid": "10formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10formulabio4",
},
{
  "_id": {
    "$oid": "10formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10formulabio5",
},
{
  "_id": {
    "$oid": "11formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11formulabio1",
},
{
  "_id": {
    "$oid": "11formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11formulabio2",
},
{
  "_id": {
    "$oid": "11formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11formulabio3",
},
{
  "_id": {
    "$oid": "11formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11formulabio4",
},
{
  "_id": {
    "$oid": "12formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12formulabio1",
},
{
  "_id": {
    "$oid": "12formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12formulabio2",
},
{
  "_id": {
    "$oid": "12formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12formulabio3",
},
{
  "_id": {
    "$oid": "12formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12formulabio4",
},
{
  "_id": {
    "$oid": "12formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12formulabio5",
},
{
  "_id": {
    "$oid": "13formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13formulabio1",
},
{
  "_id": {
    "$oid": "13formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13formulabio2",
},
{
  "_id": {
    "$oid": "13formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13formulabio3",
},
{
  "_id": {
    "$oid": "13formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13formulabio4",
},
{
  "_id": {
    "$oid": "13formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13formulabio5",
},
{
  "_id": {
    "$oid": "14formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14formulabio1",
},
{
  "_id": {
    "$oid": "14formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14formulabio2",
},
{
  "_id": {
    "$oid": "14formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14formulabio3",
},
{
  "_id": {
    "$oid": "14formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14formulabio4",
},
{
  "_id": {
    "$oid": "14formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14formulabio5",
},
{
  "_id": {
    "$oid": "14formulabio6"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14formulabio6",
},
{
  "_id": {
    "$oid": "14formulabio7"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14formulabio7",
},
{
  "_id": {
    "$oid": "15formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15formulabio1",
},
{
  "_id": {
    "$oid": "15formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15formulabio2",
},
{
  "_id": {
    "$oid": "15formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15formulabio3",
},
{
  "_id": {
    "$oid": "16formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16formulabio1",
},
{
  "_id": {
    "$oid": "16formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16formulabio2",
},
{
  "_id": {
    "$oid": "16formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16formulabio3",
},
{
  "_id": {
    "$oid": "16formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16formulabio4",
},
{
  "_id": {
    "$oid": "16formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16formulabio5",
},
{
  "_id": {
    "$oid": "17formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17formulabio1",
},
{
  "_id": {
    "$oid": "17formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17formulabio2",
},
{
  "_id": {
    "$oid": "17formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17formulabio3",
},
{
  "_id": {
    "$oid": "17formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17formulabio4",
},
{
  "_id": {
    "$oid": "17formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17formulabio5",
},
{
  "_id": {
    "$oid": "17formulabio6"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17formulabio6",
},
{
  "_id": {
    "$oid": "18formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18formulabio1",
},
{
  "_id": {
    "$oid": "18formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18formulabio2",
},
{
  "_id": {
    "$oid": "18formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18formulabio3",
},
{
  "_id": {
    "$oid": "18formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18formulabio4",
},
{
  "_id": {
    "$oid": "18formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18formulabio5",
},
{
  "_id": {
    "$oid": "19formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB19",
  "pagename": "19formulabio1",
},
{
  "_id": {
    "$oid": "19formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB19",
  "pagename": "19formulabio2",
},
{
  "_id": {
    "$oid": "19formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB19",
  "pagename": "19formulabio3",
},
{
  "_id": {
    "$oid": "19formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB19",
  "pagename": "19formulabio4",
},
{
  "_id": {
    "$oid": "20formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB20",
  "pagename": "20formulabio1",
},
{
  "_id": {
    "$oid": "20formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB20",
  "pagename": "20formulabio2",
},
{
  "_id": {
    "$oid": "20formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB20",
  "pagename": "20formulabio3",
},
{
  "_id": {
    "$oid": "20formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB20",
  "pagename": "20formulabio4",
},
{
  "_id": {
    "$oid": "21formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB21",
  "pagename": "21formulabio1",
},
{
  "_id": {
    "$oid": "21formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB21",
  "pagename": "21formulabio2",
},
{
  "_id": {
    "$oid": "21formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB21",
  "pagename": "21formulabio3",
},
{
  "_id": {
    "$oid": "21formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB21",
  "pagename": "21formulabio4",
},
{
  "_id": {
    "$oid": "21formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB21",
  "pagename": "21formulabio5",
},
{
  "_id": {
    "$oid": "22formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB22",
  "pagename": "22formulabio1",
},
{
  "_id": {
    "$oid": "22formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB22",
  "pagename": "22formulabio2",
},
{
  "_id": {
    "$oid": "22formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB22",
  "pagename": "22formulabio3",
},
{
  "_id": {
    "$oid": "22formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB22",
  "pagename": "22formulabio4",
},
{
  "_id": {
    "$oid": "23formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB23",
  "pagename": "23formulabio1",
},
{
  "_id": {
    "$oid": "23formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB23",
  "pagename": "23formulabio2",
},
{
  "_id": {
    "$oid": "23formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB23",
  "pagename": "23formulabio3",
},
{
  "_id": {
    "$oid": "23formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB23",
  "pagename": "23formulabio4",
},
{
  "_id": {
    "$oid": "23formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB23",
  "pagename": "23formulabio5",
},
{
  "_id": {
    "$oid": "24formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB24",
  "pagename": "24formulabio1",
},
{
  "_id": {
    "$oid": "24formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB24",
  "pagename": "24formulabio2",
},
{
  "_id": {
    "$oid": "24formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB24",
  "pagename": "24formulabio3",
},
{
  "_id": {
    "$oid": "24formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB24",
  "pagename": "24formulabio4",
},
{
  "_id": {
    "$oid": "24formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB24",
  "pagename": "24formulabio5",
},
{
  "_id": {
    "$oid": "25formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB25",
  "pagename": "25formulabio1",
},
{
  "_id": {
    "$oid": "25formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB25",
  "pagename": "25formulabio2",
},
{
  "_id": {
    "$oid": "25formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB25",
  "pagename": "25formulabio3",
},
{
  "_id": {
    "$oid": "25formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB25",
  "pagename": "25formulabio4",
},
{
  "_id": {
    "$oid": "26formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB26",
  "pagename": "26formulabio1",
},
{
  "_id": {
    "$oid": "26formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB26",
  "pagename": "26formulabio2",
},
{
  "_id": {
    "$oid": "26formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB26",
  "pagename": "26formulabio3",
},
{
  "_id": {
    "$oid": "26formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB26",
  "pagename": "26formulabio4",
},
{
  "_id": {
    "$oid": "26formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB26",
  "pagename": "26formulabio5",
},
{
  "_id": {
    "$oid": "27formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27formulabio1",
},
{
  "_id": {
    "$oid": "27formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27formulabio2",
},
{
  "_id": {
    "$oid": "27formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27formulabio3",
},
{
  "_id": {
    "$oid": "27formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27formulabio4",
},
{
  "_id": {
    "$oid": "27formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27formulabio5",
},
{
  "_id": {
    "$oid": "27formulabio6"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27formulabio6",
},
{
  "_id": {
    "$oid": "28formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28formulabio1",
},
{
  "_id": {
    "$oid": "28formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28formulabio2",
},
{
  "_id": {
    "$oid": "28formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28formulabio3",
},
{
  "_id": {
    "$oid": "28formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28formulabio4",
},
{
  "_id": {
    "$oid": "28formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28formulabio5",
},
{
  "_id": {
    "$oid": "28formulabio6"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28formulabio6",
},
{
  "_id": {
    "$oid": "29formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB29",
  "pagename": "29formulabio1",
},
{
  "_id": {
    "$oid": "29formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB29",
  "pagename": "29formulabio2",
},
{
  "_id": {
    "$oid": "29formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB29",
  "pagename": "29formulabio3",
},
{
  "_id": {
    "$oid": "29formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB29",
  "pagename": "29formulabio4",
},
{
  "_id": {
    "$oid": "29formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB29",
  "pagename": "29formulabio5",
},
{
  "_id": {
    "$oid": "30formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB30",
  "pagename": "30formulabio1",
},
{
  "_id": {
    "$oid": "30formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB30",
  "pagename": "30formulabio2",
},
{
  "_id": {
    "$oid": "30formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB30",
  "pagename": "30formulabio3",
},
{
  "_id": {
    "$oid": "30formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB30",
  "pagename": "30formulabio4",
},
{
  "_id": {
    "$oid": "31formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31formulabio1",
},
{
  "_id": {
    "$oid": "31formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31formulabio2",
},
{
  "_id": {
    "$oid": "31formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31formulabio3",
},
{
  "_id": {
    "$oid": "31formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31formulabio4",
},
{
  "_id": {
    "$oid": "31formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31formulabio5",
},
{
  "_id": {
    "$oid": "32formulabio1"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32formulabio1",
},
{
  "_id": {
    "$oid": "32formulabio2"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32formulabio2",
},
{
  "_id": {
    "$oid": "32formulabio3"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32formulabio3",
},
{
  "_id": {
    "$oid": "32formulabio4"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32formulabio4",
},
{
  "_id": {
    "$oid": "32formulabio5"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32formulabio5",
},
{
  "_id": {
    "$oid": "32formulabio6"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32formulabio6",
},
{
  "_id": {
    "$oid": "32formulabio7"
  },
  "type": "formula",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32formulabio7",
},




{
  "_id": {
    "$oid": "01flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP01",
  "pagename": "01flashcardphy1",
},
{
  "_id": {
    "$oid": "02flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02flashcardphy1",
},
{
  "_id": {
    "$oid": "03flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP03",
  "pagename": "03flashcardphy1",
},{
  "_id": {
    "$oid": "03flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP03",
  "pagename": "03flashcardphy1",
},
{
  "_id": {
    "$oid": "04flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP04",
  "pagename": "04flashcardphy1",
},
{
  "_id": {
    "$oid": "05flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05flashcardphy1",
},
{
  "_id": {
    "$oid": "05flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05flashcardphy2",
},
{
  "_id": {
    "$oid": "05flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05flashcardphy3",
},
{
  "_id": {
    "$oid": "05flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05flashcardphy4",
},
{
  "_id": {
    "$oid": "05flashcardphy5"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05flashcardphy5",
},
{
  "_id": {
    "$oid": "06flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP06",
  "pagename": "06flashcardphy1",
},
{
  "_id": {
    "$oid": "07flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07flashcardphy1",
},
{
  "_id": {
    "$oid": "07flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07flashcardphy2",
},
{
  "_id": {
    "$oid": "07flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07flashcardphy3",
},
{
  "_id": {
    "$oid": "07flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07flashcardphy4",
},
{
  "_id": {
    "$oid": "08flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08flashcardphy1",
},
{
  "_id": {
    "$oid": "08flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08flashcardphy2",
},
{
  "_id": {
    "$oid": "08flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08flashcardphy3",
},
{
  "_id": {
    "$oid": "08flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08flashcardphy4",
},
{
  "_id": {
    "$oid": "09flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09flashcardphy1",
},
{
  "_id": {
    "$oid": "09flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09flashcardphy2",
},
{
  "_id": {
    "$oid": "10flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10flashcardphy1",
},
{
  "_id": {
    "$oid": "10flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10flashcardphy2",
},
{
  "_id": {
    "$oid": "10flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10flashcardphy3",
},
{
  "_id": {
    "$oid": "10flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10flashcardphy4",
},
{
  "_id": {
    "$oid": "11flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11flashcardphy1",
},
{
  "_id": {
    "$oid": "11flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11flashcardphy2",
},
{
  "_id": {
    "$oid": "11flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11flashcardphy3",
},
{
  "_id": {
    "$oid": "11flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11flashcardphy4",
},
{
  "_id": {
    "$oid": "11flashcardphy5"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11flashcardphy5",
},
{
  "_id": {
    "$oid": "11flashcardphy6"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11flashcardphy6",
},
{
  "_id": {
    "$oid": "11flashcardphy7"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11flashcardphy7",
},
{
  "_id": {
    "$oid": "11flashcardphy8"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11flashcardphy8",
},
{
  "_id": {
    "$oid": "12flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12flashcardphy1",
},
{
  "_id": {
    "$oid": "12flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12flashcardphy2",
},
{
  "_id": {
    "$oid": "12flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12flashcardphy3",
},
{
  "_id": {
    "$oid": "12flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12flashcardphy4",
},
{
  "_id": {
    "$oid": "13flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13flashcardphy1",
},
{
  "_id": {
    "$oid": "13flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13flashcardphy2",
},
{
  "_id": {
    "$oid": "13flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13flashcardphy3",
},
{
  "_id": {
    "$oid": "13flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13flashcardphy4",
},
{
  "_id": {
    "$oid": "14flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14flashcardphy1",
},
{
  "_id": {
    "$oid": "14flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14flashcardphy2",
},
{
  "_id": {
    "$oid": "14flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14flashcardphy3",
},
{
  "_id": {
    "$oid": "14flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14flashcardphy4",
},
{
  "_id": {
    "$oid": "15flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15flashcardphy1",
},
{
  "_id": {
    "$oid": "15flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15flashcardphy2",
},
{
  "_id": {
    "$oid": "15flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15flashcardphy3",
},
{
  "_id": {
    "$oid": "15flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15flashcardphy4",
},
{
  "_id": {
    "$oid": "15flashcardphy5"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15flashcardphy5",
},
{
  "_id": {
    "$oid": "15flashcardphy6"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15flashcardphy6",
},
{
  "_id": {
    "$oid": "16flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16flashcardphy1",
},
{
  "_id": {
    "$oid": "16flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16flashcardphy2",
},
{
  "_id": {
    "$oid": "16flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16flashcardphy3",
},
{
  "_id": {
    "$oid": "16flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16flashcardphy4",
},
{
  "_id": {
    "$oid": "17flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy1",
},
{
  "_id": {
    "$oid": "17flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy2",
},
{
  "_id": {
    "$oid": "17flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy3",
},
{
  "_id": {
    "$oid": "17flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy4",
},
{
  "_id": {
    "$oid": "17flashcardphy5"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy5",
},
{
  "_id": {
    "$oid": "17flashcardphy6"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy6",
},
{
  "_id": {
    "$oid": "17flashcardphy7"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy7",
},
{
  "_id": {
    "$oid": "17flashcardphy8"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy8",
},
{
  "_id": {
    "$oid": "17flashcardphy9"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy9",
},
{
  "_id": {
    "$oid": "17flashcardphy10"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy10",
},
{
  "_id": {
    "$oid": "17flashcardphy11"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy11",
},
{
  "_id": {
    "$oid": "17flashcardphy12"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17flashcardphy12",
},
{
  "_id": {
    "$oid": "18flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18flashcardphy1",
},
{
  "_id": {
    "$oid": "18flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18flashcardphy2",
},
{
  "_id": {
    "$oid": "18flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18flashcardphy3",
},
{
  "_id": {
    "$oid": "18flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18flashcardphy4",
},
{
  "_id": {
    "$oid": "18flashcardphy5"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18flashcardphy5",
},
{
  "_id": {
    "$oid": "18flashcardphy6"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18flashcardphy6",
},
{
  "_id": {
    "$oid": "19flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy1",
},
{
  "_id": {
    "$oid": "19flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy2",
},
{
  "_id": {
    "$oid": "19flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy3",
},
{
  "_id": {
    "$oid": "19flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy4",
},
{
  "_id": {
    "$oid": "19flashcardphy5"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy5",
},
{
  "_id": {
    "$oid": "19flashcardphy6"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy6",
},
{
  "_id": {
    "$oid": "19flashcardphy7"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy7",
},
{
  "_id": {
    "$oid": "19flashcardphy8"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy8",
},
{
  "_id": {
    "$oid": "19flashcardphy9"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy9",
},
{
  "_id": {
    "$oid": "19flashcardphy10"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy10",
},
{
  "_id": {
    "$oid": "19flashcardphy11"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy11",
},
{
  "_id": {
    "$oid": "19flashcardphy12"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19flashcardphy12",
},
{
  "_id": {
    "$oid": "1flashcardphy"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP1",
  "pagename": "1flashcardphy",
},
{
  "_id": {
    "$oid": "20flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20flashcardphy1",
},
{
  "_id": {
    "$oid": "21flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21flashcardphy1",
},
{
  "_id": {
    "$oid": "21flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21flashcardphy2",
},
{
  "_id": {
    "$oid": "21flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21flashcardphy3",
},
{
  "_id": {
    "$oid": "22flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP22",
  "pagename": "22flashcardphy1",
},
{
  "_id": {
    "$oid": "22flashcardphy"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP22",
  "pagename": "22flashcardphy1",
},
{
  "_id": {
    "$oid": "23flashcardphy1"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23flashcardphy1",
},
{
  "_id": {
    "$oid": "23flashcardphy2"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23flashcardphy2",
},
{
  "_id": {
    "$oid": "23flashcardphy3"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23flashcardphy3",
},
{
  "_id": {
    "$oid": "23flashcardphy4"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23flashcardphy4",
},
{
  "_id": {
    "$oid": "23flashcardphy5"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23flashcardphy5",
},
{
  "_id": {
    "$oid": "23flashcardphy6"
  },
  "type": "flashcard",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23flashcardphy6",
},

{
  "_id": {
    "$oid": "01flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01flashcardche1",
},
{
  "_id": {
    "$oid": "01flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01flashcardche2",
},
{
  "_id": {
    "$oid": "01flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01flashcardche3",
},
{
  "_id": {
    "$oid": "01flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01flashcardche4",
},
{
  "_id": {
    "$oid": "02flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02flashcardche1",
},
{
  "_id": {
    "$oid": "02flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02flashcardche2",
},
{
  "_id": {
    "$oid": "02flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02flashcardche3",
},
{
  "_id": {
    "$oid": "02flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02flashcardche4",
},
{
  "_id": {
    "$oid": "02flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02flashcardche5",
},
{
  "_id": {
    "$oid": "02flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02flashcardche6",
},
{
  "_id": {
    "$oid": "03flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche1",
},
{
  "_id": {
    "$oid": "03flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche2",
},
{
  "_id": {
    "$oid": "03flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche3",
},
{
  "_id": {
    "$oid": "03flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche4",
},
{
  "_id": {
    "$oid": "03flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche5",
},
{
  "_id": {
    "$oid": "03flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche6",
},
{
  "_id": {
    "$oid": "03flashcardche7"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche7",
},
{
  "_id": {
    "$oid": "03flashcardche8"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche8",
},
{
  "_id": {
    "$oid": "03flashcardche9"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche9",
},
{
  "_id": {
    "$oid": "03flashcardche10"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche10",
},
{
  "_id": {
    "$oid": "03flashcardche11"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche11",
},
{
  "_id": {
    "$oid": "03flashcardche12"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03flashcardche12",
},
{
  "_id": {
    "$oid": "04flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04flashcardche1",
},
{
  "_id": {
    "$oid": "04flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04flashcardche2",
},
{
  "_id": {
    "$oid": "04flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04flashcardche3",
},
{
  "_id": {
    "$oid": "04flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04flashcardche4",
},
{
  "_id": {
    "$oid": "05flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05flashcardche1",
},
{
  "_id": {
    "$oid": "05flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05flashcardche2",
},
{
  "_id": {
    "$oid": "05flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05flashcardche3",
},
{
  "_id": {
    "$oid": "05flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05flashcardche4",
},
{
  "_id": {
    "$oid": "06flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06flashcardche1",
},
{
  "_id": {
    "$oid": "06flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06flashcardche2",
},
{
  "_id": {
    "$oid": "06flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06flashcardche3",
},
{
  "_id": {
    "$oid": "06flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06flashcardche4",
},
{
  "_id": {
    "$oid": "06flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06flashcardche5",
},
{
  "_id": {
    "$oid": "06flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06flashcardche6",
},
{
  "_id": {
    "$oid": "06flashcardche7"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06flashcardche7",
},
{
  "_id": {
    "$oid": "06flashcardche8"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06flashcardche8",
},
{
  "_id": {
    "$oid": "07flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche1",
},
{
  "_id": {
    "$oid": "07flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche2",
},
{
  "_id": {
    "$oid": "07flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche3",
},
{
  "_id": {
    "$oid": "07flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche4",
},
{
  "_id": {
    "$oid": "07flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche5",
},
{
  "_id": {
    "$oid": "07flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche6",
},
{
  "_id": {
    "$oid": "07flashcardche7"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche7",
},
{
  "_id": {
    "$oid": "07flashcardche8"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche8",
},
{
  "_id": {
    "$oid": "07flashcardche9"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche9",
},
{
  "_id": {
    "$oid": "07flashcardche10"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07flashcardche10",
},
{
  "_id": {
    "$oid": "08flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08flashcardche1",
},
{
  "_id": {
    "$oid": "08flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08flashcardche2",
},
{
  "_id": {
    "$oid": "08flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08flashcardche3",
},
{
  "_id": {
    "$oid": "08flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08flashcardche4",
},
{
  "_id": {
    "$oid": "08flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08flashcardche5",
},
{
  "_id": {
    "$oid": "08flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08flashcardche6",
},
{
  "_id": {
    "$oid": "09flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09flashcardche1",
},
{
  "_id": {
    "$oid": "09flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09flashcardche2",
},
{
  "_id": {
    "$oid": "09flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09flashcardche3",
},
{
  "_id": {
    "$oid": "09flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09flashcardche4",
},
{
  "_id": {
    "$oid": "09flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09flashcardche5",
},
{
  "_id": {
    "$oid": "09flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09flashcardche6",
},
{
  "_id": {
    "$oid": "10flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10flashcardche1",
},
{
  "_id": {
    "$oid": "10flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10flashcardche2",
},
{
  "_id": {
    "$oid": "10flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10flashcardche3",
},
{
  "_id": {
    "$oid": "10flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10flashcardche4",
},
{
  "_id": {
    "$oid": "10flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10flashcardche5",
},
{
  "_id": {
    "$oid": "10flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10flashcardche6",
},
{
  "_id": {
    "$oid": "11flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11flashcardche1",
},
{
  "_id": {
    "$oid": "11flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11flashcardche2",
},
{
  "_id": {
    "$oid": "11flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11flashcardche3",
},
{
  "_id": {
    "$oid": "11flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11flashcardche4",
},
{
  "_id": {
    "$oid": "11flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11flashcardche5",
},
{
  "_id": {
    "$oid": "11flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11flashcardche6",
},
{
  "_id": {
    "$oid": "11flashcardche7"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11flashcardche7",
},
{
  "_id": {
    "$oid": "12flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12flashcardche1",
},
{
  "_id": {
    "$oid": "12flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12flashcardche2",
},
{
  "_id": {
    "$oid": "12flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12flashcardche3",
},
{
  "_id": {
    "$oid": "12flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12flashcardche4",
},
{
  "_id": {
    "$oid": "12flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12flashcardche5",
},
{
  "_id": {
    "$oid": "12flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12flashcardche6",
},
{
  "_id": {
    "$oid": "13flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13flashcardche1",
},
{
  "_id": {
    "$oid": "13flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13flashcardche2",
},
{
  "_id": {
    "$oid": "13flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13flashcardche3",
},
{
  "_id": {
    "$oid": "13flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13flashcardche4",
},
{
  "_id": {
    "$oid": "13flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13flashcardche5",
},
{
  "_id": {
    "$oid": "13flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13flashcardche6",
},
{
  "_id": {
    "$oid": "14flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14flashcardche1",
},
{
  "_id": {
    "$oid": "14flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14flashcardche2",
},
{
  "_id": {
    "$oid": "14flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14flashcardche3",
},
{
  "_id": {
    "$oid": "14flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14flashcardche4",
},
{
  "_id": {
    "$oid": "15flashcardche1"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15flashcardche1",
},
{
  "_id": {
    "$oid": "15flashcardche2"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15flashcardche2",
},
{
  "_id": {
    "$oid": "15flashcardche3"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15flashcardche3",
},
{
  "_id": {
    "$oid": "15flashcardche4"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15flashcardche4",
},
{
  "_id": {
    "$oid": "15flashcardche5"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15flashcardche5",
},
{
  "_id": {
    "$oid": "15flashcardche6"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15flashcardche6",
},
{
  "_id": {
    "$oid": "15flashcardche7"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15flashcardche7",
},
{
  "_id": {
    "$oid": "15flashcardche8"
  },
  "type": "flashcard",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15flashcardche8",
},
{
  "_id": {
    "$oid": "01flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio1",
},
{
  "_id": {
    "$oid": "01flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio2",
},
{
  "_id": {
    "$oid": "01flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio3",
},
{
  "_id": {
    "$oid": "01flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio4",
},
{
  "_id": {
    "$oid": "01flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio5",
},
{
  "_id": {
    "$oid": "01flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio6",
},
{
  "_id": {
    "$oid": "01flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio7",
},
{
  "_id": {
    "$oid": "01flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio8",
},
{
  "_id": {
    "$oid": "01flashcardbio9"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio9",
},
{
  "_id": {
    "$oid": "01flashcardbio10"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio10",
},
{
  "_id": {
    "$oid": "01flashcardbio11"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio11",
},
{
  "_id": {
    "$oid": "01flashcardbio12"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio12",
},
{
  "_id": {
    "$oid": "01flashcardbio13"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01flashcardbio13",
},
{
  "_id": {
    "$oid": "02flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02flashcardbio1",
},
{
  "_id": {
    "$oid": "02flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02flashcardbio2",
},
{
  "_id": {
    "$oid": "02flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02flashcardbio3",
},
{
  "_id": {
    "$oid": "03flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03flashcardbio1",
},
{
  "_id": {
    "$oid": "03flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03flashcardbio2",
},
{
  "_id": {
    "$oid": "03flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03flashcardbio3",
},
{
  "_id": {
    "$oid": "03flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03flashcardbio4",
},
{
  "_id": {
    "$oid": "03flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03flashcardbio5",
},
{
  "_id": {
    "$oid": "03flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03flashcardbio6",
},
{
  "_id": {
    "$oid": "03flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03flashcardbio7",
},
{
  "_id": {
    "$oid": "03flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03flashcardbio8",
},
{
  "_id": {
    "$oid": "04flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04flashcardbio1",
},
{
  "_id": {
    "$oid": "04flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04flashcardbio2",
},
{
  "_id": {
    "$oid": "04flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04flashcardbio3",
},
{
  "_id": {
    "$oid": "04flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04flashcardbio4",
},
{
  "_id": {
    "$oid": "05flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio1",
},
{
  "_id": {
    "$oid": "05flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio2",
},
{
  "_id": {
    "$oid": "05flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio3",
},
{
  "_id": {
    "$oid": "05flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio4",
},
{
  "_id": {
    "$oid": "05flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio5",
},
{
  "_id": {
    "$oid": "05flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio6",
},
{
  "_id": {
    "$oid": "05flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio7",
},
{
  "_id": {
    "$oid": "05flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio8",
},
{
  "_id": {
    "$oid": "05flashcardbio9"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio9",
},
{
  "_id": {
    "$oid": "05flashcardbio10"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05flashcardbio10",
},
{
  "_id": {
    "$oid": "06flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06flashcardbio1",
},
{
  "_id": {
    "$oid": "06flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06flashcardbio2",
},
{
  "_id": {
    "$oid": "06flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06flashcardbio3",
},
{
  "_id": {
    "$oid": "06flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06flashcardbio4",
},
{
  "_id": {
    "$oid": "06flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06flashcardbio5",
},
{
  "_id": {
    "$oid": "06flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06flashcardbio6",
},
{
  "_id": {
    "$oid": "07flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio1",
},
{
  "_id": {
    "$oid": "07flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio2",
},
{
  "_id": {
    "$oid": "07flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio3",
},
{
  "_id": {
    "$oid": "07flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio4",
},
{
  "_id": {
    "$oid": "07flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio5",
},
{
  "_id": {
    "$oid": "07flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio6",
},
{
  "_id": {
    "$oid": "07flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio7",
},
{
  "_id": {
    "$oid": "07flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio8",
},
{
  "_id": {
    "$oid": "07flashcardbio9"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio9",
},
{
  "_id": {
    "$oid": "07flashcardbio10"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07flashcardbio10",
},
{
  "_id": {
    "$oid": "08flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08flashcardbio1",
},
{
  "_id": {
    "$oid": "08flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08flashcardbio2",
},
{
  "_id": {
    "$oid": "08flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08flashcardbio3",
},
{
  "_id": {
    "$oid": "08flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08flashcardbio4",
},
{
  "_id": {
    "$oid": "08flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08flashcardbio5",
},
{
  "_id": {
    "$oid": "08flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08flashcardbio6",
},
{
  "_id": {
    "$oid": "08flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08flashcardbio7",
},
{
  "_id": {
    "$oid": "08flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08flashcardbio8",
},
{
  "_id": {
    "$oid": "09flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09flashcardbio1",
},
{
  "_id": {
    "$oid": "09flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09flashcardbio2",
},
{
  "_id": {
    "$oid": "09flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09flashcardbio3",
},
{
  "_id": {
    "$oid": "09flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09flashcardbio4",
},
{
  "_id": {
    "$oid": "09flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09flashcardbio5",
},
{
  "_id": {
    "$oid": "09flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09flashcardbio6",
},
{
  "_id": {
    "$oid": "09flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09flashcardbio7",
},
{
  "_id": {
    "$oid": "09flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09flashcardbio8",
},
{
  "_id": {
    "$oid": "09flashcardbio9"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09flashcardbio9",
},
{
  "_id": {
    "$oid": "10flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10flashcardbio1",
},
{
  "_id": {
    "$oid": "10flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10flashcardbio2",
},
{
  "_id": {
    "$oid": "10flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10flashcardbio3",
},
{
  "_id": {
    "$oid": "10flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10flashcardbio4",
},
{
  "_id": {
    "$oid": "10flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10flashcardbio5",
},
{
  "_id": {
    "$oid": "10flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10flashcardbio6",
},
{
  "_id": {
    "$oid": "10flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10flashcardbio7",
},
{
  "_id": {
    "$oid": "11flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11flashcardbio1",
},
{
  "_id": {
    "$oid": "11flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11flashcardbio2",
},
{
  "_id": {
    "$oid": "11flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11flashcardbio3",
},
{
  "_id": {
    "$oid": "11flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11flashcardbio4",
},
{
  "_id": {
    "$oid": "11flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11flashcardbio5",
},
{
  "_id": {
    "$oid": "11flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11flashcardbio6",
},
{
  "_id": {
    "$oid": "11flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11flashcardbio7",
},
{
  "_id": {
    "$oid": "11flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11flashcardbio8",
},
{
  "_id": {
    "$oid": "12flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12flashcardbio1",
},
{
  "_id": {
    "$oid": "12flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12flashcardbio2",
},
{
  "_id": {
    "$oid": "12flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12flashcardbio3",
},
{
  "_id": {
    "$oid": "12flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12flashcardbio4",
},
{
  "_id": {
    "$oid": "12flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12flashcardbio5",
},
{
  "_id": {
    "$oid": "13flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13flashcardbio1",
},
{
  "_id": {
    "$oid": "13flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13flashcardbio2",
},
{
  "_id": {
    "$oid": "13flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13flashcardbio3",
},
{
  "_id": {
    "$oid": "13flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13flashcardbio4",
},
{
  "_id": {
    "$oid": "13flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13flashcardbio5",
},
{
  "_id": {
    "$oid": "13flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13flashcardbio6",
},
{
  "_id": {
    "$oid": "13flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13flashcardbio7",
},
{
  "_id": {
    "$oid": "14flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14flashcardbio1",
},
{
  "_id": {
    "$oid": "14flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14flashcardbio2",
},
{
  "_id": {
    "$oid": "14flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14flashcardbio3",
},
{
  "_id": {
    "$oid": "14flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14flashcardbio4",
},
{
  "_id": {
    "$oid": "14flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14flashcardbio5",
},
{
  "_id": {
    "$oid": "14flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14flashcardbio6",
},
{
  "_id": {
    "$oid": "14flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14flashcardbio7",
},
{
  "_id": {
    "$oid": "14flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14flashcardbio8",
},
{
  "_id": {
    "$oid": "15flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio1",
},
{
  "_id": {
    "$oid": "15flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio2",
},
{
  "_id": {
    "$oid": "15flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio3",
},
{
  "_id": {
    "$oid": "15flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio4",
},
{
  "_id": {
    "$oid": "15flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio5",
},
{
  "_id": {
    "$oid": "15flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio6",
},
{
  "_id": {
    "$oid": "15flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio7",
},
{
  "_id": {
    "$oid": "15flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio8",
},
{
  "_id": {
    "$oid": "15flashcardbio9"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio9",
},
{
  "_id": {
    "$oid": "15flashcardbio10"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio10",
},
{
  "_id": {
    "$oid": "15flashcardbio11"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15flashcardbio11",
},
{
  "_id": {
    "$oid": "16flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio1",
},
{
  "_id": {
    "$oid": "16flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio2",
},
{
  "_id": {
    "$oid": "16flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio3",
},
{
  "_id": {
    "$oid": "16flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio4",
},
{
  "_id": {
    "$oid": "16flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio5",
},
{
  "_id": {
    "$oid": "16flashcardbio6"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio6",
},
{
  "_id": {
    "$oid": "16flashcardbio7"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio7",
},
{
  "_id": {
    "$oid": "16flashcardbio8"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio8",
},
{
  "_id": {
    "$oid": "16flashcardbio9"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio9",
},
{
  "_id": {
    "$oid": "16flashcardbio10"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16flashcardbio10",
},
{
  "_id": {
    "$oid": "17flashcardbio1"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17flashcardbio1",
},
{
  "_id": {
    "$oid": "17flashcardbio2"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17flashcardbio2",
},
{
  "_id": {
    "$oid": "17flashcardbio3"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17flashcardbio3",
},
{
  "_id": {
    "$oid": "17flashcardbio4"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17flashcardbio4",
},
{
  "_id": {
    "$oid": "17flashcardbio5"
  },
  "type": "flashcard",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17flashcardbio5",
},






{
  "_id": {
    "$oid": "01ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP01",
  "pagename": "01ncertnotephy1",
},
{
  "_id": {
    "$oid": "02ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02ncertnotephy1",
},
{
  "_id": {
    "$oid": "02ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP02",
  "pagename": "02ncertnotephy2",
},
{
  "_id": {
    "$oid": "03ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP03",
  "pagename": "03ncertnotephy1",
},
{
  "_id": {
    "$oid": "04ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP04",
  "pagename": "04ncertnotephy1",
},
{
  "_id": {
    "$oid": "04ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP04",
  "pagename": "04ncertnotephy2",
},
{
  "_id": {
    "$oid": "04ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP04",
  "pagename": "04ncertnotephy3",
},
{
  "_id": {
    "$oid": "05ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05ncertnotephy1",
},
{
  "_id": {
    "$oid": "05ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05ncertnotephy2",
},
{
  "_id": {
    "$oid": "05ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP05",
  "pagename": "05ncertnotephy3",
},
{
  "_id": {
    "$oid": "06ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP06",
  "pagename": "06ncertnotephy1",
},
{
  "_id": {
    "$oid": "07ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07ncertnotephy1",
},
{
  "_id": {
    "$oid": "07ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP07",
  "pagename": "07ncertnotephy2",
},
{
  "_id": {
    "$oid": "08ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08ncertnotephy1",
},
{
  "_id": {
    "$oid": "08ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08ncertnotephy2",
},
{
  "_id": {
    "$oid": "08ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08ncertnotephy3",
},
{
  "_id": {
    "$oid": "08ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP08",
  "pagename": "08ncertnotephy4",
},
{
  "_id": {
    "$oid": "09ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09ncertnotephy1",
},
{
  "_id": {
    "$oid": "09ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09ncertnotephy2",
},
{
  "_id": {
    "$oid": "09ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09ncertnotephy3",
},
{
  "_id": {
    "$oid": "09ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09ncertnotephy4",
},
{
  "_id": {
    "$oid": "09ncertnotephy5"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP09",
  "pagename": "09ncertnotephy5",
},
{
  "_id": {
    "$oid": "10ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10ncertnotephy1",
},
{
  "_id": {
    "$oid": "10ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10ncertnotephy2",
},
{
  "_id": {
    "$oid": "10ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10ncertnotephy3",
},
{
  "_id": {
    "$oid": "10ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10ncertnotephy4",
},
{
  "_id": {
    "$oid": "10ncertnotephy5"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10ncertnotephy5",
},
{
  "_id": {
    "$oid": "10ncertnotephy6"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10ncertnotephy6",
},
{
  "_id": {
    "$oid": "10ncertnotephy7"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10ncertnotephy7",
},
{
  "_id": {
    "$oid": "10ncertnotephy8"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP10",
  "pagename": "10ncertnotephy8",
},
{
  "_id": {
    "$oid": "11ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11ncertnotephy1",
},
{
  "_id": {
    "$oid": "11ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11ncertnotephy2",
},
{
  "_id": {
    "$oid": "11ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP11",
  "pagename": "11ncertnotephy3",
},
{
  "_id": {
    "$oid": "12ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12ncertnotephy1",
},
{
  "_id": {
    "$oid": "12ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12ncertnotephy2",
},
{
  "_id": {
    "$oid": "12ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP12",
  "pagename": "12ncertnotephy3",
},
{
  "_id": {
    "$oid": "13ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13ncertnotephy1",
},
{
  "_id": {
    "$oid": "13ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13ncertnotephy2",
},
{
  "_id": {
    "$oid": "13ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13ncertnotephy3",
},
{
  "_id": {
    "$oid": "13ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13ncertnotephy4",
},
{
  "_id": {
    "$oid": "13ncertnotephy5"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13ncertnotephy5",
},
{
  "_id": {
    "$oid": "13ncertnotephy6"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13ncertnotephy6",
},
{
  "_id": {
    "$oid": "13ncertnotephy7"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP13",
  "pagename": "13ncertnotephy7",
},
{
  "_id": {
    "$oid": "14ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14ncertnotephy1",
},
{
  "_id": {
    "$oid": "14ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14ncertnotephy2",
},
{
  "_id": {
    "$oid": "14ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14ncertnotephy3",
},
{
  "_id": {
    "$oid": "14ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14ncertnotephy4",
},
{
  "_id": {
    "$oid": "14ncertnotephy5"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14ncertnotephy5",
},
{
  "_id": {
    "$oid": "14ncertnotephy6"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14ncertnotephy6",
},
{
  "_id": {
    "$oid": "14ncertnotephy7"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP14",
  "pagename": "14ncertnotephy7",
},
{
  "_id": {
    "$oid": "15ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15ncertnotephy1",
},
{
  "_id": {
    "$oid": "15ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15ncertnotephy2",
},
{
  "_id": {
    "$oid": "15ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15ncertnotephy3",
},
{
  "_id": {
    "$oid": "15ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15ncertnotephy4",
},
{
  "_id": {
    "$oid": "15ncertnotephy5"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP15",
  "pagename": "15ncertnotephy5",
},
{
  "_id": {
    "$oid": "16ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16ncertnotephy1",
},
{
  "_id": {
    "$oid": "16ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16ncertnotephy2",
},
{
  "_id": {
    "$oid": "16ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP16",
  "pagename": "16ncertnotephy3",
},
{
  "_id": {
    "$oid": "17ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17ncertnotephy1",
},
{
  "_id": {
    "$oid": "17ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17ncertnotephy2",
},
{
  "_id": {
    "$oid": "17ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP17",
  "pagename": "17ncertnotephy3",
},
{
  "_id": {
    "$oid": "18ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18ncertnotephy1",
},
{
  "_id": {
    "$oid": "18ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18ncertnotephy2",
},
{
  "_id": {
    "$oid": "18ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP18",
  "pagename": "18ncertnotephy3",
},
{
  "_id": {
    "$oid": "19ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19ncertnotephy1",
},
{
  "_id": {
    "$oid": "19ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19ncertnotephy2",
},
{
  "_id": {
    "$oid": "19ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19ncertnotephy3",
},
{
  "_id": {
    "$oid": "19ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19ncertnotephy4",
},
{
  "_id": {
    "$oid": "19ncertnotephy5"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19ncertnotephy5",
},
{
  "_id": {
    "$oid": "19ncertnotephy6"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19ncertnotephy6",
},
{
  "_id": {
    "$oid": "19ncertnotephy7"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19ncertnotephy7",
},
{
  "_id": {
    "$oid": "19ncertnotephy8"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP19",
  "pagename": "19ncertnotephy8",
},
{
  "_id": {
    "$oid": "20ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20ncertnotephy1",
},
{
  "_id": {
    "$oid": "20ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20ncertnotephy2",
},
{
  "_id": {
    "$oid": "20ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20ncertnotephy3",
},
{
  "_id": {
    "$oid": "20ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP20",
  "pagename": "20ncertnotephy4",
},
{
  "_id": {
    "$oid": "21ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21ncertnotephy1",
},
{
  "_id": {
    "$oid": "21ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21ncertnotephy2",
},
{
  "_id": {
    "$oid": "21ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21ncertnotephy3",
},
{
  "_id": {
    "$oid": "21ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP21",
  "pagename": "21ncertnotephy4",
},
{
  "_id": {
    "$oid": "22ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP22",
  "pagename": "22ncertnotephy1",
},
{
  "_id": {
    "$oid": "22ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP22",
  "pagename": "22ncertnotephy2",
},
{
  "_id": {
    "$oid": "22ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP22",
  "pagename": "22ncertnotephy3",
},
{
  "_id": {
    "$oid": "23ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23ncertnotephy1",
},
{
  "_id": {
    "$oid": "23ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23ncertnotephy2",
},
{
  "_id": {
    "$oid": "23ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP23",
  "pagename": "23ncertnotephy3",
},
{
  "_id": {
    "$oid": "24ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP24",
  "pagename": "24ncertnotephy1",
},
{
  "_id": {
    "$oid": "24ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP24",
  "pagename": "24ncertnotephy2",
},
{
  "_id": {
    "$oid": "24ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP24",
  "pagename": "24ncertnotephy3",
},
{
  "_id": {
    "$oid": "25ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP25",
  "pagename": "25ncertnotephy1",
},
{
  "_id": {
    "$oid": "25ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP25",
  "pagename": "25ncertnotephy2",
},
{
  "_id": {
    "$oid": "26ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP26",
  "pagename": "26ncertnotephy1",
},
{
  "_id": {
    "$oid": "26ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP26",
  "pagename": "26ncertnotephy2",
},
{
  "_id": {
    "$oid": "27ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP27",
  "pagename": "27ncertnotephy1",
},
{
  "_id": {
    "$oid": "27ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP27",
  "pagename": "27ncertnotephy2",
},
{
  "_id": {
    "$oid": "28ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP28",
  "pagename": "28ncertnotephy1",
},
{
  "_id": {
    "$oid": "28ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP28",
  "pagename": "28ncertnotephy2",
},
{
  "_id": {
    "$oid": "29ncertnotephy1"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP29",
  "pagename": "29ncertnotephy1",
},
{
  "_id": {
    "$oid": "29ncertnotephy2"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP29",
  "pagename": "29ncertnotephy2",
},
{
  "_id": {
    "$oid": "29ncertnotephy3"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP29",
  "pagename": "29ncertnotephy3",
},
{
  "_id": {
    "$oid": "29ncertnotephy4"
  },
  "type": "ncertshortnote",
  "subject": "physics",
  "topic": "CP29",
  "pagename": "29ncertnotephy4",
},
{
  "_id": {
    "$oid": "01ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01ncertnoteche1",
},
{
  "_id": {
    "$oid": "01ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC01",
  "pagename": "01ncertnoteche2",
},
{
  "_id": {
    "$oid": "02ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02ncertnoteche1",
},
{
  "_id": {
    "$oid": "02ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02ncertnoteche2",
},
{
  "_id": {
    "$oid": "02ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02ncertnoteche3",
},
{
  "_id": {
    "$oid": "02ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02ncertnoteche4",
},
{
  "_id": {
    "$oid": "02ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC02",
  "pagename": "02ncertnoteche5",
},
{
  "_id": {
    "$oid": "03ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03ncertnoteche1",
},
{
  "_id": {
    "$oid": "03ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03ncertnoteche2",
},
{
  "_id": {
    "$oid": "03ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC03",
  "pagename": "03ncertnoteche3",
},
{
  "_id": {
    "$oid": "04ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04ncertnoteche1",
},
{
  "_id": {
    "$oid": "04ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04ncertnoteche2",
},
{
  "_id": {
    "$oid": "04ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04ncertnoteche3",
},
{
  "_id": {
    "$oid": "04ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04ncertnoteche4",
},
{
  "_id": {
    "$oid": "04ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC04",
  "pagename": "04ncertnoteche5",
},
{
  "_id": {
    "$oid": "05ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05ncertnoteche1",
},
{
  "_id": {
    "$oid": "05ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05ncertnoteche2",
},
{
  "_id": {
    "$oid": "05ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC05",
  "pagename": "05ncertnoteche3",
},
{
  "_id": {
    "$oid": "06ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06ncertnoteche1",
},
{
  "_id": {
    "$oid": "06ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06ncertnoteche2",
},
{
  "_id": {
    "$oid": "06ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06ncertnoteche3",
},
{
  "_id": {
    "$oid": "06ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC06",
  "pagename": "06ncertnoteche4",
},
{
  "_id": {
    "$oid": "07ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07ncertnoteche1",
},
{
  "_id": {
    "$oid": "07ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07ncertnoteche2",
},
{
  "_id": {
    "$oid": "07ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07ncertnoteche3",
},
{
  "_id": {
    "$oid": "07ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC07",
  "pagename": "07ncertnoteche4",
},
{
  "_id": {
    "$oid": "08ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08ncertnoteche1",
},
{
  "_id": {
    "$oid": "08ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08ncertnoteche2",
},
{
  "_id": {
    "$oid": "08ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08ncertnoteche3",
},
{
  "_id": {
    "$oid": "08ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08ncertnoteche4",
},
{
  "_id": {
    "$oid": "08ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC08",
  "pagename": "08ncertnoteche5",
},
{
  "_id": {
    "$oid": "09ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09ncertnoteche1",
},
{
  "_id": {
    "$oid": "09ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09ncertnoteche2",
},
{
  "_id": {
    "$oid": "09ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC09",
  "pagename": "09ncertnoteche3",
},
{
  "_id": {
    "$oid": "10ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10ncertnoteche1",
},
{
  "_id": {
    "$oid": "10ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10ncertnoteche2",
},
{
  "_id": {
    "$oid": "10ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10ncertnoteche3",
},
{
  "_id": {
    "$oid": "10ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC10",
  "pagename": "10ncertnoteche4",
},
{
  "_id": {
    "$oid": "11ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche1",
},
{
  "_id": {
    "$oid": "11ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche2",
},
{
  "_id": {
    "$oid": "11ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche3",
},
{
  "_id": {
    "$oid": "11ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche4",
},
{
  "_id": {
    "$oid": "11ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche5",
},
{
  "_id": {
    "$oid": "11ncertnoteche6"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche6",
},
{
  "_id": {
    "$oid": "11ncertnoteche7"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche7",
},
{
  "_id": {
    "$oid": "11ncertnoteche8"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche8",
},
{
  "_id": {
    "$oid": "11ncertnoteche9"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche9",
},
{
  "_id": {
    "$oid": "11ncertnoteche10"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche10",
},
{
  "_id": {
    "$oid": "11ncertnoteche11"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC11",
  "pagename": "11ncertnoteche11",
},
{
  "_id": {
    "$oid": "12ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12ncertnoteche1",
},
{
  "_id": {
    "$oid": "12ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12ncertnoteche2",
},
{
  "_id": {
    "$oid": "12ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12ncertnoteche3",
},
{
  "_id": {
    "$oid": "12ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12ncertnoteche4",
},
{
  "_id": {
    "$oid": "12ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12ncertnoteche5",
},
{
  "_id": {
    "$oid": "12ncertnoteche6"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12ncertnoteche6",
},
{
  "_id": {
    "$oid": "12ncertnoteche7"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12ncertnoteche7",
},
{
  "_id": {
    "$oid": "12ncertnoteche8"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC12",
  "pagename": "12ncertnoteche8",
},
{
  "_id": {
    "$oid": "13ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche1",
},
{
  "_id": {
    "$oid": "13ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche2",
},
{
  "_id": {
    "$oid": "13ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche3",
},
{
  "_id": {
    "$oid": "13ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche4",
},
{
  "_id": {
    "$oid": "13ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche5",
},
{
  "_id": {
    "$oid": "13ncertnoteche6"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche6",
},
{
  "_id": {
    "$oid": "13ncertnoteche7"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche7",
},
{
  "_id": {
    "$oid": "13ncertnoteche8"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche8",
},
{
  "_id": {
    "$oid": "13ncertnoteche9"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche9",
},
{
  "_id": {
    "$oid": "13ncertnoteche10"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche10",
},
{
  "_id": {
    "$oid": "13ncertnoteche11"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche11",
},
{
  "_id": {
    "$oid": "13ncertnoteche12"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche12",
},
{
  "_id": {
    "$oid": "13ncertnoteche13"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC13",
  "pagename": "13ncertnoteche13",
},
{
  "_id": {
    "$oid": "14ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14ncertnoteche1",
},
{
  "_id": {
    "$oid": "14ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14ncertnoteche2",
},
{
  "_id": {
    "$oid": "14ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14ncertnoteche3",
},
{
  "_id": {
    "$oid": "14ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14ncertnoteche4",
},
{
  "_id": {
    "$oid": "14ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14ncertnoteche5",
},
{
  "_id": {
    "$oid": "14ncertnoteche6"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14ncertnoteche6",
},
{
  "_id": {
    "$oid": "14ncertnoteche7"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC14",
  "pagename": "14ncertnoteche7",
},
{
  "_id": {
    "$oid": "15ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15ncertnoteche1",
},
{
  "_id": {
    "$oid": "15ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15ncertnoteche2",
},
{
  "_id": {
    "$oid": "15ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15ncertnoteche3",
},
{
  "_id": {
    "$oid": "15ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15ncertnoteche4",
},
{
  "_id": {
    "$oid": "15ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC15",
  "pagename": "15ncertnoteche5",
},
{
  "_id": {
    "$oid": "16ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche1",
},
{
  "_id": {
    "$oid": "16ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche2",
},
{
  "_id": {
    "$oid": "16ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche3",
},
{
  "_id": {
    "$oid": "16ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche4",
},
{
  "_id": {
    "$oid": "16ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche5",
},
{
  "_id": {
    "$oid": "16ncertnoteche6"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche6",
},
{
  "_id": {
    "$oid": "16ncertnoteche7"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche7",
},
{
  "_id": {
    "$oid": "16ncertnoteche8"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche8",
},
{
  "_id": {
    "$oid": "16ncertnoteche9"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche9",
},
{
  "_id": {
    "$oid": "16ncertnoteche10"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche10",
},
{
  "_id": {
    "$oid": "16ncertnoteche11"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche11",
},
{
  "_id": {
    "$oid": "16ncertnoteche12"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche12",
},
{
  "_id": {
    "$oid": "16ncertnoteche13"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche13",
},
{
  "_id": {
    "$oid": "16ncertnoteche14"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche14",
},
{
  "_id": {
    "$oid": "16ncertnoteche15"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche15",
},
{
  "_id": {
    "$oid": "16ncertnoteche16"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche16",
},
{
  "_id": {
    "$oid": "16ncertnoteche17"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche17",
},
{
  "_id": {
    "$oid": "16ncertnoteche18"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche18",
},
{
  "_id": {
    "$oid": "16ncertnoteche19"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC16",
  "pagename": "16ncertnoteche19",
},
{
  "_id": {
    "$oid": "17ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17ncertnoteche1",
},
{
  "_id": {
    "$oid": "17ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17ncertnoteche2",
},
{
  "_id": {
    "$oid": "17ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17ncertnoteche3",
},
{
  "_id": {
    "$oid": "17ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17ncertnoteche4",
},
{
  "_id": {
    "$oid": "17ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17ncertnoteche5",
},
{
  "_id": {
    "$oid": "17ncertnoteche6"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17ncertnoteche6",
},
{
  "_id": {
    "$oid": "17ncertnoteche7"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC17",
  "pagename": "17ncertnoteche7",
},
{
  "_id": {
    "$oid": "18ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18ncertnoteche1",
},
{
  "_id": {
    "$oid": "18ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18ncertnoteche2",
},
{
  "_id": {
    "$oid": "18ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18ncertnoteche3",
},
{
  "_id": {
    "$oid": "18ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18ncertnoteche4",
},
{
  "_id": {
    "$oid": "18ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18ncertnoteche5",
},
{
  "_id": {
    "$oid": "18ncertnoteche6"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18ncertnoteche6",
},
{
  "_id": {
    "$oid": "18ncertnoteche7"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18ncertnoteche7",
},
{
  "_id": {
    "$oid": "18ncertnoteche8"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC18",
  "pagename": "18ncertnoteche8",
},
{
  "_id": {
    "$oid": "19ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC19",
  "pagename": "19ncertnoteche1",
},
{
  "_id": {
    "$oid": "19ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC19",
  "pagename": "19ncertnoteche2",
},
{
  "_id": {
    "$oid": "19ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC19",
  "pagename": "19ncertnoteche3",
},
{
  "_id": {
    "$oid": "19ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC19",
  "pagename": "19ncertnoteche4",
},
{
  "_id": {
    "$oid": "19ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC19",
  "pagename": "19ncertnoteche5",
},
{
  "_id": {
    "$oid": "20ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20ncertnoteche1",
},
{
  "_id": {
    "$oid": "20ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20ncertnoteche2",
},
{
  "_id": {
    "$oid": "20ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20ncertnoteche3",
},
{
  "_id": {
    "$oid": "20ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20ncertnoteche4",
},
{
  "_id": {
    "$oid": "20ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC20",
  "pagename": "20ncertnoteche5",
},
{
  "_id": {
    "$oid": "21ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21ncertnoteche1",
},
{
  "_id": {
    "$oid": "21ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21ncertnoteche2",
},
{
  "_id": {
    "$oid": "21ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21ncertnoteche3",
},
{
  "_id": {
    "$oid": "21ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21ncertnoteche4",
},
{
  "_id": {
    "$oid": "21ncertnoteche5"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21ncertnoteche5",
},
{
  "_id": {
    "$oid": "21ncertnoteche6"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21ncertnoteche6",
},
{
  "_id": {
    "$oid": "21ncertnoteche7"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21ncertnoteche7",
},
{
  "_id": {
    "$oid": "21ncertnoteche8"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC21",
  "pagename": "21ncertnoteche8",
},
{
  "_id": {
    "$oid": "22ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC22",
  "pagename": "22ncertnoteche1",
},
{
  "_id": {
    "$oid": "23ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23ncertnoteche1",
},
{
  "_id": {
    "$oid": "23ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC23",
  "pagename": "23ncertnoteche2",
},
{
  "_id": {
    "$oid": "24ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC24",
  "pagename": "24ncertnoteche1",
},
{
  "_id": {
    "$oid": "25ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC25",
  "pagename": "25ncertnoteche1",
},
{
  "_id": {
    "$oid": "25ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC25",
  "pagename": "25ncertnoteche2",
},
{
  "_id": {
    "$oid": "25ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC25",
  "pagename": "25ncertnoteche3",
},
{
  "_id": {
    "$oid": "26ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC26",
  "pagename": "26ncertnoteche1",
},
{
  "_id": {
    "$oid": "26ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC26",
  "pagename": "26ncertnoteche2",
},
{
  "_id": {
    "$oid": "27ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27ncertnoteche1",
},
{
  "_id": {
    "$oid": "27ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27ncertnoteche2",
},
{
  "_id": {
    "$oid": "27ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC27",
  "pagename": "27ncertnoteche3",
},
{
  "_id": {
    "$oid": "28ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC28",
  "pagename": "28ncertnoteche1",
},
{
  "_id": {
    "$oid": "28ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC28",
  "pagename": "28ncertnoteche2",
},
{
  "_id": {
    "$oid": "28ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC28",
  "pagename": "28ncertnoteche3",
},
{
  "_id": {
    "$oid": "29ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC29",
  "pagename": "29ncertnoteche1",
},
{
  "_id": {
    "$oid": "29ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC29",
  "pagename": "29ncertnoteche2",
},
{
  "_id": {
    "$oid": "29ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC29",
  "pagename": "29ncertnoteche3",
},
{
  "_id": {
    "$oid": "29ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC29",
  "pagename": "29ncertnoteche4",
},
{
  "_id": {
    "$oid": "30ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC30",
  "pagename": "30ncertnoteche1",
},
{
  "_id": {
    "$oid": "30ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC30",
  "pagename": "30ncertnoteche2",
},
{
  "_id": {
    "$oid": "30ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC30",
  "pagename": "30ncertnoteche3",
},
{
  "_id": {
    "$oid": "31ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC31",
  "pagename": "31ncertnoteche1",
},
{
  "_id": {
    "$oid": "31ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC31",
  "pagename": "31ncertnoteche2",
},
{
  "_id": {
    "$oid": "31ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC31",
  "pagename": "31ncertnoteche3",
},
{
  "_id": {
    "$oid": "31ncertnoteche4"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC31",
  "pagename": "31ncertnoteche4",
},
{
  "_id": {
    "$oid": "32ncertnoteche1"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC32",
  "pagename": "32ncertnoteche1",
},
{
  "_id": {
    "$oid": "32ncertnoteche2"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC32",
  "pagename": "32ncertnoteche2",
},
{
  "_id": {
    "$oid": "32ncertnoteche3"
  },
  "type": "ncertshortnote",
  "subject": "chemistry",
  "topic": "CC32",
  "pagename": "32ncertnoteche3",
},
{
  "_id": {
    "$oid": "01ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01ncertnotebio1",
},
{
  "_id": {
    "$oid": "01ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01ncertnotebio2",
},
{
  "_id": {
    "$oid": "01ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01ncertnotebio3",
},
{
  "_id": {
    "$oid": "01ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01ncertnotebio4",
},
{
  "_id": {
    "$oid": "01ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01ncertnotebio5",
},
{
  "_id": {
    "$oid": "01ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB01",
  "pagename": "01ncertnotebio6",
},
{
  "_id": {
    "$oid": "02ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02ncertnotebio1",
},
{
  "_id": {
    "$oid": "02ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02ncertnotebio2",
},
{
  "_id": {
    "$oid": "02ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02ncertnotebio3",
},
{
  "_id": {
    "$oid": "02ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02ncertnotebio4",
},
{
  "_id": {
    "$oid": "02ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02ncertnotebio5",
},
{
  "_id": {
    "$oid": "02ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB02",
  "pagename": "02ncertnotebio6",
},
{
  "_id": {
    "$oid": "03ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03ncertnotebio1",
},
{
  "_id": {
    "$oid": "03ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03ncertnotebio2",
},
{
  "_id": {
    "$oid": "03ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB03",
  "pagename": "03ncertnotebio3",
},
{
  "_id": {
    "$oid": "04ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04ncertnotebio1",
},
{
  "_id": {
    "$oid": "04ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04ncertnotebio2",
},
{
  "_id": {
    "$oid": "04ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04ncertnotebio3",
},
{
  "_id": {
    "$oid": "04ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04ncertnotebio4",
},
{
  "_id": {
    "$oid": "04ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB04",
  "pagename": "04ncertnotebio5",
},
{
  "_id": {
    "$oid": "05ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05ncertnotebio1",
},
{
  "_id": {
    "$oid": "05ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05ncertnotebio2",
},
{
  "_id": {
    "$oid": "05ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05ncertnotebio3",
},
{
  "_id": {
    "$oid": "05ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB05",
  "pagename": "05ncertnotebio4",
},
{
  "_id": {
    "$oid": "06ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06ncertnotebio1",
},
{
  "_id": {
    "$oid": "06ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06ncertnotebio2",
},
{
  "_id": {
    "$oid": "06ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB06",
  "pagename": "06ncertnotebio3",
},
{
  "_id": {
    "$oid": "07ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07ncertnotebio1",
},
{
  "_id": {
    "$oid": "07ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07ncertnotebio2",
},
{
  "_id": {
    "$oid": "07ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB07",
  "pagename": "07ncertnotebio3",
},
{
  "_id": {
    "$oid": "08ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08ncertnotebio1",
},
{
  "_id": {
    "$oid": "08ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08ncertnotebio2",
},
{
  "_id": {
    "$oid": "08ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08ncertnotebio3",
},
{
  "_id": {
    "$oid": "08ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08ncertnotebio4",
},
{
  "_id": {
    "$oid": "08ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08ncertnotebio5",
},
{
  "_id": {
    "$oid": "08ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08ncertnotebio6",
},
{
  "_id": {
    "$oid": "08ncertnotebio7"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB08",
  "pagename": "08ncertnotebio7",
},
{
  "_id": {
    "$oid": "09ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09ncertnotebio1",
},
{
  "_id": {
    "$oid": "09ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09ncertnotebio2",
},
{
  "_id": {
    "$oid": "09ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09ncertnotebio3",
},
{
  "_id": {
    "$oid": "09ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB09",
  "pagename": "09ncertnotebio4",
},
{
  "_id": {
    "$oid": "10ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10ncertnotebio1",
},
{
  "_id": {
    "$oid": "10ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10ncertnotebio2",
},
{
  "_id": {
    "$oid": "10ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10ncertnotebio3",
},
{
  "_id": {
    "$oid": "10ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10ncertnotebio4",
},
{
  "_id": {
    "$oid": "10ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10ncertnotebio5",
},
{
  "_id": {
    "$oid": "10ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB10",
  "pagename": "10ncertnotebio6",
},
{
  "_id": {
    "$oid": "11ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11ncertnotebio1",
},
{
  "_id": {
    "$oid": "11ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11ncertnotebio2",
},
{
  "_id": {
    "$oid": "11ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11ncertnotebio3",
},
{
  "_id": {
    "$oid": "11ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11ncertnotebio4",
},
{
  "_id": {
    "$oid": "11ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11ncertnotebio5",
},
{
  "_id": {
    "$oid": "11ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11ncertnotebio6",
},
{
  "_id": {
    "$oid": "11ncertnotebio7"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11ncertnotebio7",
},
{
  "_id": {
    "$oid": "11ncertnotebio8"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB11",
  "pagename": "11ncertnotebio8",
},
{
  "_id": {
    "$oid": "12ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12ncertnotebio1",
},
{
  "_id": {
    "$oid": "12ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12ncertnotebio2",
},
{
  "_id": {
    "$oid": "12ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12ncertnotebio3",
},
{
  "_id": {
    "$oid": "12ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12ncertnotebio4",
},
{
  "_id": {
    "$oid": "12ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12ncertnotebio5",
},
{
  "_id": {
    "$oid": "12ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB12",
  "pagename": "12ncertnotebio6",
},
{
  "_id": {
    "$oid": "13ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13ncertnotebio1",
},
{
  "_id": {
    "$oid": "13ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13ncertnotebio2",
},
{
  "_id": {
    "$oid": "13ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13ncertnotebio3",
},
{
  "_id": {
    "$oid": "13ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13ncertnotebio4",
},
{
  "_id": {
    "$oid": "13ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13ncertnotebio5",
},
{
  "_id": {
    "$oid": "13ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB13",
  "pagename": "13ncertnotebio6",
},
{
  "_id": {
    "$oid": "14ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14ncertnotebio1",
},
{
  "_id": {
    "$oid": "14ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14ncertnotebio2",
},
{
  "_id": {
    "$oid": "14ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14ncertnotebio3",
},
{
  "_id": {
    "$oid": "14ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14ncertnotebio4",
},
{
  "_id": {
    "$oid": "14ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14ncertnotebio5",
},
{
  "_id": {
    "$oid": "14ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14ncertnotebio6",
},
{
  "_id": {
    "$oid": "14ncertnotebio7"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14ncertnotebio7",
},
{
  "_id": {
    "$oid": "14ncertnotebio8"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14ncertnotebio8",
},
{
  "_id": {
    "$oid": "14ncertnotebio9"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB14",
  "pagename": "14ncertnotebio9",
},
{
  "_id": {
    "$oid": "15ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15ncertnotebio1",
},
{
  "_id": {
    "$oid": "15ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15ncertnotebio2",
},
{
  "_id": {
    "$oid": "15ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15ncertnotebio3",
},
{
  "_id": {
    "$oid": "15ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15ncertnotebio4",
},
{
  "_id": {
    "$oid": "15ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15ncertnotebio5",
},
{
  "_id": {
    "$oid": "15ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB15",
  "pagename": "15ncertnotebio6",
},
{
  "_id": {
    "$oid": "16ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16ncertnotebio1",
},
{
  "_id": {
    "$oid": "16ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16ncertnotebio2",
},
{
  "_id": {
    "$oid": "16ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16ncertnotebio3",
},
{
  "_id": {
    "$oid": "16ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB16",
  "pagename": "16ncertnotebio4",
},
{
  "_id": {
    "$oid": "17ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17ncertnotebio1",
},
{
  "_id": {
    "$oid": "17ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17ncertnotebio2",
},
{
  "_id": {
    "$oid": "17ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17ncertnotebio3",
},
{
  "_id": {
    "$oid": "17ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB17",
  "pagename": "17ncertnotebio4",
},
{
  "_id": {
    "$oid": "18ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18ncertnotebio1",
},
{
  "_id": {
    "$oid": "18ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18ncertnotebio2",
},
{
  "_id": {
    "$oid": "18ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18ncertnotebio3",
},
{
  "_id": {
    "$oid": "18ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18ncertnotebio4",
},
{
  "_id": {
    "$oid": "18ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18ncertnotebio5",
},
{
  "_id": {
    "$oid": "18ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB18",
  "pagename": "18ncertnotebio6",
},
{
  "_id": {
    "$oid": "19ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB19",
  "pagename": "19ncertnotebio1",
},
{
  "_id": {
    "$oid": "19ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB19",
  "pagename": "19ncertnotebio2",
},
{
  "_id": {
    "$oid": "19ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB19",
  "pagename": "19ncertnotebio3",
},
{
  "_id": {
    "$oid": "19ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB19",
  "pagename": "19ncertnotebio4",
},
{
  "_id": {
    "$oid": "20ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB20",
  "pagename": "20ncertnotebio1",
},
{
  "_id": {
    "$oid": "20ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB20",
  "pagename": "20ncertnotebio2",
},
{
  "_id": {
    "$oid": "20ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB20",
  "pagename": "20ncertnotebio3",
},
{
  "_id": {
    "$oid": "20ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB20",
  "pagename": "20ncertnotebio4",
},
{
  "_id": {
    "$oid": "20ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB20",
  "pagename": "20ncertnotebio5",
},
{
  "_id": {
    "$oid": "21ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB21",
  "pagename": "21ncertnotebio1",
},
{
  "_id": {
    "$oid": "21ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB21",
  "pagename": "21ncertnotebio2",
},
{
  "_id": {
    "$oid": "21ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB21",
  "pagename": "21ncertnotebio3",
},
{
  "_id": {
    "$oid": "21ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB21",
  "pagename": "21ncertnotebio4",
},
{
  "_id": {
    "$oid": "22ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB22",
  "pagename": "22ncertnotebio1",
},
{
  "_id": {
    "$oid": "22ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB22",
  "pagename": "22ncertnotebio2",
},
{
  "_id": {
    "$oid": "22ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB22",
  "pagename": "22ncertnotebio3",
},
{
  "_id": {
    "$oid": "22ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB22",
  "pagename": "22ncertnotebio4",
},
{
  "_id": {
    "$oid": "22ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB22",
  "pagename": "22ncertnotebio5",
},
{
  "_id": {
    "$oid": "23ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB23",
  "pagename": "23ncertnotebio1",
},
{
  "_id": {
    "$oid": "23ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB23",
  "pagename": "23ncertnotebio2",
},
{
  "_id": {
    "$oid": "23ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB23",
  "pagename": "23ncertnotebio3",
},
{
  "_id": {
    "$oid": "23ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB23",
  "pagename": "23ncertnotebio4",
},
{
  "_id": {
    "$oid": "24ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB24",
  "pagename": "24ncertnotebio1",
},
{
  "_id": {
    "$oid": "24ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB24",
  "pagename": "24ncertnotebio2",
},
{
  "_id": {
    "$oid": "24ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB24",
  "pagename": "24ncertnotebio3",
},
{
  "_id": {
    "$oid": "25ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB25",
  "pagename": "25ncertnotebio1",
},
{
  "_id": {
    "$oid": "25ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB25",
  "pagename": "25ncertnotebio2",
},
{
  "_id": {
    "$oid": "25ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB25",
  "pagename": "25ncertnotebio3",
},
{
  "_id": {
    "$oid": "25ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB25",
  "pagename": "25ncertnotebio4",
},
{
  "_id": {
    "$oid": "25ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB25",
  "pagename": "25ncertnotebio5",
},
{
  "_id": {
    "$oid": "26ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB26",
  "pagename": "26ncertnotebio1",
},
{
  "_id": {
    "$oid": "26ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB26",
  "pagename": "26ncertnotebio2",
},
{
  "_id": {
    "$oid": "26ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB26",
  "pagename": "26ncertnotebio3",
},
{
  "_id": {
    "$oid": "26ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB26",
  "pagename": "26ncertnotebio4",
},
{
  "_id": {
    "$oid": "27ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27ncertnotebio1",
},
{
  "_id": {
    "$oid": "27ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27ncertnotebio2",
},
{
  "_id": {
    "$oid": "27ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27ncertnotebio3",
},
{
  "_id": {
    "$oid": "27ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB27",
  "pagename": "27ncertnotebio4",
},
{
  "_id": {
    "$oid": "28ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28ncertnotebio1",
},
{
  "_id": {
    "$oid": "28ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28ncertnotebio2",
},
{
  "_id": {
    "$oid": "28ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28ncertnotebio3",
},
{
  "_id": {
    "$oid": "28ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28ncertnotebio4",
},
{
  "_id": {
    "$oid": "28ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB28",
  "pagename": "28ncertnotebio5",
},
{
  "_id": {
    "$oid": "29ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB29",
  "pagename": "29ncertnotebio1",
},
{
  "_id": {
    "$oid": "29ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB29",
  "pagename": "29ncertnotebio2",
},
{
  "_id": {
    "$oid": "29ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB29",
  "pagename": "29ncertnotebio3",
},
{
  "_id": {
    "$oid": "29ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB29",
  "pagename": "29ncertnotebio4",
},
{
  "_id": {
    "$oid": "30ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB30",
  "pagename": "30ncertnotebio1",
},
{
  "_id": {
    "$oid": "30ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB30",
  "pagename": "30ncertnotebio2",
},
{
  "_id": {
    "$oid": "30ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB30",
  "pagename": "30ncertnotebio3",
},
{
  "_id": {
    "$oid": "30ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB30",
  "pagename": "30ncertnotebio4",
},
{
  "_id": {
    "$oid": "31ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31ncertnotebio1",
},
{
  "_id": {
    "$oid": "31ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31ncertnotebio2",
},
{
  "_id": {
    "$oid": "31ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31ncertnotebio3",
},
{
  "_id": {
    "$oid": "31ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31ncertnotebio4",
},
{
  "_id": {
    "$oid": "31ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31ncertnotebio5",
},
{
  "_id": {
    "$oid": "31ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB31",
  "pagename": "31ncertnotebio6",
},
{
  "_id": {
    "$oid": "32ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32ncertnotebio1",
},
{
  "_id": {
    "$oid": "32ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32ncertnotebio2",
},
{
  "_id": {
    "$oid": "32ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB32",
  "pagename": "32ncertnotebio3",
},
{
  "_id": {
    "$oid": "33ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB33",
  "pagename": "33ncertnotebio1",
},
{
  "_id": {
    "$oid": "33ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB33",
  "pagename": "33ncertnotebio2",
},
{
  "_id": {
    "$oid": "33ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB33",
  "pagename": "33ncertnotebio3",
},
{
  "_id": {
    "$oid": "33ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB33",
  "pagename": "33ncertnotebio4",
},
{
  "_id": {
    "$oid": "34ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB34",
  "pagename": "34ncertnotebio1",
},
{
  "_id": {
    "$oid": "34ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB34",
  "pagename": "34ncertnotebio2",
},
{
  "_id": {
    "$oid": "34ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB34",
  "pagename": "34ncertnotebio3",
},
{
  "_id": {
    "$oid": "34ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB34",
  "pagename": "34ncertnotebio4",
},
{
  "_id": {
    "$oid": "34ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB34",
  "pagename": "34ncertnotebio5",
},
{
  "_id": {
    "$oid": "34ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB34",
  "pagename": "34ncertnotebio6",
},
{
  "_id": {
    "$oid": "34ncertnotebio7"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB34",
  "pagename": "34ncertnotebio7",
},
{
  "_id": {
    "$oid": "34ncertnotebio8"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB34",
  "pagename": "34ncertnotebio8",
},
{
  "_id": {
    "$oid": "35ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB35",
  "pagename": "35ncertnotebio1",
},
{
  "_id": {
    "$oid": "35ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB35",
  "pagename": "35ncertnotebio2",
},
{
  "_id": {
    "$oid": "35ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB35",
  "pagename": "35ncertnotebio3",
},
{
  "_id": {
    "$oid": "35ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB35",
  "pagename": "35ncertnotebio4",
},
{
  "_id": {
    "$oid": "35ncertnotebio5"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB35",
  "pagename": "35ncertnotebio5",
},
{
  "_id": {
    "$oid": "35ncertnotebio6"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB35",
  "pagename": "35ncertnotebio6",
},
{
  "_id": {
    "$oid": "36ncertnotebio1"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB36",
  "pagename": "36ncertnotebio1",
},
{
  "_id": {
    "$oid": "36ncertnotebio2"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB36",
  "pagename": "36ncertnotebio2",
},
{
  "_id": {
    "$oid": "36ncertnotebio3"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB36",
  "pagename": "36ncertnotebio3",
},
{
  "_id": {
    "$oid": "36ncertnotebio4"
  },
  "type": "ncertshortnote",
  "subject": "biology",
  "topic": "CB36",
  "pagename": "36ncertnotebio4",
},





 {
      "_id": {
        "$oid": "01mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP01",
      "pagename": "01mindmapphy1",
    },
    {
      "_id": {
        "$oid": "02mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP02",
      "pagename": "02mindmapphy1",
    },
    {
      "_id": {
        "$oid": "03mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP03",
      "pagename": "03mindmapphy1",
    },
    {
      "_id": {
        "$oid": "04mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP04",
      "pagename": "04mindmapphy1",
    },
    {
      "_id": {
        "$oid": "05mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP05",
      "pagename": "05mindmapphy1",
    },
    {
      "_id": {
        "$oid": "06mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP06",
      "pagename": "06mindmapphy1",
    },
    {
      "_id": {
        "$oid": "07mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP07",
      "pagename": "07mindmapphy1",
    },
    {
      "_id": {
        "$oid": "08mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP08",
      "pagename": "08mindmapphy1",
    },
    {
      "_id": {
        "$oid": "09mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP09",
      "pagename": "09mindmapphy1",
    },
    {
      "_id": {
        "$oid": "10mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP10",
      "pagename": "10mindmapphy1",
    },
    {
      "_id": {
        "$oid": "11mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP11",
      "pagename": "11mindmapphy1",
    },
    {
      "_id": {
        "$oid": "12mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP12",
      "pagename": "12mindmapphy1",
    },
    {
      "_id": {
        "$oid": "13mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP13",
      "pagename": "13mindmapphy1",
    },
    {
      "_id": {
        "$oid": "14mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP14",
      "pagename": "14mindmapphy1",
    },
    {
      "_id": {
        "$oid": "15mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP15",
      "pagename": "15mindmapphy1",
    },
    {
      "_id": {
        "$oid": "16mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP16",
      "pagename": "16mindmapphy1",
    },
    {
      "_id": {
        "$oid": "17mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP17",
      "pagename": "17mindmapphy1",
    },
    {
      "_id": {
        "$oid": "18mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP18",
      "pagename": "18mindmapphy1",
    },
    {
      "_id": {
        "$oid": "19mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP19",
      "pagename": "19mindmapphy1",
    },
    {
      "_id": {
        "$oid": "20mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP20",
      "pagename": "20mindmapphy1",
    },
    {
      "_id": {
        "$oid": "21mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP21",
      "pagename": "21mindmapphy1",
    },
    {
      "_id": {
        "$oid": "22mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP22",
      "pagename": "22mindmapphy1",
    },
    {
      "_id": {
        "$oid": "23mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP23",
      "pagename": "23mindmapphy1",
    },
    {
      "_id": {
        "$oid": "24mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP24",
      "pagename": "24mindmapphy1",
    },
    {
      "_id": {
        "$oid": "25mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP25",
      "pagename": "25mindmapphy1",
    },
    {
      "_id": {
        "$oid": "26mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP26",
      "pagename": "26mindmapphy1",
    },
    {
      "_id": {
        "$oid": "27mindmapphy1"
      },
      "type": "mindmap",
      "subject": "physics",
      "topic": "CP27",
      "pagename": "27mindmapphy1",
    },
     {
      "_id": {
        "$oid": "01mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC01",
      "pagename": "01mindmapche1",
    },
    {
      "_id": {
        "$oid": "02mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC02",
      "pagename": "02mindmapche1",
    },
    {
      "_id": {
        "$oid": "03mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC03",
      "pagename": "03mindmapche1",
    },
    {
      "_id": {
        "$oid": "04mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC04",
      "pagename": "04mindmapche1",
    },
    {
      "_id": {
        "$oid": "05mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC05",
      "pagename": "05mindmapche1",
    },
    {
      "_id": {
        "$oid": "06mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC06",
      "pagename": "06mindmapche1",
    },
    {
      "_id": {
        "$oid": "07mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC07",
      "pagename": "07mindmapche1",
    },
    {
      "_id": {
        "$oid": "08mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC08",
      "pagename": "08mindmapche1",
    },
    {
      "_id": {
        "$oid": "09mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC09",
      "pagename": "09mindmapche1",
    },
    {
      "_id": {
        "$oid": "10mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC10",
      "pagename": "10mindmapche1",
    },
    {
      "_id": {
        "$oid": "11mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC11",
      "pagename": "11mindmapche1",
    },
    {
      "_id": {
        "$oid": "12mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC12",
      "pagename": "12mindmapche1",
    },
    {
      "_id": {
        "$oid": "13mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC13",
      "pagename": "13mindmapche1",
    },
    {
      "_id": {
        "$oid": "14mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC14",
      "pagename": "14mindmapche1",
    },
    {
      "_id": {
        "$oid": "15mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC15",
      "pagename": "15mindmapche1",
    },
    {
      "_id": {
        "$oid": "16mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC16",
      "pagename": "16mindmapche1",
    },
    {
      "_id": {
        "$oid": "17mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC17",
      "pagename": "17mindmapche1",
    },
    {
      "_id": {
        "$oid": "18mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC18",
      "pagename": "18mindmapche1",
    },
    {
      "_id": {
        "$oid": "19mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC19",
      "pagename": "19mindmapche1",
    },
    {
      "_id": {
        "$oid": "20mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC20",
      "pagename": "20mindmapche1",
    },
    {
      "_id": {
        "$oid": "21mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC21",
      "pagename": "21mindmapche1",
    },
    {
      "_id": {
        "$oid": "22mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC22",
      "pagename": "22mindmapche1",
    },
    {
      "_id": {
        "$oid": "23mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC23",
      "pagename": "23mindmapche1",
    },
    {
      "_id": {
        "$oid": "24mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC24",
      "pagename": "24mindmapche1",
    },
    {
      "_id": {
        "$oid": "25mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC25",
      "pagename": "25mindmapche1",
    },
    {
      "_id": {
        "$oid": "26mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC26",
      "pagename": "26mindmapche1",
    },
    {
      "_id": {
        "$oid": "27mindmapche1"
      },
      "type": "mindmap",
      "subject": "chemistry",
      "topic": "CC27",
      "pagename": "27mindmapche1",
    },
  {
            "_id": {
                "$oid": "01mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB01",
            "pagename": "01mindmapbio1",
        },
        {
            "_id": {
                "$oid": "02mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB02",
            "pagename": "02mindmapbio1",
        },
        {
            "_id": {
                "$oid": "03mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB03",
            "pagename": "03mindmapbio1",
        },
        {
            "_id": {
                "$oid": "04mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB04",
            "pagename": "04mindmapbio1",
        },
        {
            "_id": {
                "$oid": "05mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB05",
            "pagename": "05mindmapbio1",
        },
        {
            "_id": {
                "$oid": "06mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB06",
            "pagename": "06mindmapbio1",
        },
        {
            "_id": {
                "$oid": "07mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB07",
            "pagename": "07mindmapbio1",
        },
        {
            "_id": {
                "$oid": "08mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB08",
            "pagename": "08mindmapbio1",
        },
        {
            "_id": {
                "$oid": "08mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB08",
            "pagename": "08mindmapbio2",
        },
        {
            "_id": {
                "$oid": "09mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB09",
            "pagename": "09mindmapbio1",
        },
        {
            "_id": {
                "$oid": "09mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB09",
            "pagename": "09mindmapbio2",
        }, {
            "_id": {
                "$oid": "09mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB09",
            "pagename": "09mindmapbio3",
        },
        {
            "_id": {
                "$oid": "10mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB10",
            "pagename": "10mindmapbio1",
        },
        {
            "_id": {
                "$oid": "10mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB10",
            "pagename": "10mindmapbio2",
        }, {
            "_id": {
                "$oid": "10mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB10",
            "pagename": "10mindmapbio3",
        },
        {
            "_id": {
                "$oid": "11mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB11",
            "pagename": "11mindmapbio1",
        },
        {
            "_id": {
                "$oid": "11mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB11",
            "pagename": "11mindmapbio2",
        },
        {
            "_id": {
                "$oid": "11mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB11",
            "pagename": "11mindmapbio3",
        },
        {
            "_id": {
                "$oid": "11mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB11",
            "pagename": "11mindmapbio4",
        },
        {
            "_id": {
                "$oid": "12mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB12",
            "pagename": "12mindmapbio1",
        },
        {
            "_id": {
                "$oid": "12mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB12",
            "pagename": "12mindmapbio2",
        },
        {
            "_id": {
                "$oid": "12mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB12",
            "pagename": "12mindmapbio3",
        },
        {
            "_id": {
                "$oid": "13mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB13",
            "pagename": "13mindmapbio1",
        },
        {
            "_id": {
                "$oid": "13mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB13",
            "pagename": "13mindmapbio2",
        },
        {
            "_id": {
                "$oid": "13mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB13",
            "pagename": "13mindmapbio3",
        },
        {
            "_id": {
                "$oid": "14mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB14",
            "pagename": "14mindmapbio1",
        },
        {
            "_id": {
                "$oid": "14mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB14",
            "pagename": "14mindmapbio2",
        },
        {
            "_id": {
                "$oid": "14mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB14",
            "pagename": "14mindmapbio3",
        },
        {
            "_id": {
                "$oid": "14mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB14",
            "pagename": "14mindmapbio4",
        },
        {
            "_id": {
                "$oid": "15mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB15",
            "pagename": "15mindmapbio1",
        },
        {
            "_id": {
                "$oid": "15mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB15",
            "pagename": "15mindmapbio2",
        },
        {
            "_id": {
                "$oid": "15mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB15",
            "pagename": "15mindmapbio3",
        },
        {
            "_id": {
                "$oid": "16mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB16",
            "pagename": "16mindmapbio1",
        },
        {
            "_id": {
                "$oid": "16mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB16",
            "pagename": "16mindmapbio2",
        },
        {
            "_id": {
                "$oid": "17mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB17",
            "pagename": "17mindmapbio1",
        },
        {
            "_id": {
                "$oid": "17mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB17",
            "pagename": "17mindmapbio2",
        }, {
            "_id": {
                "$oid": "17mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB17",
            "pagename": "17mindmapbio3",
        },
        {
            "_id": {
                "$oid": "18mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB18",
            "pagename": "18mindmapbio1",
        },
        {
            "_id": {
                "$oid": "18mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB18",
            "pagename": "18mindmapbio2",
        },
        {
            "_id": {
                "$oid": "18mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB18",
            "pagename": "18mindmapbio3",
        },
        {
            "_id": {
                "$oid": "19mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB19",
            "pagename": "19mindmapbio1",
        },
        {
            "_id": {
                "$oid": "19mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB19",
            "pagename": "19mindmapbio2",
        },
        {
            "_id": {
                "$oid": "20mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB20",
            "pagename": "20mindmapbio1",
        },
        {
            "_id": {
                "$oid": "20mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB20",
            "pagename": "20mindmapbio2",
        },
        {
            "_id": {
                "$oid": "20mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB20",
            "pagename": "20mindmapbio3",
        },

        {
            "_id": {
                "$oid": "21mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB21",
            "pagename": "21mindmapbio1",
        },
        {
            "_id": {
                "$oid": "21mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB21",
            "pagename": "21mindmapbio2",
        },
        {
            "_id": {
                "$oid": "22mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB22",
            "pagename": "22mindmapbio1",
        },
        {
            "_id": {
                "$oid": "22mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB22",
            "pagename": "22mindmapbio2",
        },
        {
            "_id": {
                "$oid": "22mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB22",
            "pagename": "22mindmapbio3",
        },

        {
            "_id": {
                "$oid": "23mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB23",
            "pagename": "23mindmapbio1",
        },
        {
            "_id": {
                "$oid": "23mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB23",
            "pagename": "23mindmapbio2",
        },
        {
            "_id": {
                "$oid": "23mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB23",
            "pagename": "23mindmapbio3",
        },

        {
            "_id": {
                "$oid": "24mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB24",
            "pagename": "24mindmapbio1",
        },
        {
            "_id": {
                "$oid": "24mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB24",
            "pagename": "24mindmapbio2",
        },
        {
            "_id": {
                "$oid": "24mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB24",
            "pagename": "24mindmapbio3",
        },
        {
            "_id": {
                "$oid": "25mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB25",
            "pagename": "25mindmapbio1",
        },
        {
            "_id": {
                "$oid": "25mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB25",
            "pagename": "25mindmapbio2",
        },
        {
            "_id": {
                "$oid": "25mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB25",
            "pagename": "25mindmapbio3",
        },
        {
            "_id": {
                "$oid": "26mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB26",
            "pagename": "26mindmapbio1",
        },
        {
            "_id": {
                "$oid": "26mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB26",
            "pagename": "26mindmapbio2",
        },
        {
            "_id": {
                "$oid": "26mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB26",
            "pagename": "26mindmapbio3",
        },
        {
            "_id": {
                "$oid": "27mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB27",
            "pagename": "27mindmapbio1",
        },
        {
            "_id": {
                "$oid": "27mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB27",
            "pagename": "27mindmapbio2",
        },
        {
            "_id": {
                "$oid": "28mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB28",
            "pagename": "28mindmapbio1",
        },
        {
            "_id": {
                "$oid": "28mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB28",
            "pagename": "28mindmapbio2",
        },
        {
            "_id": {
                "$oid": "29mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB29",
            "pagename": "29mindmapbio1",
        },
        {
            "_id": {
                "$oid": "29mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB29",
            "pagename": "29mindmapbio2",
        },
        {
            "_id": {
                "$oid": "29mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB29",
            "pagename": "29mindmapbio3",
        },
        {
            "_id": {
                "$oid": "29mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB29",
            "pagename": "29mindmapbio4",
        },
        {
            "_id": {
                "$oid": "30mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB30",
            "pagename": "30mindmapbio1",
        },
        {
            "_id": {
                "$oid": "30mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB30",
            "pagename": "30mindmapbio2",
        },
        {
            "_id": {
                "$oid": "30mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB30",
            "pagename": "30mindmapbio3",
        },
        {
            "_id": {
                "$oid": "30mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB30",
            "pagename": "30mindmapbio4",
        },
        {
            "_id": {
                "$oid": "31mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB31",
            "pagename": "31mindmapbio1",
        },
        {
            "_id": {
                "$oid": "31mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB31",
            "pagename": "31mindmapbio2",
        },
        {
            "_id": {
                "$oid": "31mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB31",
            "pagename": "31mindmapbio3",
        },
        {
            "_id": {
                "$oid": "31mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB31",
            "pagename": "31mindmapbio4",
        },
        {
            "_id": {
                "$oid": "32mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB32",
            "pagename": "32mindmapbio1",
        },
        {
            "_id": {
                "$oid": "32mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB32",
            "pagename": "32mindmapbio2",
        },
        {
            "_id": {
                "$oid": "33mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB33",
            "pagename": "33mindmapbio1",
        },
        {
            "_id": {
                "$oid": "33mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB33",
            "pagename": "33mindmapbio2",
        },
        {
            "_id": {
                "$oid": "34mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB34",
            "pagename": "34mindmapbio1",
        },
        {
            "_id": {
                "$oid": "34mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB34",
            "pagename": "34mindmapbio2",
        },
        {
            "_id": {
                "$oid": "34mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB34",
            "pagename": "34mindmapbio3",
        },
        {
            "_id": {
                "$oid": "35mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB35",
            "pagename": "35mindmapbio1",
        },
        {
            "_id": {
                "$oid": "35mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB35",
            "pagename": "35mindmapbio2",
        },
        {
            "_id": {
                "$oid": "35mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB35",
            "pagename": "35mindmapbio3",
        },
        {
            "_id": {
                "$oid": "35mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB35",
            "pagename": "35mindmapbio4",
        },
        {
            "_id": {
                "$oid": "36mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB36",
            "pagename": "36mindmapbio1",
        },
        {
            "_id": {
                "$oid": "36mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB36",
            "pagename": "36mindmapbio2",
        },
        {
            "_id": {
                "$oid": "36mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB36",
            "pagename": "36mindmapbio3",
        },
        {
            "_id": {
                "$oid": "37mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB37",
            "pagename": "37mindmapbio1",
        },
        {
            "_id": {
                "$oid": "37mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB37",
            "pagename": "37mindmapbio2",
        },
        {
            "_id": {
                "$oid": "38mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB38",
            "pagename": "38mindmapbio1",
        },
        {
            "_id": {
                "$oid": "38mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB38",
            "pagename": "38mindmapbio2",
        },
        {
            "_id": {
                "$oid": "38mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB38",
            "pagename": "38mindmapbio3",
        },
        {
            "_id": {
                "$oid": "38mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB38",
            "pagename": "38mindmapbio4",
        },
        {
            "_id": {
                "$oid": "38mindmapbio5"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB38",
            "pagename": "38mindmapbio5",
        },
        {
            "_id": {
                "$oid": "39mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB39",
            "pagename": "39mindmapbio1",
        },
        {
            "_id": {
                "$oid": "39mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB39",
            "pagename": "39mindmapbio2",
        },
        {
            "_id": {
                "$oid": "39mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB39",
            "pagename": "39mindmapbio3",
        },
        {
            "_id": {
                "$oid": "40mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB40",
            "pagename": "40mindmapbio1",
        },
        {
            "_id": {
                "$oid": "40mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB40",
            "pagename": "40mindmapbio2",
        },
        {
            "_id": {
                "$oid": "40mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB40",
            "pagename": "40mindmapbio3",
        },
        {
            "_id": {
                "$oid": "40mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB40",
            "pagename": "40mindmapbio4",
        },
        {
            "_id": {
                "$oid": "40mindmapbio5"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB40",
            "pagename": "40mindmapbio5",
        },
        {
            "_id": {
                "$oid": "40mindmapbio6"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB40",
            "pagename": "40mindmapbio6",
        },
        {
            "_id": {
                "$oid": "41mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB41",
            "pagename": "41mindmapbio1",
        },
        {
            "_id": {
                "$oid": "41mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB41",
            "pagename": "41mindmapbio2",
        },
        {
            "_id": {
                "$oid": "41mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB41",
            "pagename": "41mindmapbio3",
        },
        {
            "_id": {
                "$oid": "41mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB41",
            "pagename": "41mindmapbio4",
        },
        {
            "_id": {
                "$oid": "41mindmapbio5"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB41",
            "pagename": "41mindmapbio5",
        },
        {
            "_id": {
                "$oid": "41mindmapbio6"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB41",
            "pagename": "41mindmapbio6",
        },
        {
            "_id": {
                "$oid": "41mindmapbio7"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB41",
            "pagename": "41mindmapbio7",
        },
        {
            "_id": {
                "$oid": "42mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB42",
            "pagename": "42mindmapbio1",
        },
        {
            "_id": {
                "$oid": "42mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB42",
            "pagename": "42mindmapbio2",
        },
        {
            "_id": {
                "$oid": "43mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB43",
            "pagename": "43mindmapbio1",
        },
        {
            "_id": {
                "$oid": "43mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB43",
            "pagename": "43mindmapbio2",
        },
        {
            "_id": {
                "$oid": "43mindmapbio3"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB43",
            "pagename": "43mindmapbio3",
        },
        {
            "_id": {
                "$oid": "43mindmapbio4"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB43",
            "pagename": "43mindmapbio4",
        },
        {
            "_id": {
                "$oid": "44mindmapbio1"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB44",
            "pagename": "44mindmapbio1",
        },
        {
            "_id": {
                "$oid": "44mindmapbio2"
            },
            "type": "mindmap",
            "subject": "biology",
            "topic": "CB44",
            "pagename": "44mindmapbio2",
        },









  
  
    {
    "_id": {
      "$oid": "01topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP01",
    "pagename": "1- Basic Maths-01"
  },
  {
    "_id": {
      "$oid": "01topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-02"
  },
  {
    "_id": {
      "$oid": "01topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-03"
  },
  {
    "_id": {
      "$oid": "01topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-04"
  },
  {
    "_id": {
      "$oid": "01topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-05"
  },
  {
    "_id": {
      "$oid": "01topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-06"
  },
  {
    "_id": {
      "$oid": "01topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-07"
  },
  {
    "_id": {
      "$oid": "01topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-08"
  },
  {
    "_id": {
      "$oid": "01topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-09"
  },
  {
    "_id": {
      "$oid": "01topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-10"
  },
  {
    "_id": {
      "$oid": "01topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-11"
  },
  {
    "_id": {
      "$oid": "01topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-12"
  },
  {
    "_id": {
      "$oid": "01topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-13"
  },
  {
    "_id": {
      "$oid": "01topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-14"
  },
  {
    "_id": {
      "$oid": "01topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-15"
  },
  {
    "_id": {
      "$oid": "01topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-16"
  },
  {
    "_id": {
      "$oid": "01topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-17"
  },
  {
    "_id": {
      "$oid": "01topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-18"
  },
  {
    "_id": {
      "$oid": "01topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-19"
  },
  {
    "_id": {
      "$oid": "01topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-20"
  },
  {
    "_id": {
      "$oid": "01topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-21"
  },
  {
    "_id": {
      "$oid": "01topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-22"
  },
  {
    "_id": {
      "$oid": "01topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-23"
  },
  {
    "_id": {
      "$oid": "01topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-24"
  },
  {
    "_id": {
      "$oid": "01topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-25"
  },
  {
    "_id": {
      "$oid": "01topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-26"
  },
  {
    "_id": {
      "$oid": "01topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-27"
  },
  {
    "_id": {
      "$oid": "01topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-28"
  },
  {
    "_id": {
      "$oid": "01topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-29"
  },
  {
    "_id": {
      "$oid": "01topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-30"
  },
  {
    "_id": {
      "$oid": "01topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-31"
  },
  {
    "_id": {
      "$oid": "01topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-32"
  },
  {
    "_id": {
      "$oid": "01topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-33"
  },
  {
    "_id": {
      "$oid": "01topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-34"
  },
  {
    "_id": {
      "$oid": "01topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-35"
  },
  {
    "_id": {
      "$oid": "01topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-36"
  },
  {
    "_id": {
      "$oid": "01topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-37"
  },
  {
    "_id": {
      "$oid": "01topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-38"
  },
  {
    "_id": {
      "$oid": "01topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-39"
  },
  {
    "_id": {
      "$oid": "01topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-40"
  },
  {
    "_id": {
      "$oid": "01topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-41"
  },
  {
    "_id": {
      "$oid": "01topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-42"
  },
  {
    "_id": {
      "$oid": "01topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-43"
  },
  {
    "_id": {
      "$oid": "01topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-44"
  },
  {
    "_id": {
      "$oid": "01topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-45"
  },
  {
    "_id": {
      "$oid": "01topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-46"
  },
  {
    "_id": {
      "$oid": "01topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-47"
  },
  {
    "_id": {
      "$oid": "01topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-48"
  },
  {
    "_id": {
      "$oid": "01topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-49"
  },
  {
    "_id": {
      "$oid": "01topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-50"
  },
  {
    "_id": {
      "$oid": "01topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-51"
  },
  {
    "_id": {
      "$oid": "01topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-52"
  },
  {
    "_id": {
      "$oid": "01topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-53"
  },
  {
    "_id": {
      "$oid": "01topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-54"
  },
  {
    "_id": {
      "$oid": "01topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-55"
  },
  {
    "_id": {
      "$oid": "01topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-56"
  },
  {
    "_id": {
      "$oid": "01topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-57"
  },
  {
    "_id": {
      "$oid": "01topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-58"
  },
  {
    "_id": {
      "$oid": "01topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-59"
  },
  {
    "_id": {
      "$oid": "01topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-60"
  },
  {
    "_id": {
      "$oid": "01topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-61"
  },
  {
    "_id": {
      "$oid": "01topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-62"
  },
  {
    "_id": {
      "$oid": "01topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-63"
  },
  {
    "_id": {
      "$oid": "01topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-64"
  },
  {
    "_id": {
      "$oid": "01topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-65"
  },
  {
    "_id": {
      "$oid": "01topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "1- Basic Maths-66"
  },
     {
    "_id": {
      "$oid": "02topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP02",
    "pagename": "2-Vector-01"
  },
  {
    "_id": {
      "$oid": "02topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-02"
  },
  {
    "_id": {
      "$oid": "02topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-03"
  },
  {
    "_id": {
      "$oid": "02topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-04"
  },
  {
    "_id": {
      "$oid": "02topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-05"
  },
  {
    "_id": {
      "$oid": "02topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-06"
  },
  {
    "_id": {
      "$oid": "02topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-07"
  },
  {
    "_id": {
      "$oid": "02topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-08"
  },
  {
    "_id": {
      "$oid": "02topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-09"
  },
  {
    "_id": {
      "$oid": "02topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-10"
  },
  {
    "_id": {
      "$oid": "02topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-11"
  },
  {
    "_id": {
      "$oid": "02topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-12"
  },
  {
    "_id": {
      "$oid": "02topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-13"
  },
  {
    "_id": {
      "$oid": "02topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-14"
  },
  {
    "_id": {
      "$oid": "02topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-15"
  },
  {
    "_id": {
      "$oid": "02topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-16"
  },
  {
    "_id": {
      "$oid": "02topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-17"
  },
  {
    "_id": {
      "$oid": "02topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-18"
  },
  {
    "_id": {
      "$oid": "02topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-19"
  },
  {
    "_id": {
      "$oid": "02topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-20"
  },
  {
    "_id": {
      "$oid": "02topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-21"
  },
  {
    "_id": {
      "$oid": "02topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-22"
  },
  {
    "_id": {
      "$oid": "02topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-23"
  },
  {
    "_id": {
      "$oid": "02topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-24"
  },
  {
    "_id": {
      "$oid": "02topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-25"
  },
  {
    "_id": {
      "$oid": "02topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-26"
  },
  {
    "_id": {
      "$oid": "02topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-27"
  },
  {
    "_id": {
      "$oid": "02topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-28"
  },
  {
    "_id": {
      "$oid": "02topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-29"
  },
  {
    "_id": {
      "$oid": "02topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-30"
  },
  {
    "_id": {
      "$oid": "02topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-31"
  },
  {
    "_id": {
      "$oid": "02topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-32"
  },
  {
    "_id": {
      "$oid": "02topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-33"
  },
  {
    "_id": {
      "$oid": "02topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-34"
  },
  {
    "_id": {
      "$oid": "02topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-35"
  },
  {
    "_id": {
      "$oid": "02topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-36"
  },
  {
    "_id": {
      "$oid": "02topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-37"
  },
  {
    "_id": {
      "$oid": "02topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "2-Vector-38"
  },
   {
    "_id": {
      "$oid": "03topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-01"
  },
  {
    "_id": {
      "$oid": "03topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-02"
  },
  {
    "_id": {
      "$oid": "03topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-03"
  },
  {
    "_id": {
      "$oid": "03topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-04"
  },
  {
    "_id": {
      "$oid": "03topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-05"
  },
  {
    "_id": {
      "$oid": "03topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-06"
  },
  {
    "_id": {
      "$oid": "03topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-07"
  },
  {
    "_id": {
      "$oid": "03topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-08"
  },
  {
    "_id": {
      "$oid": "03topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-09"
  },
  {
    "_id": {
      "$oid": "03topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-10"
  },
  {
    "_id": {
      "$oid": "03topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-11"
  },
  {
    "_id": {
      "$oid": "03topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-12"
  },
  {
    "_id": {
      "$oid": "03topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-13"
  },
  {
    "_id": {
      "$oid": "03topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-14"
  },
  {
    "_id": {
      "$oid": "03topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-15"
  },
  {
    "_id": {
      "$oid": "03topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-16"
  },
  {
    "_id": {
      "$oid": "03topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-17"
  },
  {
    "_id": {
      "$oid": "03topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-18"
  },
  {
    "_id": {
      "$oid": "03topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-19"
  },
  {
    "_id": {
      "$oid": "03topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-20"
  },
  {
    "_id": {
      "$oid": "03topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-21"
  },
  {
    "_id": {
      "$oid": "03topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-22"
  },
  {
    "_id": {
      "$oid": "03topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-23"
  },
  {
    "_id": {
      "$oid": "03topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-24"
  },
  {
    "_id": {
      "$oid": "03topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-25"
  },
  {
    "_id": {
      "$oid": "03topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-26"
  },
  {
    "_id": {
      "$oid": "03topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-27"
  },
  {
    "_id": {
      "$oid": "03topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-28"
  },
  {
    "_id": {
      "$oid": "03topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-29"
  },
  {
    "_id": {
      "$oid": "03topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-30"
  },
  {
    "_id": {
      "$oid": "03topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-31"
  },
  {
    "_id": {
      "$oid": "03topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-32"
  },
  {
    "_id": {
      "$oid": "03topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-33"
  },
  {
    "_id": {
      "$oid": "03topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-34"
  },
  {
    "_id": {
      "$oid": "03topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-35"
  },
  {
    "_id": {
      "$oid": "03topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-36"
  },
  {
    "_id": {
      "$oid": "03topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-37"
  },
  {
    "_id": {
      "$oid": "03topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-38"
  },
  {
    "_id": {
      "$oid": "03topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-39"
  },
  {
    "_id": {
      "$oid": "03topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-40"
  },
  {
    "_id": {
      "$oid": "03topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-41"
  },
  {
    "_id": {
      "$oid": "03topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-42"
  },
  {
    "_id": {
      "$oid": "03topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-43"
  },
  {
    "_id": {
      "$oid": "03topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-44"
  },
  {
    "_id": {
      "$oid": "03topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-45"
  },
  {
    "_id": {
      "$oid": "03topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-46"
  },
  {
    "_id": {
      "$oid": "03topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-47"
  },
  {
    "_id": {
      "$oid": "03topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-48"
  },
  {
    "_id": {
      "$oid": "03topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-49"
  },
  {
    "_id": {
      "$oid": "03topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-50"
  },
  {
    "_id": {
      "$oid": "03topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-51"
  },
  {
    "_id": {
      "$oid": "03topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-52"
  },
  {
    "_id": {
      "$oid": "03topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-53"
  },
  {
    "_id": {
      "$oid": "03topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-54"
  },
  {
    "_id": {
      "$oid": "03topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-55"
  },
  {
    "_id": {
      "$oid": "03topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "3-Unit  Dimensions-56"
  },
    {
    "_id": {
      "$oid": "04topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-01"
  },
  {
    "_id": {
      "$oid": "04topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-02"
  },
  {
    "_id": {
      "$oid": "04topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-03"
  },
  {
    "_id": {
      "$oid": "04topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-04"
  },
  {
    "_id": {
      "$oid": "04topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-05"
  },
  {
    "_id": {
      "$oid": "04topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-06"
  },
  {
    "_id": {
      "$oid": "04topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-07"
  },
  {
    "_id": {
      "$oid": "04topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-08"
  },
  {
    "_id": {
      "$oid": "04topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-09"
  },
  {
    "_id": {
      "$oid": "04topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-10"
  },
  {
    "_id": {
      "$oid": "04topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-11"
  },
  {
    "_id": {
      "$oid": "04topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-12"
  },
  {
    "_id": {
      "$oid": "04topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-13"
  },
  {
    "_id": {
      "$oid": "04topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-14"
  },
  {
    "_id": {
      "$oid": "04topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-15"
  },
  {
    "_id": {
      "$oid": "04topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-16"
  },
  {
    "_id": {
      "$oid": "04topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-17"
  },
  {
    "_id": {
      "$oid": "04topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-18"
  },
  {
    "_id": {
      "$oid": "04topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-19"
  },
  {
    "_id": {
      "$oid": "04topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-20"
  },
  {
    "_id": {
      "$oid": "04topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-21"
  },
  {
    "_id": {
      "$oid": "04topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-22"
  },
  {
    "_id": {
      "$oid": "04topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-23"
  },
  {
    "_id": {
      "$oid": "04topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-24"
  },
  {
    "_id": {
      "$oid": "04topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-25"
  },
  {
    "_id": {
      "$oid": "04topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-26"
  },
  {
    "_id": {
      "$oid": "04topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-27"
  },
  {
    "_id": {
      "$oid": "04topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-28"
  },
  {
    "_id": {
      "$oid": "04topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-29"
  },
  {
    "_id": {
      "$oid": "04topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-30"
  },
  {
    "_id": {
      "$oid": "04topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-31"
  },
  {
    "_id": {
      "$oid": "04topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-32"
  },
  {
    "_id": {
      "$oid": "04topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-33"
  },
  {
    "_id": {
      "$oid": "04topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-34"
  },
  {
    "_id": {
      "$oid": "04topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-35"
  },
  {
    "_id": {
      "$oid": "04topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-36"
  },
  {
    "_id": {
      "$oid": "04topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-37"
  },
  {
    "_id": {
      "$oid": "04topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-38"
  },
  {
    "_id": {
      "$oid": "04topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-39"
  },
  {
    "_id": {
      "$oid": "04topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-40"
  },
  {
    "_id": {
      "$oid": "04topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-41"
  },
  {
    "_id": {
      "$oid": "04topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-42"
  },
  {
    "_id": {
      "$oid": "04topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-43"
  },
  {
    "_id": {
      "$oid": "04topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-44"
  },
  {
    "_id": {
      "$oid": "04topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-45"
  },
  {
    "_id": {
      "$oid": "04topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-46"
  },
  {
    "_id": {
      "$oid": "04topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-47"
  },
  {
    "_id": {
      "$oid": "04topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-48"
  },
  {
    "_id": {
      "$oid": "04topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-49"
  },
  {
    "_id": {
      "$oid": "04topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-50"
  },
  {
    "_id": {
      "$oid": "04topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-51"
  },
  {
    "_id": {
      "$oid": "04topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-52"
  },
  {
    "_id": {
      "$oid": "04topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-53"
  },
  {
    "_id": {
      "$oid": "04topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-54"
  },
  {
    "_id": {
      "$oid": "04topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-55"
  },
  {
    "_id": {
      "$oid": "04topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-56"
  },
  {
    "_id": {
      "$oid": "04topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-57"
  },
  {
    "_id": {
      "$oid": "04topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-58"
  },
  {
    "_id": {
      "$oid": "04topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-59"
  },
  {
    "_id": {
      "$oid": "04topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-60"
  },
  {
    "_id": {
      "$oid": "04topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-61"
  },
  {
    "_id": {
      "$oid": "04topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "4-Motion in Striaight Line-62"
  },
  
    {
    "_id": {
      "$oid": "05topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-01"
  },
  {
    "_id": {
      "$oid": "05topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-02"
  },
  {
    "_id": {
      "$oid": "05topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-03"
  },
  {
    "_id": {
      "$oid": "05topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-04"
  },
  {
    "_id": {
      "$oid": "05topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-05"
  },
  {
    "_id": {
      "$oid": "05topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-06"
  },
  {
    "_id": {
      "$oid": "05topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-07"
  },
  {
    "_id": {
      "$oid": "05topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-08"
  },
  {
    "_id": {
      "$oid": "05topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-09"
  },
  {
    "_id": {
      "$oid": "05topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-10"
  },
  {
    "_id": {
      "$oid": "05topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-11"
  },
  {
    "_id": {
      "$oid": "05topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-12"
  },
  {
    "_id": {
      "$oid": "05topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-13"
  },
  {
    "_id": {
      "$oid": "05topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-14"
  },
  {
    "_id": {
      "$oid": "05topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-15"
  },
  {
    "_id": {
      "$oid": "05topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-16"
  },
  {
    "_id": {
      "$oid": "05topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-17"
  },
  {
    "_id": {
      "$oid": "05topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-18"
  },
  {
    "_id": {
      "$oid": "05topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-19"
  },
  {
    "_id": {
      "$oid": "05topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-20"
  },
  {
    "_id": {
      "$oid": "05topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-21"
  },
  {
    "_id": {
      "$oid": "05topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-22"
  },
  {
    "_id": {
      "$oid": "05topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-23"
  },
  {
    "_id": {
      "$oid": "05topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-24"
  },
  {
    "_id": {
      "$oid": "05topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-25"
  },
  {
    "_id": {
      "$oid": "05topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-26"
  },
  {
    "_id": {
      "$oid": "05topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-27"
  },
  {
    "_id": {
      "$oid": "05topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-28"
  },
  {
    "_id": {
      "$oid": "05topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-29"
  },
  {
    "_id": {
      "$oid": "05topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-30"
  },
  {
    "_id": {
      "$oid": "05topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-31"
  },
  {
    "_id": {
      "$oid": "05topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-32"
  },
  {
    "_id": {
      "$oid": "05topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-33"
  },
  {
    "_id": {
      "$oid": "05topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-34"
  },
  {
    "_id": {
      "$oid": "05topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-35"
  },
  {
    "_id": {
      "$oid": "05topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-36"
  },
  {
    "_id": {
      "$oid": "05topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-37"
  },
  {
    "_id": {
      "$oid": "05topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-38"
  },
  {
    "_id": {
      "$oid": "05topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-39"
  },
  {
    "_id": {
      "$oid": "05topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-40"
  },
  {
    "_id": {
      "$oid": "05topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-41"
  },
  {
    "_id": {
      "$oid": "05topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-42"
  },
  {
    "_id": {
      "$oid": "05topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-43"
  },
  {
    "_id": {
      "$oid": "05topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-44"
  },
  {
    "_id": {
      "$oid": "05topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-45"
  },
  {
    "_id": {
      "$oid": "05topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-46"
  },
  {
    "_id": {
      "$oid": "05topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-47"
  },
  {
    "_id": {
      "$oid": "05topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-48"
  },
  {
    "_id": {
      "$oid": "05topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-49"
  },
  {
    "_id": {
      "$oid": "05topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-50"
  },
  {
    "_id": {
      "$oid": "05topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-51"
  },
  {
    "_id": {
      "$oid": "05topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-52"
  },
  {
    "_id": {
      "$oid": "05topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-53"
  },
  {
    "_id": {
      "$oid": "05topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-54"
  },
  {
    "_id": {
      "$oid": "05topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-55"
  },
  {
    "_id": {
      "$oid": "05topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-56"
  },
  {
    "_id": {
      "$oid": "05topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-57"
  },
  {
    "_id": {
      "$oid": "05topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-58"
  },
  {
    "_id": {
      "$oid": "05topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-59"
  },
  {
    "_id": {
      "$oid": "05topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-60"
  },
  {
    "_id": {
      "$oid": "05topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-61"
  },
  {
    "_id": {
      "$oid": "05topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-62"
  },
  {
    "_id": {
      "$oid": "05topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-63"
  },
  {
    "_id": {
      "$oid": "05topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-64"
  },
  {
    "_id": {
      "$oid": "05topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-65"
  },
  {
    "_id": {
      "$oid": "05topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-66"
  },
  {
    "_id": {
      "$oid": "05topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "5-Motion in Plane-67"
  },
    {
    "_id": {
      "$oid": "06topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP06",
    "pagename": "6-Law of Motion-01"
  },
  {
    "_id": {
      "$oid": "06topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-02"
  },
  {
    "_id": {
      "$oid": "06topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-03"
  },
  {
    "_id": {
      "$oid": "06topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-04"
  },
  {
    "_id": {
      "$oid": "06topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-05"
  },
  {
    "_id": {
      "$oid": "06topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-06"
  },
  {
    "_id": {
      "$oid": "06topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-07"
  },
  {
    "_id": {
      "$oid": "06topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-08"
  },
  {
    "_id": {
      "$oid": "06topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-09"
  },
  {
    "_id": {
      "$oid": "06topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-10"
  },
  {
    "_id": {
      "$oid": "06topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-11"
  },
  {
    "_id": {
      "$oid": "06topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-12"
  },
  {
    "_id": {
      "$oid": "06topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-13"
  },
  {
    "_id": {
      "$oid": "06topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-14"
  },
  {
    "_id": {
      "$oid": "06topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-15"
  },
  {
    "_id": {
      "$oid": "06topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-16"
  },
  {
    "_id": {
      "$oid": "06topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-17"
  },
  {
    "_id": {
      "$oid": "06topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-18"
  },
  {
    "_id": {
      "$oid": "06topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-19"
  },
  {
    "_id": {
      "$oid": "06topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-20"
  },
  {
    "_id": {
      "$oid": "06topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-21"
  },
  {
    "_id": {
      "$oid": "06topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-22"
  },
  {
    "_id": {
      "$oid": "06topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-23"
  },
  {
    "_id": {
      "$oid": "06topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-24"
  },
  {
    "_id": {
      "$oid": "06topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-25"
  },
  {
    "_id": {
      "$oid": "06topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-26"
  },
  {
    "_id": {
      "$oid": "06topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-27"
  },
  {
    "_id": {
      "$oid": "06topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-28"
  },
  {
    "_id": {
      "$oid": "06topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-29"
  },
  {
    "_id": {
      "$oid": "06topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-30"
  },
  {
    "_id": {
      "$oid": "06topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-31"
  },
  {
    "_id": {
      "$oid": "06topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-32"
  },
  {
    "_id": {
      "$oid": "06topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-33"
  },
  {
    "_id": {
      "$oid": "06topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-34"
  },
  {
    "_id": {
      "$oid": "06topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-35"
  },
  {
    "_id": {
      "$oid": "06topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-36"
  },
  {
    "_id": {
      "$oid": "06topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "6-Law of Motion-37"
  },
    {
    "_id": {
      "$oid": "07topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP07",
    "pagename": "7-Friction-01"
  },
  {
    "_id": {
      "$oid": "07topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-02"
  },
  {
    "_id": {
      "$oid": "07topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-03"
  },
  {
    "_id": {
      "$oid": "07topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-04"
  },
  {
    "_id": {
      "$oid": "07topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-05"
  },
  {
    "_id": {
      "$oid": "07topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-06"
  },
  {
    "_id": {
      "$oid": "07topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-07"
  },
  {
    "_id": {
      "$oid": "07topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-08"
  },
  {
    "_id": {
      "$oid": "07topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-09"
  },
  {
    "_id": {
      "$oid": "07topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-10"
  },
  {
    "_id": {
      "$oid": "07topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-11"
  },
  {
    "_id": {
      "$oid": "07topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-12"
  },
  {
    "_id": {
      "$oid": "07topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-13"
  },
  {
    "_id": {
      "$oid": "07topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-14"
  },
  {
    "_id": {
      "$oid": "07topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-15"
  },
  {
    "_id": {
      "$oid": "07topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-16"
  },
  {
    "_id": {
      "$oid": "07topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-17"
  },
  {
    "_id": {
      "$oid": "07topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-18"
  },
  {
    "_id": {
      "$oid": "07topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-19"
  },
  {
    "_id": {
      "$oid": "07topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-20"
  },
  {
    "_id": {
      "$oid": "07topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-21"
  },
  {
    "_id": {
      "$oid": "07topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-22"
  },
  {
    "_id": {
      "$oid": "07topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-23"
  },
  {
    "_id": {
      "$oid": "07topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-24"
  },
  {
    "_id": {
      "$oid": "07topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-25"
  },
  {
    "_id": {
      "$oid": "07topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-26"
  },
  {
    "_id": {
      "$oid": "07topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-27"
  },
  {
    "_id": {
      "$oid": "07topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-28"
  },
  {
    "_id": {
      "$oid": "07topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-29"
  },
  {
    "_id": {
      "$oid": "07topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-30"
  },
  {
    "_id": {
      "$oid": "07topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-31"
  },
  {
    "_id": {
      "$oid": "07topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-32"
  },
  {
    "_id": {
      "$oid": "07topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-33"
  },
  {
    "_id": {
      "$oid": "07topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-34"
  },
  {
    "_id": {
      "$oid": "07topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-35"
  },
  {
    "_id": {
      "$oid": "07topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "7-Friction-36"
  },
    {
    "_id": {
      "$oid": "08topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-01"
  },
  {
    "_id": {
      "$oid": "08topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-02"
  },
  {
    "_id": {
      "$oid": "08topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-03"
  },
  {
    "_id": {
      "$oid": "08topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-04"
  },
  {
    "_id": {
      "$oid": "08topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-05"
  },
  {
    "_id": {
      "$oid": "08topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-06"
  },
  {
    "_id": {
      "$oid": "08topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-07"
  },
  {
    "_id": {
      "$oid": "08topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-08"
  },
  {
    "_id": {
      "$oid": "08topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-09"
  },
  {
    "_id": {
      "$oid": "08topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-10"
  },
  {
    "_id": {
      "$oid": "08topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-11"
  },
  {
    "_id": {
      "$oid": "08topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-12"
  },
  {
    "_id": {
      "$oid": "08topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-13"
  },
  {
    "_id": {
      "$oid": "08topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-14"
  },
  {
    "_id": {
      "$oid": "08topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-15"
  },
  {
    "_id": {
      "$oid": "08topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-16"
  },
  {
    "_id": {
      "$oid": "08topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-17"
  },
  {
    "_id": {
      "$oid": "08topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-18"
  },
  {
    "_id": {
      "$oid": "08topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-19"
  },
  {
    "_id": {
      "$oid": "08topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-20"
  },
  {
    "_id": {
      "$oid": "08topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-21"
  },
  {
    "_id": {
      "$oid": "08topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-22"
  },
  {
    "_id": {
      "$oid": "08topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-23"
  },
  {
    "_id": {
      "$oid": "08topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-24"
  },
  {
    "_id": {
      "$oid": "08topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-25"
  },
  {
    "_id": {
      "$oid": "08topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-26"
  },
  {
    "_id": {
      "$oid": "08topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-27"
  },
  {
    "_id": {
      "$oid": "08topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-28"
  },
  {
    "_id": {
      "$oid": "08topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-29"
  },
  {
    "_id": {
      "$oid": "08topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-30"
  },
  {
    "_id": {
      "$oid": "08topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-31"
  },
  {
    "_id": {
      "$oid": "08topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-32"
  },
  {
    "_id": {
      "$oid": "08topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-33"
  },
  {
    "_id": {
      "$oid": "08topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-34"
  },
  {
    "_id": {
      "$oid": "08topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-35"
  },
  {
    "_id": {
      "$oid": "08topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-36"
  },
  {
    "_id": {
      "$oid": "08topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-37"
  },
  {
    "_id": {
      "$oid": "08topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "8-Work Power and Energy-38"
  },
    {
    "_id": {
      "$oid": "09topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP09",
    "pagename": "9-Center of Mass-01"
  },
  {
    "_id": {
      "$oid": "09topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-02"
  },
  {
    "_id": {
      "$oid": "09topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-03"
  },
  {
    "_id": {
      "$oid": "09topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-04"
  },
  {
    "_id": {
      "$oid": "09topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-05"
  },
  {
    "_id": {
      "$oid": "09topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-06"
  },
  {
    "_id": {
      "$oid": "09topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-07"
  },
  {
    "_id": {
      "$oid": "09topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-08"
  },
  {
    "_id": {
      "$oid": "09topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-09"
  },
  {
    "_id": {
      "$oid": "09topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-10"
  },
  {
    "_id": {
      "$oid": "09topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-11"
  },
  {
    "_id": {
      "$oid": "09topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-12"
  },
  {
    "_id": {
      "$oid": "09topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-13"
  },
  {
    "_id": {
      "$oid": "09topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-14"
  },
  {
    "_id": {
      "$oid": "09topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-15"
  },
  {
    "_id": {
      "$oid": "09topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-16"
  },
  {
    "_id": {
      "$oid": "09topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-17"
  },
  {
    "_id": {
      "$oid": "09topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-18"
  },
  {
    "_id": {
      "$oid": "09topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-19"
  },
  {
    "_id": {
      "$oid": "09topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-20"
  },
  {
    "_id": {
      "$oid": "09topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-21"
  },
  {
    "_id": {
      "$oid": "09topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-22"
  },
  {
    "_id": {
      "$oid": "09topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-23"
  },
  {
    "_id": {
      "$oid": "09topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-24"
  },
  {
    "_id": {
      "$oid": "09topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-25"
  },
  {
    "_id": {
      "$oid": "09topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-26"
  },
  {
    "_id": {
      "$oid": "09topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-27"
  },
  {
    "_id": {
      "$oid": "09topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "9-Center of Mass-28"
  },
    {
    "_id": {
      "$oid": "10topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-01"
  },
  {
    "_id": {
      "$oid": "10topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-02"
  },
  {
    "_id": {
      "$oid": "10topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-03"
  },
  {
    "_id": {
      "$oid": "10topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-04"
  },
  {
    "_id": {
      "$oid": "10topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-05"
  },
  {
    "_id": {
      "$oid": "10topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-06"
  },
  {
    "_id": {
      "$oid": "10topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-07"
  },
  {
    "_id": {
      "$oid": "10topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-08"
  },
  {
    "_id": {
      "$oid": "10topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-09"
  },
  {
    "_id": {
      "$oid": "10topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-10"
  },
  {
    "_id": {
      "$oid": "10topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-11"
  },
  {
    "_id": {
      "$oid": "10topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-12"
  },
  {
    "_id": {
      "$oid": "10topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-13"
  },
  {
    "_id": {
      "$oid": "10topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-14"
  },
  {
    "_id": {
      "$oid": "10topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-15"
  },
  {
    "_id": {
      "$oid": "10topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-16"
  },
  {
    "_id": {
      "$oid": "10topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-17"
  },
  {
    "_id": {
      "$oid": "10topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-18"
  },
  {
    "_id": {
      "$oid": "10topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-19"
  },
  {
    "_id": {
      "$oid": "10topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-20"
  },
  {
    "_id": {
      "$oid": "10topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-21"
  },
  {
    "_id": {
      "$oid": "10topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-22"
  },
  {
    "_id": {
      "$oid": "10topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-23"
  },
  {
    "_id": {
      "$oid": "10topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-24"
  },
  {
    "_id": {
      "$oid": "10topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-25"
  },
  {
    "_id": {
      "$oid": "10topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-26"
  },
  {
    "_id": {
      "$oid": "10topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-27"
  },
  {
    "_id": {
      "$oid": "10topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-28"
  },
  {
    "_id": {
      "$oid": "10topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-29"
  },
  {
    "_id": {
      "$oid": "10topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-30"
  },
  {
    "_id": {
      "$oid": "10topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-31"
  },
  {
    "_id": {
      "$oid": "10topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-32"
  },
  {
    "_id": {
      "$oid": "10topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-33"
  },
  {
    "_id": {
      "$oid": "10topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-34"
  },
  {
    "_id": {
      "$oid": "10topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-35"
  },
  {
    "_id": {
      "$oid": "10topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-36"
  },
  {
    "_id": {
      "$oid": "10topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-37"
  },
  {
    "_id": {
      "$oid": "10topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-38"
  },
  {
    "_id": {
      "$oid": "10topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-39"
  },
  {
    "_id": {
      "$oid": "10topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-40"
  },
  {
    "_id": {
      "$oid": "10topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-41"
  },
  {
    "_id": {
      "$oid": "10topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-42"
  },
  {
    "_id": {
      "$oid": "10topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-43"
  },
  {
    "_id": {
      "$oid": "10topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-44"
  },
  {
    "_id": {
      "$oid": "10topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-45"
  },
  {
    "_id": {
      "$oid": "10topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-46"
  },
  {
    "_id": {
      "$oid": "10topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-47"
  },
  {
    "_id": {
      "$oid": "10topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-48"
  },
  {
    "_id": {
      "$oid": "10topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-49"
  },
  {
    "_id": {
      "$oid": "10topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-50"
  },
  {
    "_id": {
      "$oid": "10topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-51"
  },
  {
    "_id": {
      "$oid": "10topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-52"
  },
  {
    "_id": {
      "$oid": "10topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-53"
  },
  {
    "_id": {
      "$oid": "10topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-54"
  },
  {
    "_id": {
      "$oid": "10topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-55"
  },
  {
    "_id": {
      "$oid": "10topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-56"
  },
  {
    "_id": {
      "$oid": "10topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-57"
  },
  {
    "_id": {
      "$oid": "10topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-58"
  },
  {
    "_id": {
      "$oid": "10topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-59"
  },
  {
    "_id": {
      "$oid": "10topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-60"
  },
  {
    "_id": {
      "$oid": "10topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-61"
  },
  {
    "_id": {
      "$oid": "10topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-62"
  },
  {
    "_id": {
      "$oid": "10topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-63"
  },
  {
    "_id": {
      "$oid": "10topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-64"
  },
  {
    "_id": {
      "$oid": "10topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-65"
  },
  {
    "_id": {
      "$oid": "10topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-66"
  },
  {
    "_id": {
      "$oid": "10topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-67"
  },
  {
    "_id": {
      "$oid": "10topernotephy68"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-68"
  },
  {
    "_id": {
      "$oid": "10topernotephy69"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-69"
  },
  {
    "_id": {
      "$oid": "10topernotephy70"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-70"
  },
    {
    "_id": {
      "$oid": "10topernotephy71"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-71"
  },
  {
    "_id": {
      "$oid": "10topernotephy72"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-72"
  },
  {
    "_id": {
      "$oid": "10topernotephy73"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-73"
  },
  {
    "_id": {
      "$oid": "10topernotephy74"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-74"
  },
  {
    "_id": {
      "$oid": "10topernotephy75"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-75"
  },
  {
    "_id": {
      "$oid": "10topernotephy76"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-76"
  },
  {
    "_id": {
      "$oid": "10topernotephy77"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-77"
  },
  {
    "_id": {
      "$oid": "10topernotephy78"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-78"
  },
  {
    "_id": {
      "$oid": "10topernotephy79"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-79"
  },
  {
    "_id": {
      "$oid": "10topernotephy81"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-81"
  },
   {
    "_id": {
      "$oid": "10topernotephy81"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "10-Rotational Motion-81"
  },
         {
    "_id": {
      "$oid": "11topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP11",
    "pagename": "11-Gravitation-01"
  },
  {
    "_id": {
      "$oid": "11topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-02"
  },
  {
    "_id": {
      "$oid": "11topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-03"
  },
  {
    "_id": {
      "$oid": "11topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-04"
  },
  {
    "_id": {
      "$oid": "11topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-05"
  },
  {
    "_id": {
      "$oid": "11topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-06"
  },
  {
    "_id": {
      "$oid": "11topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-07"
  },
  {
    "_id": {
      "$oid": "11topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-08"
  },
  {
    "_id": {
      "$oid": "11topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-09"
  },
  {
    "_id": {
      "$oid": "11topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-10"
  },
  {
    "_id": {
      "$oid": "11topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-11"
  },
  {
    "_id": {
      "$oid": "11topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-12"
  },
  {
    "_id": {
      "$oid": "11topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-13"
  },
  {
    "_id": {
      "$oid": "11topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-14"
  },
  {
    "_id": {
      "$oid": "11topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-15"
  },
  {
    "_id": {
      "$oid": "11topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-16"
  },
  {
    "_id": {
      "$oid": "11topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-17"
  },
  {
    "_id": {
      "$oid": "11topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-18"
  },
  {
    "_id": {
      "$oid": "11topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-19"
  },
  {
    "_id": {
      "$oid": "11topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-20"
  },
  {
    "_id": {
      "$oid": "11topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-21"
  },
  {
    "_id": {
      "$oid": "11topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-22"
  },
  {
    "_id": {
      "$oid": "11topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-23"
  },
  {
    "_id": {
      "$oid": "11topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-24"
  },
  {
    "_id": {
      "$oid": "11topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-25"
  },
  {
    "_id": {
      "$oid": "11topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-26"
  },
  {
    "_id": {
      "$oid": "11topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-27"
  },
  {
    "_id": {
      "$oid": "11topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-28"
  },
  {
    "_id": {
      "$oid": "11topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-29"
  },
  {
    "_id": {
      "$oid": "11topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-30"
  },
  {
    "_id": {
      "$oid": "11topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-31"
  },
  {
    "_id": {
      "$oid": "11topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-32"
  },
  {
    "_id": {
      "$oid": "11topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-33"
  },
  {
    "_id": {
      "$oid": "11topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-34"
  },
  {
    "_id": {
      "$oid": "11topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-35"
  },
  {
    "_id": {
      "$oid": "11topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-36"
  },
  {
    "_id": {
      "$oid": "11topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-37"
  },
  {
    "_id": {
      "$oid": "11topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-38"
  },
  {
    "_id": {
      "$oid": "11topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-39"
  },
  {
    "_id": {
      "$oid": "11topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-40"
  },
  {
    "_id": {
      "$oid": "11topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-41"
  },
  {
    "_id": {
      "$oid": "11topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-42"
  },
  {
    "_id": {
      "$oid": "11topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-43"
  },
  {
    "_id": {
      "$oid": "11topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-44"
  },
  {
    "_id": {
      "$oid": "11topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-45"
  },
  {
    "_id": {
      "$oid": "11topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-46"
  },
  {
    "_id": {
      "$oid": "11topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-47"
  },
  {
    "_id": {
      "$oid": "11topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-48"
  },
  {
    "_id": {
      "$oid": "11topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-49"
  },
  {
    "_id": {
      "$oid": "11topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-50"
  },
  {
    "_id": {
      "$oid": "11topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-51"
  },
  {
    "_id": {
      "$oid": "11topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-52"
  },
  {
    "_id": {
      "$oid": "11topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-53"
  },
  {
    "_id": {
      "$oid": "11topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-54"
  },
  {
    "_id": {
      "$oid": "11topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-55"
  },
  {
    "_id": {
      "$oid": "11topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-56"
  },
  {
    "_id": {
      "$oid": "11topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-57"
  },
  {
    "_id": {
      "$oid": "11topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-58"
  },
  {
    "_id": {
      "$oid": "11topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-59"
  },
  {
    "_id": {
      "$oid": "11topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-60"
  },
  {
    "_id": {
      "$oid": "11topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-61"
  },
  {
    "_id": {
      "$oid": "11topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-62"
  },
  {
    "_id": {
      "$oid": "11topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-63"
  },
  {
    "_id": {
      "$oid": "11topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-64"
  },
  {
    "_id": {
      "$oid": "11topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-65"
  },
  {
    "_id": {
      "$oid": "11topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-66"
  },
  {
    "_id": {
      "$oid": "11topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-67"
  },
  {
    "_id": {
      "$oid": "11topernotephy68"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-68"
  },
  {
    "_id": {
      "$oid": "11topernotephy69"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-69"
  },
  {
    "_id": {
      "$oid": "11topernotephy70"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-70"
  },
    {
    "_id": {
      "$oid": "11topernotephy71"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-71"
  },
  {
    "_id": {
      "$oid": "11topernotephy72"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-72"
  },
  {
    "_id": {
      "$oid": "11topernotephy73"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-73"
  },
  {
    "_id": {
      "$oid": "11topernotephy74"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-74"
  },
  {
    "_id": {
      "$oid": "11topernotephy75"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-75"
  },
  {
    "_id": {
      "$oid": "11topernotephy76"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "11-Gravitation-76"
  },
    {
    "_id": {
      "$oid": "12topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-01"
  },
  {
    "_id": {
      "$oid": "12topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-02"
  },
  {
    "_id": {
      "$oid": "12topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-03"
  },
  {
    "_id": {
      "$oid": "12topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-04"
  },
  {
    "_id": {
      "$oid": "12topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-05"
  },
  {
    "_id": {
      "$oid": "12topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-06"
  },
  {
    "_id": {
      "$oid": "12topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-07"
  },
  {
    "_id": {
      "$oid": "12topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-08"
  },
  {
    "_id": {
      "$oid": "12topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-09"
  },
  {
    "_id": {
      "$oid": "12topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-10"
  },
  {
    "_id": {
      "$oid": "12topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-11"
  },
  {
    "_id": {
      "$oid": "12topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-12"
  },
  {
    "_id": {
      "$oid": "12topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-13"
  },
  {
    "_id": {
      "$oid": "12topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-14"
  },
  {
    "_id": {
      "$oid": "12topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-15"
  },
  {
    "_id": {
      "$oid": "12topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-16"
  },
  {
    "_id": {
      "$oid": "12topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-17"
  },
  {
    "_id": {
      "$oid": "12topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-18"
  },
  {
    "_id": {
      "$oid": "12topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-19"
  },
  {
    "_id": {
      "$oid": "12topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-20"
  },
  {
    "_id": {
      "$oid": "12topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-21"
  },
  {
    "_id": {
      "$oid": "12topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "12-Mechanical properties of Solids-22"
  },
    {
    "_id": {
      "$oid": "13topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-01"
  },
  {
    "_id": {
      "$oid": "13topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-02"
  },
  {
    "_id": {
      "$oid": "13topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-03"
  },
  {
    "_id": {
      "$oid": "13topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-04"
  },
  {
    "_id": {
      "$oid": "13topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-05"
  },
  {
    "_id": {
      "$oid": "13topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-06"
  },
  {
    "_id": {
      "$oid": "13topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-07"
  },
  {
    "_id": {
      "$oid": "13topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-08"
  },
  {
    "_id": {
      "$oid": "13topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-09"
  },
  {
    "_id": {
      "$oid": "13topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-10"
  },
  {
    "_id": {
      "$oid": "13topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-11"
  },
  {
    "_id": {
      "$oid": "13topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-12"
  },
  {
    "_id": {
      "$oid": "13topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-13"
  },
  {
    "_id": {
      "$oid": "13topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-14"
  },
  {
    "_id": {
      "$oid": "13topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-15"
  },
  {
    "_id": {
      "$oid": "13topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-16"
  },
  {
    "_id": {
      "$oid": "13topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-17"
  },
  {
    "_id": {
      "$oid": "13topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-18"
  },
  {
    "_id": {
      "$oid": "13topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-19"
  },
  {
    "_id": {
      "$oid": "13topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-20"
  },
  {
    "_id": {
      "$oid": "13topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-21"
  },
  {
    "_id": {
      "$oid": "13topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-22"
  },
  {
    "_id": {
      "$oid": "13topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-23"
  },
  {
    "_id": {
      "$oid": "13topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-24"
  },
  {
    "_id": {
      "$oid": "13topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-25"
  },
  {
    "_id": {
      "$oid": "13topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-26"
  },
  {
    "_id": {
      "$oid": "13topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-27"
  },
  {
    "_id": {
      "$oid": "13topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-28"
  },
  {
    "_id": {
      "$oid": "13topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-29"
  },
  {
    "_id": {
      "$oid": "13topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-30"
  },
  {
    "_id": {
      "$oid": "13topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-31"
  },
  {
    "_id": {
      "$oid": "13topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-32"
  },
  {
    "_id": {
      "$oid": "13topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-33"
  },
  {
    "_id": {
      "$oid": "13topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-34"
  },
  {
    "_id": {
      "$oid": "13topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-35"
  },
  {
    "_id": {
      "$oid": "13topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-36"
  },
  {
    "_id": {
      "$oid": "13topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-37"
  },
  {
    "_id": {
      "$oid": "13topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-38"
  },
  {
    "_id": {
      "$oid": "13topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-39"
  },
  {
    "_id": {
      "$oid": "13topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-40"
  },
  {
    "_id": {
      "$oid": "13topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-41"
  },
  {
    "_id": {
      "$oid": "13topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-42"
  },
  {
    "_id": {
      "$oid": "13topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-43"
  },
  {
    "_id": {
      "$oid": "13topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-44"
  },
  {
    "_id": {
      "$oid": "13topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-45"
  },
  {
    "_id": {
      "$oid": "13topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-46"
  },
  {
    "_id": {
      "$oid": "13topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-47"
  },
  {
    "_id": {
      "$oid": "13topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-48"
  },
  {
    "_id": {
      "$oid": "13topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-49"
  },
  {
    "_id": {
      "$oid": "13topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-50"
  },
  {
    "_id": {
      "$oid": "13topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-51"
  },
  {
    "_id": {
      "$oid": "13topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-52"
  },
  {
    "_id": {
      "$oid": "13topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-53"
  },
  {
    "_id": {
      "$oid": "13topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-54"
  },
  {
    "_id": {
      "$oid": "13topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-55"
  },
  {
    "_id": {
      "$oid": "13topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "13-Mechanical properties of Fluids-56"
  },
    {
    "_id": {
      "$oid": "14topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-01"
  },
  {
    "_id": {
      "$oid": "14topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-02"
  },
  {
    "_id": {
      "$oid": "14topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-03"
  },
  {
    "_id": {
      "$oid": "14topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-04"
  },
  {
    "_id": {
      "$oid": "14topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-05"
  },
  {
    "_id": {
      "$oid": "14topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-06"
  },
  {
    "_id": {
      "$oid": "14topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-07"
  },
  {
    "_id": {
      "$oid": "14topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-08"
  },
  {
    "_id": {
      "$oid": "14topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-09"
  },
  {
    "_id": {
      "$oid": "14topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-10"
  },
  {
    "_id": {
      "$oid": "14topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-11"
  },
  {
    "_id": {
      "$oid": "14topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-12"
  },
  {
    "_id": {
      "$oid": "14topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-13"
  },
  {
    "_id": {
      "$oid": "14topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-14"
  },
  {
    "_id": {
      "$oid": "14topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-15"
  },
  {
    "_id": {
      "$oid": "14topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-16"
  },
  {
    "_id": {
      "$oid": "14topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-17"
  },
  {
    "_id": {
      "$oid": "14topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-18"
  },
  {
    "_id": {
      "$oid": "14topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-19"
  },
  {
    "_id": {
      "$oid": "14topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-20"
  },
  {
    "_id": {
      "$oid": "14topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-21"
  },
  {
    "_id": {
      "$oid": "14topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-22"
  },
  {
    "_id": {
      "$oid": "14topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-23"
  },
  {
    "_id": {
      "$oid": "14topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-24"
  },
  {
    "_id": {
      "$oid": "14topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-25"
  },
  {
    "_id": {
      "$oid": "14topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-26"
  },
  {
    "_id": {
      "$oid": "14topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-27"
  },
  {
    "_id": {
      "$oid": "14topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-28"
  },
  {
    "_id": {
      "$oid": "14topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-29"
  },
  {
    "_id": {
      "$oid": "14topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-30"
  },
  {
    "_id": {
      "$oid": "14topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-31"
  },
  {
    "_id": {
      "$oid": "14topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-32"
  },
  {
    "_id": {
      "$oid": "14topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-33"
  },
  {
    "_id": {
      "$oid": "14topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-34"
  },
  {
    "_id": {
      "$oid": "14topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-35"
  },
  {
    "_id": {
      "$oid": "14topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-36"
  },
  {
    "_id": {
      "$oid": "14topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-37"
  },
  {
    "_id": {
      "$oid": "14topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-38"
  },
  {
    "_id": {
      "$oid": "14topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-39"
  },
  {
    "_id": {
      "$oid": "14topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-40"
  },
  {
    "_id": {
      "$oid": "14topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-41"
  },
  {
    "_id": {
      "$oid": "14topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-42"
  },
  {
    "_id": {
      "$oid": "14topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-43"
  },
  {
    "_id": {
      "$oid": "14topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-44"
  },
  {
    "_id": {
      "$oid": "14topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-45"
  },
  {
    "_id": {
      "$oid": "14topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-46"
  },
  {
    "_id": {
      "$oid": "14topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-47"
  },
  {
    "_id": {
      "$oid": "14topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-48"
  },
  {
    "_id": {
      "$oid": "14topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-49"
  },
  {
    "_id": {
      "$oid": "14topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-50"
  },
  {
    "_id": {
      "$oid": "14topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-51"
  },
  {
    "_id": {
      "$oid": "14topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-52"
  },
  {
    "_id": {
      "$oid": "14topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-53"
  },
  {
    "_id": {
      "$oid": "14topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-54"
  },
  {
    "_id": {
      "$oid": "14topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-55"
  },
  {
    "_id": {
      "$oid": "14topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-56"
  },
  {
    "_id": {
      "$oid": "14topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-57"
  },
  {
    "_id": {
      "$oid": "14topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-58"
  },
  {
    "_id": {
      "$oid": "14topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-59"
  },
  {
    "_id": {
      "$oid": "14topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-60"
  },
  {
    "_id": {
      "$oid": "14topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-61"
  },
  {
    "_id": {
      "$oid": "14topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "14-Termal Properties of  Matter-62"
  },
    {
    "_id": {
      "$oid": "15topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-01"
  },
  {
    "_id": {
      "$oid": "15topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-02"
  },
  {
    "_id": {
      "$oid": "15topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-03"
  },
  {
    "_id": {
      "$oid": "15topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-04"
  },
  {
    "_id": {
      "$oid": "15topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-05"
  },
  {
    "_id": {
      "$oid": "15topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-06"
  },
  {
    "_id": {
      "$oid": "15topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-07"
  },
  {
    "_id": {
      "$oid": "15topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-08"
  },
  {
    "_id": {
      "$oid": "15topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-09"
  },
  {
    "_id": {
      "$oid": "15topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-10"
  },
  {
    "_id": {
      "$oid": "15topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-11"
  },
  {
    "_id": {
      "$oid": "15topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-12"
  },
  {
    "_id": {
      "$oid": "15topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-13"
  },
  {
    "_id": {
      "$oid": "15topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-14"
  },
  {
    "_id": {
      "$oid": "15topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-15"
  },
  {
    "_id": {
      "$oid": "15topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-16"
  },
  {
    "_id": {
      "$oid": "15topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-17"
  },
  {
    "_id": {
      "$oid": "15topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-18"
  },
  {
    "_id": {
      "$oid": "15topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-19"
  },
  {
    "_id": {
      "$oid": "15topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-20"
  },
  {
    "_id": {
      "$oid": "15topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-21"
  },
  {
    "_id": {
      "$oid": "15topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-22"
  },
  {
    "_id": {
      "$oid": "15topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-23"
  },
  {
    "_id": {
      "$oid": "15topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-24"
  },
  {
    "_id": {
      "$oid": "15topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-25"
  },
  {
    "_id": {
      "$oid": "15topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-26"
  },
  {
    "_id": {
      "$oid": "15topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-27"
  },
  {
    "_id": {
      "$oid": "15topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-28"
  },
  {
    "_id": {
      "$oid": "15topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-29"
  },
  {
    "_id": {
      "$oid": "15topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-30"
  },
  {
    "_id": {
      "$oid": "15topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-31"
  },
  {
    "_id": {
      "$oid": "15topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-32"
  },
  {
    "_id": {
      "$oid": "15topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-33"
  },
  {
    "_id": {
      "$oid": "15topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-34"
  },
  {
    "_id": {
      "$oid": "15topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-35"
  },
  {
    "_id": {
      "$oid": "15topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-36"
  },
  {
    "_id": {
      "$oid": "15topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-37"
  },
  {
    "_id": {
      "$oid": "15topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-38"
  },
  {
    "_id": {
      "$oid": "15topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-39"
  },
  {
    "_id": {
      "$oid": "15topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-40"
  },
  {
    "_id": {
      "$oid": "15topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-41"
  },
  {
    "_id": {
      "$oid": "15topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-42"
  },
  {
    "_id": {
      "$oid": "15topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-43"
  },
  {
    "_id": {
      "$oid": "15topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-44"
  },
  {
    "_id": {
      "$oid": "15topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-45"
  },
  {
    "_id": {
      "$oid": "15topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-46"
  },
  {
    "_id": {
      "$oid": "15topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-47"
  },
  {
    "_id": {
      "$oid": "15topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "15-Thermodynamics-48"
  },
    {
    "_id": {
      "$oid": "16topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-01"
  },
  {
    "_id": {
      "$oid": "16topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-02"
  },
  {
    "_id": {
      "$oid": "16topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-03"
  },
  {
    "_id": {
      "$oid": "16topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-04"
  },
  {
    "_id": {
      "$oid": "16topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-05"
  },
  {
    "_id": {
      "$oid": "16topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-06"
  },
  {
    "_id": {
      "$oid": "16topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-07"
  },
  {
    "_id": {
      "$oid": "16topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-08"
  },
  {
    "_id": {
      "$oid": "16topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-09"
  },
  {
    "_id": {
      "$oid": "16topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-10"
  },
  {
    "_id": {
      "$oid": "16topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-11"
  },
  {
    "_id": {
      "$oid": "16topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-12"
  },
  {
    "_id": {
      "$oid": "16topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-13"
  },
  {
    "_id": {
      "$oid": "16topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-14"
  },
  {
    "_id": {
      "$oid": "16topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-15"
  },
  {
    "_id": {
      "$oid": "16topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-16"
  },
  {
    "_id": {
      "$oid": "16topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-17"
  },
  {
    "_id": {
      "$oid": "16topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-18"
  },
  {
    "_id": {
      "$oid": "16topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-19"
  },
  {
    "_id": {
      "$oid": "16topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-20"
  },
  {
    "_id": {
      "$oid": "16topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-21"
  },
  {
    "_id": {
      "$oid": "16topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-22"
  },
  {
    "_id": {
      "$oid": "16topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-23"
  },
  {
    "_id": {
      "$oid": "16topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-24"
  },
  {
    "_id": {
      "$oid": "16topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-25"
  },
  {
    "_id": {
      "$oid": "16topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-26"
  },
  {
    "_id": {
      "$oid": "16topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-27"
  },
  {
    "_id": {
      "$oid": "16topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-28"
  },
  {
    "_id": {
      "$oid": "16topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-29"
  },
  {
    "_id": {
      "$oid": "16topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-30"
  },
  {
    "_id": {
      "$oid": "16topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-31"
  },
  {
    "_id": {
      "$oid": "16topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-32"
  },
  {
    "_id": {
      "$oid": "16topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-33"
  },
  {
    "_id": {
      "$oid": "16topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-34"
  },
  {
    "_id": {
      "$oid": "16topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-35"
  },
  {
    "_id": {
      "$oid": "16topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-36"
  },
  {
    "_id": {
      "$oid": "16topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-37"
  },
  {
    "_id": {
      "$oid": "16topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-38"
  },
  {
    "_id": {
      "$oid": "16topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-39"
  },
  {
    "_id": {
      "$oid": "16topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-40"
  },
  {
    "_id": {
      "$oid": "16topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-41"
  },
  {
    "_id": {
      "$oid": "16topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-42"
  },
  {
    "_id": {
      "$oid": "16topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-43"
  },
  {
    "_id": {
      "$oid": "16topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-44"
  },
  {
    "_id": {
      "$oid": "16topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-45"
  },
  {
    "_id": {
      "$oid": "16topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-46"
  },
  {
    "_id": {
      "$oid": "16topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-47"
  },
  {
    "_id": {
      "$oid": "16topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-48"
  },
  {
    "_id": {
      "$oid": "16topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-49"
  },
  {
    "_id": {
      "$oid": "16topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-50"
  },
  {
    "_id": {
      "$oid": "16topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-51"
  },
  {
    "_id": {
      "$oid": "16topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "16-Simples Harmonic Motion-52"
  },
    {
    "_id": {
      "$oid": "17topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP17",
    "pagename": "17-Waves-01"
  },
  {
    "_id": {
      "$oid": "17topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-02"
  },
  {
    "_id": {
      "$oid": "17topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-03"
  },
  {
    "_id": {
      "$oid": "17topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-04"
  },
  {
    "_id": {
      "$oid": "17topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-05"
  },
  {
    "_id": {
      "$oid": "17topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-06"
  },
  {
    "_id": {
      "$oid": "17topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-07"
  },
  {
    "_id": {
      "$oid": "17topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-08"
  },
  {
    "_id": {
      "$oid": "17topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-09"
  },
  {
    "_id": {
      "$oid": "17topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-10"
  },
  {
    "_id": {
      "$oid": "17topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-11"
  },
  {
    "_id": {
      "$oid": "17topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-12"
  },
  {
    "_id": {
      "$oid": "17topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-13"
  },
  {
    "_id": {
      "$oid": "17topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-14"
  },
  {
    "_id": {
      "$oid": "17topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-15"
  },
  {
    "_id": {
      "$oid": "17topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-16"
  },
  {
    "_id": {
      "$oid": "17topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-17"
  },
  {
    "_id": {
      "$oid": "17topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-18"
  },
  {
    "_id": {
      "$oid": "17topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-19"
  },
  {
    "_id": {
      "$oid": "17topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-20"
  },
  {
    "_id": {
      "$oid": "17topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-21"
  },
  {
    "_id": {
      "$oid": "17topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-22"
  },
  {
    "_id": {
      "$oid": "17topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-23"
  },
  {
    "_id": {
      "$oid": "17topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-24"
  },
  {
    "_id": {
      "$oid": "17topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-25"
  },
  {
    "_id": {
      "$oid": "17topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-26"
  },
  {
    "_id": {
      "$oid": "17topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-27"
  },
  {
    "_id": {
      "$oid": "17topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-28"
  },
  {
    "_id": {
      "$oid": "17topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-29"
  },
  {
    "_id": {
      "$oid": "17topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-30"
  },
  {
    "_id": {
      "$oid": "17topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-31"
  },
  {
    "_id": {
      "$oid": "17topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-32"
  },
  {
    "_id": {
      "$oid": "17topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-33"
  },
  {
    "_id": {
      "$oid": "17topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-34"
  },
  {
    "_id": {
      "$oid": "17topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-35"
  },
  {
    "_id": {
      "$oid": "17topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-36"
  },
  {
    "_id": {
      "$oid": "17topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-37"
  },
  {
    "_id": {
      "$oid": "17topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-38"
  },
  {
    "_id": {
      "$oid": "17topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-39"
  },
  {
    "_id": {
      "$oid": "17topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-40"
  },
  {
    "_id": {
      "$oid": "17topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-41"
  },
  {
    "_id": {
      "$oid": "17topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-42"
  },
  {
    "_id": {
      "$oid": "17topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-43"
  },
  {
    "_id": {
      "$oid": "17topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-44"
  },
  {
    "_id": {
      "$oid": "17topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-45"
  },
  {
    "_id": {
      "$oid": "17topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-46"
  },
  {
    "_id": {
      "$oid": "17topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-47"
  },
  {
    "_id": {
      "$oid": "17topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-48"
  },
  {
    "_id": {
      "$oid": "17topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-49"
  },
  {
    "_id": {
      "$oid": "17topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "17-Waves-50"
  },
    {
    "_id": {
      "$oid": "18topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-01"
  },
  {
    "_id": {
      "$oid": "18topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-02"
  },
  {
    "_id": {
      "$oid": "18topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-03"
  },
  {
    "_id": {
      "$oid": "18topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-04"
  },
  {
    "_id": {
      "$oid": "18topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-05"
  },
  {
    "_id": {
      "$oid": "18topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-06"
  },
  {
    "_id": {
      "$oid": "18topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-07"
  },
  {
    "_id": {
      "$oid": "18topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-08"
  },
  {
    "_id": {
      "$oid": "18topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-09"
  },
  {
    "_id": {
      "$oid": "18topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-10"
  },
  {
    "_id": {
      "$oid": "18topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-11"
  },
  {
    "_id": {
      "$oid": "18topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-12"
  },
  {
    "_id": {
      "$oid": "18topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-13"
  },
  {
    "_id": {
      "$oid": "18topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-14"
  },
  {
    "_id": {
      "$oid": "18topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-15"
  },
  {
    "_id": {
      "$oid": "18topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-16"
  },
  {
    "_id": {
      "$oid": "18topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-17"
  },
  {
    "_id": {
      "$oid": "18topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-18"
  },
  {
    "_id": {
      "$oid": "18topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-19"
  },
  {
    "_id": {
      "$oid": "18topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-20"
  },
  {
    "_id": {
      "$oid": "18topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-21"
  },
  {
    "_id": {
      "$oid": "18topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-22"
  },
  {
    "_id": {
      "$oid": "18topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-23"
  },
  {
    "_id": {
      "$oid": "18topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-24"
  },
  {
    "_id": {
      "$oid": "18topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-25"
  },
  {
    "_id": {
      "$oid": "18topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-26"
  },
  {
    "_id": {
      "$oid": "18topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-27"
  },
  {
    "_id": {
      "$oid": "18topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-28"
  },
  {
    "_id": {
      "$oid": "18topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-29"
  },
  {
    "_id": {
      "$oid": "18topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-30"
  },
  {
    "_id": {
      "$oid": "18topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-31"
  },
  {
    "_id": {
      "$oid": "18topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-32"
  },
  {
    "_id": {
      "$oid": "18topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-33"
  },
  {
    "_id": {
      "$oid": "18topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-34"
  },
  {
    "_id": {
      "$oid": "18topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-35"
  },
  {
    "_id": {
      "$oid": "18topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-36"
  },
  {
    "_id": {
      "$oid": "18topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-37"
  },
  {
    "_id": {
      "$oid": "18topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-38"
  },
  {
    "_id": {
      "$oid": "18topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-39"
  },
  {
    "_id": {
      "$oid": "18topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-40"
  },
  {
    "_id": {
      "$oid": "18topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-41"
  },
  {
    "_id": {
      "$oid": "18topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-42"
  },
  {
    "_id": {
      "$oid": "18topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-43"
  },
  {
    "_id": {
      "$oid": "18topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-44"
  },
  {
    "_id": {
      "$oid": "18topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-45"
  },
  {
    "_id": {
      "$oid": "18topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-46"
  },
  {
    "_id": {
      "$oid": "18topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-47"
  },
  {
    "_id": {
      "$oid": "18topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-48"
  },
  {
    "_id": {
      "$oid": "18topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-49"
  },
  {
    "_id": {
      "$oid": "18topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-50"
  },
  {
    "_id": {
      "$oid": "18topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-51"
  },
  {
    "_id": {
      "$oid": "18topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-52"
  },
  {
    "_id": {
      "$oid": "18topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-53"
  },
  {
    "_id": {
      "$oid": "18topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-54"
  },
  {
    "_id": {
      "$oid": "18topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-55"
  },
  {
    "_id": {
      "$oid": "18topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-56"
  },
  {
    "_id": {
      "$oid": "18topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-57"
  },
  {
    "_id": {
      "$oid": "18topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-58"
  },
  {
    "_id": {
      "$oid": "18topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-59"
  },
  {
    "_id": {
      "$oid": "18topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-60"
  },
  {
    "_id": {
      "$oid": "18topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-61"
  },
  {
    "_id": {
      "$oid": "18topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-62"
  },
  {
    "_id": {
      "$oid": "18topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-63"
  },
  {
    "_id": {
      "$oid": "18topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-64"
  },
  {
    "_id": {
      "$oid": "18topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-65"
  },
  {
    "_id": {
      "$oid": "18topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-66"
  },
  {
    "_id": {
      "$oid": "18topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-67"
  },
  {
    "_id": {
      "$oid": "18topernotephy68"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-68"
  },
  {
    "_id": {
      "$oid": "18topernotephy69"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-69"
  },
  {
    "_id": {
      "$oid": "18topernotephy70"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-70"
  },
    {
    "_id": {
      "$oid": "18topernotephy71"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-71"
  },
  {
    "_id": {
      "$oid": "18topernotephy72"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-72"
  },
  {
    "_id": {
      "$oid": "18topernotephy73"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-73"
  },
  {
    "_id": {
      "$oid": "18topernotephy74"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-74"
  },
  {
    "_id": {
      "$oid": "18topernotephy75"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "18-Electric Charges of Fields-75"
  },


  {
    "_id": {
      "$oid": "19topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-001"
  },
  {
    "_id": {
      "$oid": "19topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-002"
  },
  {
    "_id": {
      "$oid": "19topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-003"
  },
  {
    "_id": {
      "$oid": "19topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-004"
  },
  {
    "_id": {
      "$oid": "19topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-005"
  },
  {
    "_id": {
      "$oid": "19topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-006"
  },
  {
    "_id": {
      "$oid": "19topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-007"
  },
  {
    "_id": {
      "$oid": "19topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-008"
  },
  {
    "_id": {
      "$oid": "19topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-009"
  },
  {
    "_id": {
      "$oid": "19topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-010"
  },
  {
    "_id": {
      "$oid": "19topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-011"
  },
  {
    "_id": {
      "$oid": "19topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-012"
  },
  {
    "_id": {
      "$oid": "19topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-013"
  },
  {
    "_id": {
      "$oid": "19topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-014"
  },
  {
    "_id": {
      "$oid": "19topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-015"
  },
  {
    "_id": {
      "$oid": "19topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-016"
  },
  {
    "_id": {
      "$oid": "19topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-017"
  },
  {
    "_id": {
      "$oid": "19topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-018"
  },
  {
    "_id": {
      "$oid": "19topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-019"
  },
  {
    "_id": {
      "$oid": "19topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-020"
  },
  {
    "_id": {
      "$oid": "19topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-021"
  },
  {
    "_id": {
      "$oid": "19topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-022"
  },
  {
    "_id": {
      "$oid": "19topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-023"
  },
  {
    "_id": {
      "$oid": "19topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-024"
  },
  {
    "_id": {
      "$oid": "19topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-025"
  },
  {
    "_id": {
      "$oid": "19topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-026"
  },
  {
    "_id": {
      "$oid": "19topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-027"
  },
  {
    "_id": {
      "$oid": "19topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-028"
  },
  {
    "_id": {
      "$oid": "19topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-029"
  },
  {
    "_id": {
      "$oid": "19topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-030"
  },
  {
    "_id": {
      "$oid": "19topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-031"
  },
  {
    "_id": {
      "$oid": "19topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-032"
  },
  {
    "_id": {
      "$oid": "19topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-033"
  },
  {
    "_id": {
      "$oid": "19topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-034"
  },
  {
    "_id": {
      "$oid": "19topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-035"
  },
  {
    "_id": {
      "$oid": "19topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-036"
  },
  {
    "_id": {
      "$oid": "19topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-037"
  },
  {
    "_id": {
      "$oid": "19topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-038"
  },
  {
    "_id": {
      "$oid": "19topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-039"
  },
  {
    "_id": {
      "$oid": "19topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-040"
  },
  {
    "_id": {
      "$oid": "19topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-041"
  },
  {
    "_id": {
      "$oid": "19topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-042"
  },
  {
    "_id": {
      "$oid": "19topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-043"
  },
  {
    "_id": {
      "$oid": "19topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-044"
  },
  {
    "_id": {
      "$oid": "19topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-045"
  },
  {
    "_id": {
      "$oid": "19topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-046"
  },
  {
    "_id": {
      "$oid": "19topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-047"
  },
  {
    "_id": {
      "$oid": "19topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-048"
  },
  {
    "_id": {
      "$oid": "19topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-049"
  },
  {
    "_id": {
      "$oid": "19topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-050"
  },
  {
    "_id": {
      "$oid": "19topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-051"
  },
  {
    "_id": {
      "$oid": "19topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-052"
  },
  {
    "_id": {
      "$oid": "19topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-053"
  },
  {
    "_id": {
      "$oid": "19topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-054"
  },
  {
    "_id": {
      "$oid": "19topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-055"
  },
  {
    "_id": {
      "$oid": "19topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-056"
  },
  {
    "_id": {
      "$oid": "19topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-057"
  },
  {
    "_id": {
      "$oid": "19topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-058"
  },
  {
    "_id": {
      "$oid": "19topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-059"
  },
  {
    "_id": {
      "$oid": "19topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-060"
  },
  {
    "_id": {
      "$oid": "19topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-061"
  },
  {
    "_id": {
      "$oid": "19topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-062"
  },
  {
    "_id": {
      "$oid": "19topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-063"
  },
  {
    "_id": {
      "$oid": "19topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-064"
  },
  {
    "_id": {
      "$oid": "19topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-065"
  },
  {
    "_id": {
      "$oid": "19topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-066"
  },
  {
    "_id": {
      "$oid": "19topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-067"
  },
  {
    "_id": {
      "$oid": "19topernotephy68"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-068"
  },
  {
    "_id": {
      "$oid": "19topernotephy69"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-069"
  },
  {
    "_id": {
      "$oid": "19topernotephy70"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-070"
  },
  {
    "_id": {
      "$oid": "19topernotephy71"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-071"
  },
  {
    "_id": {
      "$oid": "19topernotephy72"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-072"
  },
  {
    "_id": {
      "$oid": "19topernotephy73"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-073"
  },
  {
    "_id": {
      "$oid": "19topernotephy74"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-074"
  },
  {
    "_id": {
      "$oid": "19topernotephy75"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-075"
  },
  {
    "_id": {
      "$oid": "19topernotephy76"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-076"
  },
  {
    "_id": {
      "$oid": "19topernotephy77"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-077"
  },
  {
    "_id": {
      "$oid": "19topernotephy78"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-078"
  },
  {
    "_id": {
      "$oid": "19topernotephy79"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-079"
  },
  {
    "_id": {
      "$oid": "19topernotephy80"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-080"
  },
  {
    "_id": {
      "$oid": "19topernotephy81"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-081"
  },
  {
    "_id": {
      "$oid": "19topernotephy82"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-082"
  },
  {
    "_id": {
      "$oid": "19topernotephy83"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-083"
  },
  {
    "_id": {
      "$oid": "19topernotephy84"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-084"
  },
  {
    "_id": {
      "$oid": "19topernotephy85"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-085"
  },
  {
    "_id": {
      "$oid": "19topernotephy86"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-086"
  },
  {
    "_id": {
      "$oid": "19topernotephy87"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-087"
  },
  {
    "_id": {
      "$oid": "19topernotephy88"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-088"
  },
  {
    "_id": {
      "$oid": "19topernotephy89"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-089"
  },
  {
    "_id": {
      "$oid": "19topernotephy90"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-090"
  },
  {
    "_id": {
      "$oid": "19topernotephy91"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-091"
  },
  {
    "_id": {
      "$oid": "19topernotephy92"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-092"
  },
  {
    "_id": {
      "$oid": "19topernotephy93"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-093"
  },
  {
    "_id": {
      "$oid": "19topernotephy94"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-094"
  },
  {
    "_id": {
      "$oid": "19topernotephy95"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-095"
  },
  {
    "_id": {
      "$oid": "19topernotephy96"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-096"
  },
  {
    "_id": {
      "$oid": "19topernotephy97"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-097"
  },
  {
    "_id": {
      "$oid": "19topernotephy98"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-098"
  },
  {
    "_id": {
      "$oid": "19topernotephy99"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-099"
  },
        {
    "_id": {
      "$oid": "19topernotephy100"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-100"
  },
  {
    "_id": {
      "$oid": "19topernotephy101"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-101"
  },
  {
    "_id": {
      "$oid": "19topernotephy102"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-102"
  },
  {
    "_id": {
      "$oid": "19topernotephy103"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-103"
  },
  {
    "_id": {
      "$oid": "19topernotephy104"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-104"
  },
  {
    "_id": {
      "$oid": "19topernotephy105"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-105"
  },
  {
    "_id": {
      "$oid": "19topernotephy106"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-106"
  },
  {
    "_id": {
      "$oid": "19topernotephy107"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-107"
  },
  {
    "_id": {
      "$oid": "19topernotephy108"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-108"
  },
  {
    "_id": {
      "$oid": "19topernotephy109"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-109"
  },
  {
    "_id": {
      "$oid": "19topernotephy110"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-110"
  },
  {
    "_id": {
      "$oid": "19topernotephy111"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-111"
  },
  {
    "_id": {
      "$oid": "19topernotephy112"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-112"
  },
  {
    "_id": {
      "$oid": "19topernotephy113"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-113"
  },
  {
    "_id": {
      "$oid": "19topernotephy114"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-114"
  },
  {
    "_id": {
      "$oid": "19topernotephy115"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-115"
  },
  {
    "_id": {
      "$oid": "19topernotephy116"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-116"
  },
  {
    "_id": {
      "$oid": "19topernotephy117"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-117"
  },
  {
    "_id": {
      "$oid": "19topernotephy118"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-118"
  },
  {
    "_id": {
      "$oid": "19topernotephy119"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-119"
  },
  {
    "_id": {
      "$oid": "19topernotephy120"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-120"
  },
  {
    "_id": {
      "$oid": "19topernotephy121"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-121"
  },
  {
    "_id": {
      "$oid": "19topernotephy122"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-122"
  },
  {
    "_id": {
      "$oid": "19topernotephy123"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-123"
  },
  {
    "_id": {
      "$oid": "19topernotephy124"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-124"
  },
  {
    "_id": {
      "$oid": "19topernotephy125"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-125"
  },
  {
    "_id": {
      "$oid": "19topernotephy126"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-126"
  },
  {
    "_id": {
      "$oid": "19topernotephy127"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-127"
  },
  {
    "_id": {
      "$oid": "19topernotephy128"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-128"
  },
  {
    "_id": {
      "$oid": "19topernotephy129"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-129"
  },
  {
    "_id": {
      "$oid": "19topernotephy130"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-130"
  },
  {
    "_id": {
      "$oid": "19topernotephy131"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-131"
  },
  {
    "_id": {
      "$oid": "19topernotephy132"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-132"
  },
  {
    "_id": {
      "$oid": "19topernotephy133"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-133"
  },
  {
    "_id": {
      "$oid": "19topernotephy134"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-134"
  },
  {
    "_id": {
      "$oid": "19topernotephy135"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-135"
  },
  {
    "_id": {
      "$oid": "19topernotephy136"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-136"
  },
  {
    "_id": {
      "$oid": "19topernotephy137"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-137"
  },
  {
    "_id": {
      "$oid": "19topernotephy138"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-138"
  },
  {
    "_id": {
      "$oid": "19topernotephy139"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-139"
  },
  {
    "_id": {
      "$oid": "19topernotephy140"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-140"
  },
  {
    "_id": {
      "$oid": "19topernotephy141"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-141"
  },
  {
    "_id": {
      "$oid": "19topernotephy142"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-142"
  },
  {
    "_id": {
      "$oid": "19topernotephy143"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-143"
  },
  {
    "_id": {
      "$oid": "19topernotephy144"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-144"
  },
  {
    "_id": {
      "$oid": "19topernotephy145"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-145"
  },
  {
    "_id": {
      "$oid": "19topernotephy146"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-146"
  },
  {
    "_id": {
      "$oid": "19topernotephy147"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-147"
  },
  {
    "_id": {
      "$oid": "19topernotephy148"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-148"
  },
  {
    "_id": {
      "$oid": "19topernotephy149"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-149"
  },
  {
    "_id": {
      "$oid": "19topernotephy150"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-150"
  },
  {
    "_id": {
      "$oid": "19topernotephy151"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-151"
  },
  {
    "_id": {
      "$oid": "19topernotephy152"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-152"
  },
  {
    "_id": {
      "$oid": "19topernotephy153"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-153"
  },
  {
    "_id": {
      "$oid": "19topernotephy154"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-154"
  },
  {
    "_id": {
      "$oid": "19topernotephy155"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-155"
  },
  {
    "_id": {
      "$oid": "19topernotephy156"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-156"
  },
  {
    "_id": {
      "$oid": "19topernotephy157"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-157"
  },
  {
    "_id": {
      "$oid": "19topernotephy158"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-158"
  },
  {
    "_id": {
      "$oid": "19topernotephy159"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "19-Electric Potential and Capacitance-159"
  },


      {
    "_id": {
      "$oid": "20topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP20",
    "pagename": "20-Current Electricity-01"
  },
  {
    "_id": {
      "$oid": "20topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-02"
  },
  {
    "_id": {
      "$oid": "20topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-03"
  },
  {
    "_id": {
      "$oid": "20topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-04"
  },
  {
    "_id": {
      "$oid": "20topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-05"
  },
  {
    "_id": {
      "$oid": "20topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-06"
  },
  {
    "_id": {
      "$oid": "20topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-07"
  },
  {
    "_id": {
      "$oid": "20topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-08"
  },
  {
    "_id": {
      "$oid": "20topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-09"
  },
  {
    "_id": {
      "$oid": "20topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-10"
  },
  {
    "_id": {
      "$oid": "20topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-11"
  },
  {
    "_id": {
      "$oid": "20topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-12"
  },
  {
    "_id": {
      "$oid": "20topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-13"
  },
  {
    "_id": {
      "$oid": "20topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-14"
  },
  {
    "_id": {
      "$oid": "20topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-15"
  },
  {
    "_id": {
      "$oid": "20topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-16"
  },
  {
    "_id": {
      "$oid": "20topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-17"
  },
  {
    "_id": {
      "$oid": "20topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-18"
  },
  {
    "_id": {
      "$oid": "20topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-19"
  },
  {
    "_id": {
      "$oid": "20topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-20"
  },
  {
    "_id": {
      "$oid": "20topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-21"
  },
  {
    "_id": {
      "$oid": "20topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-22"
  },
  {
    "_id": {
      "$oid": "20topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-23"
  },
  {
    "_id": {
      "$oid": "20topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-24"
  },
  {
    "_id": {
      "$oid": "20topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-25"
  },
  {
    "_id": {
      "$oid": "20topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-26"
  },
  {
    "_id": {
      "$oid": "20topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-27"
  },
  {
    "_id": {
      "$oid": "20topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-28"
  },
  {
    "_id": {
      "$oid": "20topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-29"
  },
  {
    "_id": {
      "$oid": "20topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-30"
  },
  {
    "_id": {
      "$oid": "20topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-31"
  },
  {
    "_id": {
      "$oid": "20topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-32"
  },
  {
    "_id": {
      "$oid": "20topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-33"
  },
  {
    "_id": {
      "$oid": "20topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-34"
  },
  {
    "_id": {
      "$oid": "20topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-35"
  },
  {
    "_id": {
      "$oid": "20topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-36"
  },
  {
    "_id": {
      "$oid": "20topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-37"
  },
  {
    "_id": {
      "$oid": "20topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-38"
  },
  {
    "_id": {
      "$oid": "20topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-39"
  },
  {
    "_id": {
      "$oid": "20topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-40"
  },
  {
    "_id": {
      "$oid": "20topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-41"
  },
  {
    "_id": {
      "$oid": "20topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-42"
  },
  {
    "_id": {
      "$oid": "20topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-43"
  },
  {
    "_id": {
      "$oid": "20topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-44"
  },
  {
    "_id": {
      "$oid": "20topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-45"
  },
  {
    "_id": {
      "$oid": "20topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-46"
  },
  {
    "_id": {
      "$oid": "20topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-47"
  },
  {
    "_id": {
      "$oid": "20topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-48"
  },
  {
    "_id": {
      "$oid": "20topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-49"
  },
  {
    "_id": {
      "$oid": "20topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-50"
  },
  {
    "_id": {
      "$oid": "20topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-51"
  },
  {
    "_id": {
      "$oid": "20topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-52"
  },
  {
    "_id": {
      "$oid": "20topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-53"
  },
  {
    "_id": {
      "$oid": "20topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-54"
  },
  {
    "_id": {
      "$oid": "20topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-55"
  },
  {
    "_id": {
      "$oid": "20topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-56"
  },
  {
    "_id": {
      "$oid": "20topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-57"
  },
  {
    "_id": {
      "$oid": "20topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-58"
  },
  {
    "_id": {
      "$oid": "20topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-59"
  },
  {
    "_id": {
      "$oid": "20topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-60"
  },
  {
    "_id": {
      "$oid": "20topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-61"
  },
  {
    "_id": {
      "$oid": "20topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-62"
  },
  {
    "_id": {
      "$oid": "20topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-63"
  },
  {
    "_id": {
      "$oid": "20topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-64"
  },
  {
    "_id": {
      "$oid": "20topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-65"
  },
  {
    "_id": {
      "$oid": "20topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-66"
  },
  {
    "_id": {
      "$oid": "20topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-67"
  },
  {
    "_id": {
      "$oid": "20topernotephy68"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-68"
  },
  {
    "_id": {
      "$oid": "20topernotephy69"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-69"
  },
  {
    "_id": {
      "$oid": "20topernotephy70"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-70"
  },
    {
    "_id": {
      "$oid": "20topernotephy71"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-71"
  },
  {
    "_id": {
      "$oid": "20topernotephy72"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-72"
  },
  {
    "_id": {
      "$oid": "20topernotephy73"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-73"
  },
  {
    "_id": {
      "$oid": "20topernotephy74"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-74"
  },
  {
    "_id": {
      "$oid": "20topernotephy75"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-75"
  },
  {
    "_id": {
      "$oid": "20topernotephy76"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-76"
  },
  {
    "_id": {
      "$oid": "20topernotephy77"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-77"
  },
  {
    "_id": {
      "$oid": "20topernotephy78"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-78"
  },
  {
    "_id": {
      "$oid": "20topernotephy79"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "20-Current Electricity-79"
  },
    {
    "_id": {
      "$oid": "21topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-01"
  },
  {
    "_id": {
      "$oid": "21topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-02"
  },
  {
    "_id": {
      "$oid": "21topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-03"
  },
  {
    "_id": {
      "$oid": "21topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-04"
  },
  {
    "_id": {
      "$oid": "21topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-05"
  },
  {
    "_id": {
      "$oid": "21topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-06"
  },
  {
    "_id": {
      "$oid": "21topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-07"
  },
  {
    "_id": {
      "$oid": "21topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-08"
  },
  {
    "_id": {
      "$oid": "21topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-09"
  },
  {
    "_id": {
      "$oid": "21topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-10"
  },
  {
    "_id": {
      "$oid": "21topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-11"
  },
  {
    "_id": {
      "$oid": "21topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-12"
  },
  {
    "_id": {
      "$oid": "21topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-13"
  },
  {
    "_id": {
      "$oid": "21topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-14"
  },
  {
    "_id": {
      "$oid": "21topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-15"
  },
  {
    "_id": {
      "$oid": "21topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-16"
  },
  {
    "_id": {
      "$oid": "21topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-17"
  },
  {
    "_id": {
      "$oid": "21topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-18"
  },
  {
    "_id": {
      "$oid": "21topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-19"
  },
  {
    "_id": {
      "$oid": "21topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-20"
  },
  {
    "_id": {
      "$oid": "21topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-21"
  },
  {
    "_id": {
      "$oid": "21topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-22"
  },
  {
    "_id": {
      "$oid": "21topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-23"
  },
  {
    "_id": {
      "$oid": "21topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-24"
  },
  {
    "_id": {
      "$oid": "21topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-25"
  },
  {
    "_id": {
      "$oid": "21topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-26"
  },
  {
    "_id": {
      "$oid": "21topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-27"
  },
  {
    "_id": {
      "$oid": "21topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-28"
  },
  {
    "_id": {
      "$oid": "21topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-29"
  },
  {
    "_id": {
      "$oid": "21topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-30"
  },
  {
    "_id": {
      "$oid": "21topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-31"
  },
  {
    "_id": {
      "$oid": "21topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-32"
  },
  {
    "_id": {
      "$oid": "21topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-33"
  },
  {
    "_id": {
      "$oid": "21topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-34"
  },
  {
    "_id": {
      "$oid": "21topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-35"
  },
  {
    "_id": {
      "$oid": "21topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-36"
  },
  {
    "_id": {
      "$oid": "21topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-37"
  },
  {
    "_id": {
      "$oid": "21topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-38"
  },
  {
    "_id": {
      "$oid": "21topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-39"
  },
  {
    "_id": {
      "$oid": "21topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-40"
  },
  {
    "_id": {
      "$oid": "21topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-41"
  },
  {
    "_id": {
      "$oid": "21topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-42"
  },
  {
    "_id": {
      "$oid": "21topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-43"
  },
  {
    "_id": {
      "$oid": "21topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-44"
  },
  {
    "_id": {
      "$oid": "21topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-45"
  },
  {
    "_id": {
      "$oid": "21topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-46"
  },
  {
    "_id": {
      "$oid": "21topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-47"
  },
  {
    "_id": {
      "$oid": "21topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "21-Moving Charges  Magnetism-48"
  },
    {
    "_id": {
      "$oid": "22topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-01"
  },
  {
    "_id": {
      "$oid": "22topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-02"
  },
  {
    "_id": {
      "$oid": "22topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-03"
  },
  {
    "_id": {
      "$oid": "22topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-04"
  },
  {
    "_id": {
      "$oid": "22topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-05"
  },
  {
    "_id": {
      "$oid": "22topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-06"
  },
  {
    "_id": {
      "$oid": "22topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-07"
  },
  {
    "_id": {
      "$oid": "22topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-08"
  },
  {
    "_id": {
      "$oid": "22topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-09"
  },
  {
    "_id": {
      "$oid": "22topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-10"
  },
  {
    "_id": {
      "$oid": "22topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-11"
  },
  {
    "_id": {
      "$oid": "22topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-12"
  },
  {
    "_id": {
      "$oid": "22topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-13"
  },
  {
    "_id": {
      "$oid": "22topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-14"
  },
  {
    "_id": {
      "$oid": "22topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-15"
  },
  {
    "_id": {
      "$oid": "22topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-16"
  },
  {
    "_id": {
      "$oid": "22topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-17"
  },
  {
    "_id": {
      "$oid": "22topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-18"
  },
  {
    "_id": {
      "$oid": "22topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-19"
  },
  {
    "_id": {
      "$oid": "22topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-20"
  },
  {
    "_id": {
      "$oid": "22topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-21"
  },
  {
    "_id": {
      "$oid": "22topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-22"
  },
  {
    "_id": {
      "$oid": "22topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-23"
  },
  {
    "_id": {
      "$oid": "22topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-24"
  },
  {
    "_id": {
      "$oid": "22topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-25"
  },
  {
    "_id": {
      "$oid": "22topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-26"
  },
  {
    "_id": {
      "$oid": "22topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-27"
  },
  {
    "_id": {
      "$oid": "22topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-28"
  },
  {
    "_id": {
      "$oid": "22topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-29"
  },
  {
    "_id": {
      "$oid": "22topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-30"
  },
  {
    "_id": {
      "$oid": "22topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-31"
  },
  {
    "_id": {
      "$oid": "22topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-32"
  },
  {
    "_id": {
      "$oid": "22topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-33"
  },
  {
    "_id": {
      "$oid": "22topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-34"
  },
  {
    "_id": {
      "$oid": "22topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-35"
  },
  {
    "_id": {
      "$oid": "22topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-36"
  },
  {
    "_id": {
      "$oid": "22topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-37"
  },
  {
    "_id": {
      "$oid": "22topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-38"
  },
  {
    "_id": {
      "$oid": "22topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-39"
  },
  {
    "_id": {
      "$oid": "22topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-40"
  },
  {
    "_id": {
      "$oid": "22topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-41"
  },
  {
    "_id": {
      "$oid": "22topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-42"
  },
  {
    "_id": {
      "$oid": "22topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-43"
  },
  {
    "_id": {
      "$oid": "22topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-44"
  },
  {
    "_id": {
      "$oid": "22topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-45"
  },
  {
    "_id": {
      "$oid": "22topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-46"
  },
  {
    "_id": {
      "$oid": "22topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "22-Magnetism  Matter-47"
  },
    {
    "_id": {
      "$oid": "23topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-01"
  },
  {
    "_id": {
      "$oid": "23topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-02"
  },
  {
    "_id": {
      "$oid": "23topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-03"
  },
  {
    "_id": {
      "$oid": "23topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-04"
  },
  {
    "_id": {
      "$oid": "23topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-05"
  },
  {
    "_id": {
      "$oid": "23topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-06"
  },
  {
    "_id": {
      "$oid": "23topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-07"
  },
  {
    "_id": {
      "$oid": "23topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-08"
  },
  {
    "_id": {
      "$oid": "23topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-09"
  },
  {
    "_id": {
      "$oid": "23topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-10"
  },
  {
    "_id": {
      "$oid": "23topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-11"
  },
  {
    "_id": {
      "$oid": "23topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-12"
  },
  {
    "_id": {
      "$oid": "23topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-13"
  },
  {
    "_id": {
      "$oid": "23topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-14"
  },
  {
    "_id": {
      "$oid": "23topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-15"
  },
  {
    "_id": {
      "$oid": "23topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-16"
  },
  {
    "_id": {
      "$oid": "23topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-17"
  },
  {
    "_id": {
      "$oid": "23topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-18"
  },
  {
    "_id": {
      "$oid": "23topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-19"
  },
  {
    "_id": {
      "$oid": "23topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-20"
  },
  {
    "_id": {
      "$oid": "23topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-21"
  },
  {
    "_id": {
      "$oid": "23topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-22"
  },
  {
    "_id": {
      "$oid": "23topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-23"
  },
  {
    "_id": {
      "$oid": "23topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-24"
  },
  {
    "_id": {
      "$oid": "23topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-25"
  },
  {
    "_id": {
      "$oid": "23topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-26"
  },
  {
    "_id": {
      "$oid": "23topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-27"
  },
  {
    "_id": {
      "$oid": "23topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-28"
  },
  {
    "_id": {
      "$oid": "23topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-29"
  },
  {
    "_id": {
      "$oid": "23topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-30"
  },
  {
    "_id": {
      "$oid": "23topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-31"
  },
  {
    "_id": {
      "$oid": "23topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-32"
  },
  {
    "_id": {
      "$oid": "23topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-33"
  },
  {
    "_id": {
      "$oid": "23topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-34"
  },
  {
    "_id": {
      "$oid": "23topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-35"
  },
  {
    "_id": {
      "$oid": "23topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-36"
  },
  {
    "_id": {
      "$oid": "23topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-37"
  },
  {
    "_id": {
      "$oid": "23topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-38"
  },
  {
    "_id": {
      "$oid": "23topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-39"
  },
  {
    "_id": {
      "$oid": "23topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-40"
  },
  {
    "_id": {
      "$oid": "23topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-41"
  },
  {
    "_id": {
      "$oid": "23topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-42"
  },
  {
    "_id": {
      "$oid": "23topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-43"
  },
  {
    "_id": {
      "$oid": "23topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-44"
  },
  {
    "_id": {
      "$oid": "23topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-45"
  },
  {
    "_id": {
      "$oid": "23topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-46"
  },
  {
    "_id": {
      "$oid": "23topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-47"
  },
  {
    "_id": {
      "$oid": "23topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-48"
  },
  {
    "_id": {
      "$oid": "23topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-49"
  },
  {
    "_id": {
      "$oid": "23topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-50"
  },
  {
    "_id": {
      "$oid": "23topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-51"
  },
  {
    "_id": {
      "$oid": "23topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-52"
  },
  {
    "_id": {
      "$oid": "23topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-53"
  },
  {
    "_id": {
      "$oid": "23topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-54"
  },
  {
    "_id": {
      "$oid": "23topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-55"
  },
  {
    "_id": {
      "$oid": "23topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-56"
  },
  {
    "_id": {
      "$oid": "23topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-57"
  },
  {
    "_id": {
      "$oid": "23topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-58"
  },
  {
    "_id": {
      "$oid": "23topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-59"
  },
  {
    "_id": {
      "$oid": "23topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-60"
  },
  {
    "_id": {
      "$oid": "23topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-61"
  },
  {
    "_id": {
      "$oid": "23topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-62"
  },
  {
    "_id": {
      "$oid": "23topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-63"
  },
  {
    "_id": {
      "$oid": "23topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-64"
  },
  {
    "_id": {
      "$oid": "23topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-65"
  },
  {
    "_id": {
      "$oid": "23topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-66"
  },
  {
    "_id": {
      "$oid": "23topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-67"
  },
  {
    "_id": {
      "$oid": "23topernotephy68"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-68"
  },
  {
    "_id": {
      "$oid": "23topernotephy69"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-69"
  },
  {
    "_id": {
      "$oid": "23topernotephy70"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-70"
  },
    {
    "_id": {
      "$oid": "23topernotephy71"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-71"
  },
  {
    "_id": {
      "$oid": "23topernotephy72"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-72"
  },
  {
    "_id": {
      "$oid": "23topernotephy73"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-73"
  },
  {
    "_id": {
      "$oid": "23topernotephy74"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-74"
  },
  {
    "_id": {
      "$oid": "23topernotephy75"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-75"
  },
  {
    "_id": {
      "$oid": "23topernotephy76"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-76"
  },
  {
    "_id": {
      "$oid": "23topernotephy77"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-77"
  },
  {
    "_id": {
      "$oid": "23topernotephy78"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-78"
  },
  {
    "_id": {
      "$oid": "23topernotephy79"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-79"
  },
  {
    "_id": {
      "$oid": "23topernotephy80"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-80"
  },
   {
    "_id": {
      "$oid": "23topernotephy81"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-81"
  },
{
    "_id": {
      "$oid": "23topernotephy82"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-82"
  },
{
    "_id": {
      "$oid": "23topernotephy83"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-83"
  },
{
    "_id": {
      "$oid": "23topernotephy84"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-84"
  },
{
    "_id": {
      "$oid": "23topernotephy85"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-85"
  },
{
    "_id": {
      "$oid": "23topernotephy86"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-86"
  },
{
    "_id": {
      "$oid": "23topernotephy87"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-87"
  },
{
    "_id": {
      "$oid": "23topernotephy88"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "23-Electromagnetic Induction-88"
  },
    {
    "_id": {
      "$oid": "24topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP24",
    "pagename": "24-Alternating Current-01"
  },
  {
    "_id": {
      "$oid": "24topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-02"
  },
  {
    "_id": {
      "$oid": "24topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-03"
  },
  {
    "_id": {
      "$oid": "24topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-04"
  },
  {
    "_id": {
      "$oid": "24topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-05"
  },
  {
    "_id": {
      "$oid": "24topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-06"
  },
  {
    "_id": {
      "$oid": "24topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-07"
  },
  {
    "_id": {
      "$oid": "24topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-08"
  },
  {
    "_id": {
      "$oid": "24topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-09"
  },
  {
    "_id": {
      "$oid": "24topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-10"
  },
  {
    "_id": {
      "$oid": "24topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-11"
  },
  {
    "_id": {
      "$oid": "24topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-12"
  },
  {
    "_id": {
      "$oid": "24topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-13"
  },
  {
    "_id": {
      "$oid": "24topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-14"
  },
  {
    "_id": {
      "$oid": "24topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-15"
  },
  {
    "_id": {
      "$oid": "24topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-16"
  },
  {
    "_id": {
      "$oid": "24topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-17"
  },
  {
    "_id": {
      "$oid": "24topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-18"
  },
  {
    "_id": {
      "$oid": "24topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-19"
  },
  {
    "_id": {
      "$oid": "24topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-20"
  },
  {
    "_id": {
      "$oid": "24topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-21"
  },
  {
    "_id": {
      "$oid": "24topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-22"
  },
  {
    "_id": {
      "$oid": "24topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-23"
  },
  {
    "_id": {
      "$oid": "24topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-24"
  },
  {
    "_id": {
      "$oid": "24topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-25"
  },
  {
    "_id": {
      "$oid": "24topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-26"
  },
  {
    "_id": {
      "$oid": "24topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-27"
  },
  {
    "_id": {
      "$oid": "24topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-28"
  },
  {
    "_id": {
      "$oid": "24topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-29"
  },
  {
    "_id": {
      "$oid": "24topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-30"
  },
  {
    "_id": {
      "$oid": "24topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-31"
  },
  {
    "_id": {
      "$oid": "24topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-32"
  },
  {
    "_id": {
      "$oid": "24topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-33"
  },
  {
    "_id": {
      "$oid": "24topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-34"
  },
  {
    "_id": {
      "$oid": "24topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-35"
  },
  {
    "_id": {
      "$oid": "24topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-36"
  },
  {
    "_id": {
      "$oid": "24topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-37"
  },
  {
    "_id": {
      "$oid": "24topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-38"
  },
  {
    "_id": {
      "$oid": "24topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-39"
  },
  {
    "_id": {
      "$oid": "24topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-40"
  },
  {
    "_id": {
      "$oid": "24topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-41"
  },
  {
    "_id": {
      "$oid": "24topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-42"
  },
  {
    "_id": {
      "$oid": "24topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-43"
  },
  {
    "_id": {
      "$oid": "24topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-44"
  },
  {
    "_id": {
      "$oid": "24topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-45"
  },
  {
    "_id": {
      "$oid": "24topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-46"
  },
  {
    "_id": {
      "$oid": "24topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-47"
  },
  {
    "_id": {
      "$oid": "24topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-48"
  },
  {
    "_id": {
      "$oid": "24topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-49"
  },
  {
    "_id": {
      "$oid": "24topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-50"
  },
  {
    "_id": {
      "$oid": "24topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-51"
  },
  {
    "_id": {
      "$oid": "24topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-52"
  },
  {
    "_id": {
      "$oid": "24topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-53"
  },
  {
    "_id": {
      "$oid": "24topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-54"
  },
  {
    "_id": {
      "$oid": "24topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-55"
  },
  {
    "_id": {
      "$oid": "24topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-56"
  },
  {
    "_id": {
      "$oid": "24topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-57"
  },
  {
    "_id": {
      "$oid": "24topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-58"
  },
  {
    "_id": {
      "$oid": "24topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-59"
  },
  {
    "_id": {
      "$oid": "24topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-60"
  },
  {
    "_id": {
      "$oid": "24topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-61"
  },
  {
    "_id": {
      "$oid": "24topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-62"
  },
  {
    "_id": {
      "$oid": "24topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-63"
  },
  {
    "_id": {
      "$oid": "24topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-64"
  },
  {
    "_id": {
      "$oid": "24topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-65"
  },
  {
    "_id": {
      "$oid": "24topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-66"
  },
  {
    "_id": {
      "$oid": "24topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-67"
  },
  {
    "_id": {
      "$oid": "24topernotephy68"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-68"
  },
  {
    "_id": {
      "$oid": "24topernotephy69"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-69"
  },
  {
    "_id": {
      "$oid": "24topernotephy70"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-70"
  },
    {
    "_id": {
      "$oid": "24topernotephy71"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-71"
  },
  {
    "_id": {
      "$oid": "24topernotephy72"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "24-Alternating Current-72"
  },
    {
    "_id": {
      "$oid": "25topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-01"
  },
  {
    "_id": {
      "$oid": "25topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-02"
  },
  {
    "_id": {
      "$oid": "25topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-03"
  },
  {
    "_id": {
      "$oid": "25topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-04"
  },
  {
    "_id": {
      "$oid": "25topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-05"
  },
  {
    "_id": {
      "$oid": "25topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-06"
  },
  {
    "_id": {
      "$oid": "25topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-07"
  },
  {
    "_id": {
      "$oid": "25topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-08"
  },
  {
    "_id": {
      "$oid": "25topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-09"
  },
  {
    "_id": {
      "$oid": "25topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-10"
  },
  {
    "_id": {
      "$oid": "25topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-11"
  },
  {
    "_id": {
      "$oid": "25topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-12"
  },
  {
    "_id": {
      "$oid": "25topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-13"
  },
  {
    "_id": {
      "$oid": "25topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-14"
  },
  {
    "_id": {
      "$oid": "25topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-15"
  },
  {
    "_id": {
      "$oid": "25topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-16"
  },
  {
    "_id": {
      "$oid": "25topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-17"
  },
  {
    "_id": {
      "$oid": "25topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-18"
  },
  {
    "_id": {
      "$oid": "25topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-19"
  },
  {
    "_id": {
      "$oid": "25topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-20"
  },
  {
    "_id": {
      "$oid": "25topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-21"
  },
  {
    "_id": {
      "$oid": "25topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-22"
  },
  {
    "_id": {
      "$oid": "25topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-23"
  },
  {
    "_id": {
      "$oid": "25topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "25-Electromagnatic Waves-24"
  },
    {
    "_id": {
      "$oid": "26topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP26",
    "pagename": "26-Ray Optics-001"
  },
  {
    "_id": {
      "$oid": "26topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-002"
  },
  {
    "_id": {
      "$oid": "26topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-003"
  },
  {
    "_id": {
      "$oid": "26topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-004"
  },
  {
    "_id": {
      "$oid": "26topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-005"
  },
  {
    "_id": {
      "$oid": "26topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-006"
  },
  {
    "_id": {
      "$oid": "26topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-007"
  },
  {
    "_id": {
      "$oid": "26topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-008"
  },
  {
    "_id": {
      "$oid": "26topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-009"
  },
  {
    "_id": {
      "$oid": "26topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-010"
  },
  {
    "_id": {
      "$oid": "26topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-011"
  },
  {
    "_id": {
      "$oid": "26topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-012"
  },
  {
    "_id": {
      "$oid": "26topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-013"
  },
  {
    "_id": {
      "$oid": "26topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-014"
  },
  {
    "_id": {
      "$oid": "26topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-015"
  },
  {
    "_id": {
      "$oid": "26topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-016"
  },
  {
    "_id": {
      "$oid": "26topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-017"
  },
  {
    "_id": {
      "$oid": "26topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-018"
  },
  {
    "_id": {
      "$oid": "26topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-019"
  },
  {
    "_id": {
      "$oid": "26topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-020"
  },
  {
    "_id": {
      "$oid": "26topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-021"
  },
  {
    "_id": {
      "$oid": "26topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-022"
  },
  {
    "_id": {
      "$oid": "26topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-023"
  },
  {
    "_id": {
      "$oid": "26topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-024"
  },
  {
    "_id": {
      "$oid": "26topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-025"
  },
  {
    "_id": {
      "$oid": "26topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-026"
  },
  {
    "_id": {
      "$oid": "26topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-027"
  },
  {
    "_id": {
      "$oid": "26topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-028"
  },
  {
    "_id": {
      "$oid": "26topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-029"
  },
  {
    "_id": {
      "$oid": "26topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-030"
  },
  {
    "_id": {
      "$oid": "26topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-031"
  },
  {
    "_id": {
      "$oid": "26topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-032"
  },
  {
    "_id": {
      "$oid": "26topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-033"
  },
  {
    "_id": {
      "$oid": "26topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-034"
  },
  {
    "_id": {
      "$oid": "26topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-035"
  },
  {
    "_id": {
      "$oid": "26topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-036"
  },
  {
    "_id": {
      "$oid": "26topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-037"
  },
  {
    "_id": {
      "$oid": "26topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-038"
  },
  {
    "_id": {
      "$oid": "26topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-039"
  },
  {
    "_id": {
      "$oid": "26topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-040"
  },
  {
    "_id": {
      "$oid": "26topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-041"
  },
  {
    "_id": {
      "$oid": "26topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-042"
  },
  {
    "_id": {
      "$oid": "26topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-043"
  },
  {
    "_id": {
      "$oid": "26topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-044"
  },
  {
    "_id": {
      "$oid": "26topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-045"
  },
  {
    "_id": {
      "$oid": "26topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-046"
  },
  {
    "_id": {
      "$oid": "26topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-047"
  },
  {
    "_id": {
      "$oid": "26topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-048"
  },
  {
    "_id": {
      "$oid": "26topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-049"
  },
  {
    "_id": {
      "$oid": "26topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-050"
  },
  {
    "_id": {
      "$oid": "26topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-051"
  },
  {
    "_id": {
      "$oid": "26topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-052"
  },
  {
    "_id": {
      "$oid": "26topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-053"
  },
  {
    "_id": {
      "$oid": "26topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-054"
  },
  {
    "_id": {
      "$oid": "26topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-055"
  },
  {
    "_id": {
      "$oid": "26topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-056"
  },
  {
    "_id": {
      "$oid": "26topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-057"
  },
  {
    "_id": {
      "$oid": "26topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-058"
  },
  {
    "_id": {
      "$oid": "26topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-059"
  },
  {
    "_id": {
      "$oid": "26topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-060"
  },
  {
    "_id": {
      "$oid": "26topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-061"
  },
  {
    "_id": {
      "$oid": "26topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-062"
  },
  {
    "_id": {
      "$oid": "26topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-063"
  },
  {
    "_id": {
      "$oid": "26topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-064"
  },
  {
    "_id": {
      "$oid": "26topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-065"
  },
  {
    "_id": {
      "$oid": "26topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-066"
  },
  {
    "_id": {
      "$oid": "26topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-067"
  },
  {
    "_id": {
      "$oid": "26topernotephy68"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-068"
  },
  {
    "_id": {
      "$oid": "26topernotephy69"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-069"
  },
  {
    "_id": {
      "$oid": "26topernotephy70"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-070"
  },
  {
    "_id": {
      "$oid": "26topernotephy71"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-071"
  },
  {
    "_id": {
      "$oid": "26topernotephy72"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-072"
  },
  {
    "_id": {
      "$oid": "26topernotephy73"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-073"
  },
  {
    "_id": {
      "$oid": "26topernotephy74"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-074"
  },
  {
    "_id": {
      "$oid": "26topernotephy75"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-075"
  },
  {
    "_id": {
      "$oid": "26topernotephy76"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-076"
  },
  {
    "_id": {
      "$oid": "26topernotephy77"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-077"
  },
  {
    "_id": {
      "$oid": "26topernotephy78"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-078"
  },
  {
    "_id": {
      "$oid": "26topernotephy79"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-079"
  },
  {
    "_id": {
      "$oid": "26topernotephy80"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-080"
  },
  {
    "_id": {
      "$oid": "26topernotephy81"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-081"
  },
  {
    "_id": {
      "$oid": "26topernotephy82"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-082"
  },
  {
    "_id": {
      "$oid": "26topernotephy83"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-083"
  },
  {
    "_id": {
      "$oid": "26topernotephy84"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-084"
  },
  {
    "_id": {
      "$oid": "26topernotephy85"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-085"
  },
  {
    "_id": {
      "$oid": "26topernotephy86"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-086"
  },
  {
    "_id": {
      "$oid": "26topernotephy87"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-087"
  },
  {
    "_id": {
      "$oid": "26topernotephy88"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-088"
  },
  {
    "_id": {
      "$oid": "26topernotephy89"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-089"
  },
  {
    "_id": {
      "$oid": "26topernotephy90"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-090"
  },
  {
    "_id": {
      "$oid": "26topernotephy91"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-091"
  },
  {
    "_id": {
      "$oid": "26topernotephy92"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-092"
  },
  {
    "_id": {
      "$oid": "26topernotephy93"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-093"
  },
  {
    "_id": {
      "$oid": "26topernotephy94"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-094"
  },
  {
    "_id": {
      "$oid": "26topernotephy95"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-095"
  },
  {
    "_id": {
      "$oid": "26topernotephy96"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-096"
  },
  {
    "_id": {
      "$oid": "26topernotephy97"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-097"
  },
  {
    "_id": {
      "$oid": "26topernotephy98"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-098"
  },
  {
    "_id": {
      "$oid": "26topernotephy99"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-099"
  },
        {
    "_id": {
      "$oid": "26topernotephy100"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-100"
  },
  {
    "_id": {
      "$oid": "26topernotephy101"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-101"
  },
  {
    "_id": {
      "$oid": "26topernotephy102"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-102"
  },
  {
    "_id": {
      "$oid": "26topernotephy103"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-103"
  },
  {
    "_id": {
      "$oid": "26topernotephy104"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-104"
  },
  {
    "_id": {
      "$oid": "26topernotephy105"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-105"
  },
  {
    "_id": {
      "$oid": "26topernotephy106"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-106"
  },
  {
    "_id": {
      "$oid": "26topernotephy107"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-107"
  },
  {
    "_id": {
      "$oid": "26topernotephy108"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-108"
  },
  {
    "_id": {
      "$oid": "26topernotephy109"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-109"
  },
  {
    "_id": {
      "$oid": "26topernotephy110"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-110"
  },
  {
    "_id": {
      "$oid": "26topernotephy111"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-111"
  },
  {
    "_id": {
      "$oid": "26topernotephy112"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-112"
  },
  {
    "_id": {
      "$oid": "26topernotephy113"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-113"
  },
  {
    "_id": {
      "$oid": "26topernotephy114"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-114"
  },
  {
    "_id": {
      "$oid": "26topernotephy115"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-115"
  },
  {
    "_id": {
      "$oid": "26topernotephy116"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-116"
  },
  {
    "_id": {
      "$oid": "26topernotephy117"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-117"
  },
  {
    "_id": {
      "$oid": "26topernotephy118"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-118"
  },
  {
    "_id": {
      "$oid": "26topernotephy119"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-119"
  },
  {
    "_id": {
      "$oid": "26topernotephy120"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-120"
  },
  {
    "_id": {
      "$oid": "26topernotephy121"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-121"
  },
  {
    "_id": {
      "$oid": "26topernotephy122"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-122"
  },
  {
    "_id": {
      "$oid": "26topernotephy123"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-123"
  },
  {
    "_id": {
      "$oid": "26topernotephy124"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-124"
  },
  {
    "_id": {
      "$oid": "26topernotephy125"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-125"
  },
  {
    "_id": {
      "$oid": "26topernotephy126"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-126"
  },
  {
    "_id": {
      "$oid": "26topernotephy127"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-127"
  },
  {
    "_id": {
      "$oid": "26topernotephy128"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-128"
  },
  {
    "_id": {
      "$oid": "26topernotephy129"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-129"
  },
  {
    "_id": {
      "$oid": "26topernotephy130"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-130"
  },
  {
    "_id": {
      "$oid": "26topernotephy131"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-131"
  },
  {
    "_id": {
      "$oid": "26topernotephy132"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-132"
  },
  {
    "_id": {
      "$oid": "26topernotephy133"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-133"
  },
  {
    "_id": {
      "$oid": "26topernotephy134"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-134"
  },
  {
    "_id": {
      "$oid": "26topernotephy135"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-135"
  },
  {
    "_id": {
      "$oid": "26topernotephy136"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-136"
  },
  {
    "_id": {
      "$oid": "26topernotephy137"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-137"
  },
  {
    "_id": {
      "$oid": "26topernotephy138"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-138"
  },
  {
    "_id": {
      "$oid": "26topernotephy139"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-139"
  },
  {
    "_id": {
      "$oid": "26topernotephy140"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-140"
  },
  {
    "_id": {
      "$oid": "26topernotephy141"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-141"
  },
  {
    "_id": {
      "$oid": "26topernotephy142"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-142"
  },
  {
    "_id": {
      "$oid": "26topernotephy143"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-143"
  },
  {
    "_id": {
      "$oid": "26topernotephy144"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-144"
  },
  {
    "_id": {
      "$oid": "26topernotephy145"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-145"
  },
  {
    "_id": {
      "$oid": "26topernotephy146"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-146"
  },
  {
    "_id": {
      "$oid": "26topernotephy147"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-147"
  },
  {
    "_id": {
      "$oid": "26topernotephy148"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-148"
  },
  {
    "_id": {
      "$oid": "26topernotephy149"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-149"
  },
  {
    "_id": {
      "$oid": "26topernotephy150"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-150"
  },
  {
    "_id": {
      "$oid": "26topernotephy151"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-151"
  },
  {
    "_id": {
      "$oid": "26topernotephy152"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-152"
  },
  {
    "_id": {
      "$oid": "26topernotephy153"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-153"
  },
  {
    "_id": {
      "$oid": "26topernotephy154"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-154"
  },
  {
    "_id": {
      "$oid": "26topernotephy155"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-155"
  },
  {
    "_id": {
      "$oid": "26topernotephy156"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-156"
  },
  {
    "_id": {
      "$oid": "26topernotephy157"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-157"
  },
  {
    "_id": {
      "$oid": "26topernotephy158"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "26-Ray Optics-158"
  },
 
    {
    "_id": {
      "$oid": "27topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP27",
    "pagename": "27-Wave Optics-01"
  },
  {
    "_id": {
      "$oid": "27topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-02"
  },
  {
    "_id": {
      "$oid": "27topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-03"
  },
  {
    "_id": {
      "$oid": "27topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-04"
  },
  {
    "_id": {
      "$oid": "27topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-05"
  },
  {
    "_id": {
      "$oid": "27topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-06"
  },
  {
    "_id": {
      "$oid": "27topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-07"
  },
  {
    "_id": {
      "$oid": "27topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-08"
  },
  {
    "_id": {
      "$oid": "27topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-09"
  },
  {
    "_id": {
      "$oid": "27topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-10"
  },
  {
    "_id": {
      "$oid": "27topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-11"
  },
  {
    "_id": {
      "$oid": "27topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-12"
  },
  {
    "_id": {
      "$oid": "27topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-13"
  },
  {
    "_id": {
      "$oid": "27topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-14"
  },
  {
    "_id": {
      "$oid": "27topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-15"
  },
  {
    "_id": {
      "$oid": "27topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-16"
  },
  {
    "_id": {
      "$oid": "27topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-17"
  },
  {
    "_id": {
      "$oid": "27topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-18"
  },
  {
    "_id": {
      "$oid": "27topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-19"
  },
  {
    "_id": {
      "$oid": "27topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-20"
  },
  {
    "_id": {
      "$oid": "27topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-21"
  },
  {
    "_id": {
      "$oid": "27topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-22"
  },
  {
    "_id": {
      "$oid": "27topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-23"
  },
  {
    "_id": {
      "$oid": "27topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-24"
  },
  {
    "_id": {
      "$oid": "27topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-25"
  },
  {
    "_id": {
      "$oid": "27topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-26"
  },
  {
    "_id": {
      "$oid": "27topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-27"
  },
  {
    "_id": {
      "$oid": "27topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-28"
  },
  {
    "_id": {
      "$oid": "27topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-29"
  },
  {
    "_id": {
      "$oid": "27topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-30"
  },
  {
    "_id": {
      "$oid": "27topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-31"
  },
  {
    "_id": {
      "$oid": "27topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-32"
  },
  {
    "_id": {
      "$oid": "27topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-33"
  },
  {
    "_id": {
      "$oid": "27topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-34"
  },
  {
    "_id": {
      "$oid": "27topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-35"
  },
  {
    "_id": {
      "$oid": "27topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-36"
  },
  {
    "_id": {
      "$oid": "27topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-37"
  },
  {
    "_id": {
      "$oid": "27topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-38"
  },
  {
    "_id": {
      "$oid": "27topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-39"
  },
  {
    "_id": {
      "$oid": "27topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-40"
  },
  {
    "_id": {
      "$oid": "27topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-41"
  },
  {
    "_id": {
      "$oid": "27topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-42"
  },
  {
    "_id": {
      "$oid": "27topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-43"
  },
  {
    "_id": {
      "$oid": "27topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-44"
  },
  {
    "_id": {
      "$oid": "27topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-45"
  },
  {
    "_id": {
      "$oid": "27topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-46"
  },
  {
    "_id": {
      "$oid": "27topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-47"
  },
  {
    "_id": {
      "$oid": "27topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-48"
  },
  {
    "_id": {
      "$oid": "27topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-49"
  },
  {
    "_id": {
      "$oid": "27topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-50"
  },
  {
    "_id": {
      "$oid": "27topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-51"
  },
  {
    "_id": {
      "$oid": "27topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-52"
  },
  {
    "_id": {
      "$oid": "27topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-53"
  },
  {
    "_id": {
      "$oid": "27topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-54"
  },
  {
    "_id": {
      "$oid": "27topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-55"
  },
  {
    "_id": {
      "$oid": "27topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-56"
  },
  {
    "_id": {
      "$oid": "27topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-57"
  },
  {
    "_id": {
      "$oid": "27topernotephy58"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-58"
  },
  {
    "_id": {
      "$oid": "27topernotephy59"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-59"
  },
  {
    "_id": {
      "$oid": "27topernotephy60"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-60"
  },
  {
    "_id": {
      "$oid": "27topernotephy61"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-61"
  },
  {
    "_id": {
      "$oid": "27topernotephy62"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-62"
  },
  {
    "_id": {
      "$oid": "27topernotephy63"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-63"
  },
  {
    "_id": {
      "$oid": "27topernotephy64"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-64"
  },
  {
    "_id": {
      "$oid": "27topernotephy65"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-65"
  },
  {
    "_id": {
      "$oid": "27topernotephy66"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-66"
  },
  {
    "_id": {
      "$oid": "27topernotephy67"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-67"
  },
  {
    "_id": {
      "$oid": "27topernotephy68"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-68"
  },
  {
    "_id": {
      "$oid": "27topernotephy69"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-69"
  },
  {
    "_id": {
      "$oid": "27topernotephy70"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-70"
  },
    {
    "_id": {
      "$oid": "27topernotephy71"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-71"
  },
  {
    "_id": {
      "$oid": "27topernotephy72"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "27-Wave Optics-72"
  },
    {
    "_id": {
      "$oid": "28topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-01"
  },
  {
    "_id": {
      "$oid": "28topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-02"
  },
  {
    "_id": {
      "$oid": "28topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-03"
  },
  {
    "_id": {
      "$oid": "28topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-04"
  },
  {
    "_id": {
      "$oid": "28topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-05"
  },
  {
    "_id": {
      "$oid": "28topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-06"
  },
  {
    "_id": {
      "$oid": "28topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-07"
  },
  {
    "_id": {
      "$oid": "28topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-08"
  },
  {
    "_id": {
      "$oid": "28topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-09"
  },
  {
    "_id": {
      "$oid": "28topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-10"
  },
  {
    "_id": {
      "$oid": "28topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-11"
  },
  {
    "_id": {
      "$oid": "28topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-12"
  },
  {
    "_id": {
      "$oid": "28topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-13"
  },
  {
    "_id": {
      "$oid": "28topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-14"
  },
  {
    "_id": {
      "$oid": "28topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-15"
  },
  {
    "_id": {
      "$oid": "28topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-16"
  },
  {
    "_id": {
      "$oid": "28topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-17"
  },
  {
    "_id": {
      "$oid": "28topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-18"
  },
  {
    "_id": {
      "$oid": "28topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-19"
  },
  {
    "_id": {
      "$oid": "28topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-20"
  },
  {
    "_id": {
      "$oid": "28topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-21"
  },
  {
    "_id": {
      "$oid": "28topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-22"
  },
  {
    "_id": {
      "$oid": "28topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-23"
  },
  {
    "_id": {
      "$oid": "28topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-24"
  },
  {
    "_id": {
      "$oid": "28topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-25"
  },
  {
    "_id": {
      "$oid": "28topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-26"
  },
  {
    "_id": {
      "$oid": "28topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-27"
  },
  {
    "_id": {
      "$oid": "28topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-28"
  },
  {
    "_id": {
      "$oid": "28topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-29"
  },
  {
    "_id": {
      "$oid": "28topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-30"
  },
  {
    "_id": {
      "$oid": "28topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-31"
  },
  {
    "_id": {
      "$oid": "28topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-32"
  },
  {
    "_id": {
      "$oid": "28topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-33"
  },
  {
    "_id": {
      "$oid": "28topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-34"
  },
  {
    "_id": {
      "$oid": "28topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-35"
  },
  {
    "_id": {
      "$oid": "28topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-36"
  },
  {
    "_id": {
      "$oid": "28topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-37"
  },
  {
    "_id": {
      "$oid": "28topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-38"
  },
  {
    "_id": {
      "$oid": "28topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-39"
  },
  {
    "_id": {
      "$oid": "28topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-40"
  },
  {
    "_id": {
      "$oid": "28topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-41"
  },
  {
    "_id": {
      "$oid": "28topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-42"
  },
  {
    "_id": {
      "$oid": "28topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-43"
  },
  {
    "_id": {
      "$oid": "28topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-44"
  },
  {
    "_id": {
      "$oid": "28topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-45"
  },
  {
    "_id": {
      "$oid": "28topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-46"
  },
  {
    "_id": {
      "$oid": "28topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-47"
  },
  {
    "_id": {
      "$oid": "28topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-48"
  },
  {
    "_id": {
      "$oid": "28topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-49"
  },
  {
    "_id": {
      "$oid": "28topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-50"
  },
  {
    "_id": {
      "$oid": "28topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-51"
  },
  {
    "_id": {
      "$oid": "28topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-52"
  },
  {
    "_id": {
      "$oid": "28topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "28-Dual Nature of Radiation of  Matter-53"
  },
    {
    "_id": {
      "$oid": "29topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP29",
    "pagename": "29-Atoms-01"
  },
  {
    "_id": {
      "$oid": "29topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-02"
  },
  {
    "_id": {
      "$oid": "29topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-03"
  },
  {
    "_id": {
      "$oid": "29topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-04"
  },
  {
    "_id": {
      "$oid": "29topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-05"
  },
  {
    "_id": {
      "$oid": "29topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-06"
  },
  {
    "_id": {
      "$oid": "29topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-07"
  },
  {
    "_id": {
      "$oid": "29topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-08"
  },
  {
    "_id": {
      "$oid": "29topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-09"
  },
  {
    "_id": {
      "$oid": "29topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-10"
  },
  {
    "_id": {
      "$oid": "29topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-11"
  },
  {
    "_id": {
      "$oid": "29topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-12"
  },
  {
    "_id": {
      "$oid": "29topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-13"
  },
  {
    "_id": {
      "$oid": "29topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-14"
  },
  {
    "_id": {
      "$oid": "29topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-15"
  },
  {
    "_id": {
      "$oid": "29topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-16"
  },
  {
    "_id": {
      "$oid": "29topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-17"
  },
  {
    "_id": {
      "$oid": "29topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-18"
  },
  {
    "_id": {
      "$oid": "29topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-19"
  },
  {
    "_id": {
      "$oid": "29topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-20"
  },
  {
    "_id": {
      "$oid": "29topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-21"
  },
  {
    "_id": {
      "$oid": "29topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-22"
  },
  {
    "_id": {
      "$oid": "29topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-23"
  },
  {
    "_id": {
      "$oid": "29topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-24"
  },
  {
    "_id": {
      "$oid": "29topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-25"
  },
  {
    "_id": {
      "$oid": "29topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-26"
  },
  {
    "_id": {
      "$oid": "29topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-27"
  },
  {
    "_id": {
      "$oid": "29topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-28"
  },
  {
    "_id": {
      "$oid": "29topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-29"
  },
  {
    "_id": {
      "$oid": "29topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "29-Atoms-30"
  },
    {
    "_id": {
      "$oid": "30topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP30",
    "pagename": "30-Nuclei-01"
  },
  {
    "_id": {
      "$oid": "30topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-02"
  },
  {
    "_id": {
      "$oid": "30topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-03"
  },
  {
    "_id": {
      "$oid": "30topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-04"
  },
  {
    "_id": {
      "$oid": "30topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-05"
  },
  {
    "_id": {
      "$oid": "30topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-06"
  },
  {
    "_id": {
      "$oid": "30topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-07"
  },
  {
    "_id": {
      "$oid": "30topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-08"
  },
  {
    "_id": {
      "$oid": "30topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-09"
  },
  {
    "_id": {
      "$oid": "30topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-10"
  },
  {
    "_id": {
      "$oid": "30topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-11"
  },
  {
    "_id": {
      "$oid": "30topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-12"
  },
  {
    "_id": {
      "$oid": "30topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-13"
  },
  {
    "_id": {
      "$oid": "30topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-14"
  },
  {
    "_id": {
      "$oid": "30topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-15"
  },
  {
    "_id": {
      "$oid": "30topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-16"
  },
  {
    "_id": {
      "$oid": "30topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-17"
  },
  {
    "_id": {
      "$oid": "30topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-18"
  },
  {
    "_id": {
      "$oid": "30topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-19"
  },
  {
    "_id": {
      "$oid": "30topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-20"
  },
  {
    "_id": {
      "$oid": "30topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-21"
  },
  {
    "_id": {
      "$oid": "30topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-22"
  },
  {
    "_id": {
      "$oid": "30topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-23"
  },
  {
    "_id": {
      "$oid": "30topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-24"
  },
  {
    "_id": {
      "$oid": "30topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-25"
  },
  {
    "_id": {
      "$oid": "30topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-26"
  },
  {
    "_id": {
      "$oid": "30topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-27"
  },
  {
    "_id": {
      "$oid": "30topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-28"
  },
  {
    "_id": {
      "$oid": "30topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-29"
  },
  {
    "_id": {
      "$oid": "30topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-30"
  },
  {
    "_id": {
      "$oid": "30topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-31"
  },
  {
    "_id": {
      "$oid": "30topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-32"
  },
  {
    "_id": {
      "$oid": "30topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-33"
  },
  {
    "_id": {
      "$oid": "30topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-34"
  },
  {
    "_id": {
      "$oid": "30topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-35"
  },
  {
    "_id": {
      "$oid": "30topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-36"
  },
  {
    "_id": {
      "$oid": "30topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-37"
  },
  {
    "_id": {
      "$oid": "30topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-38"
  },
  {
    "_id": {
      "$oid": "30topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-39"
  },
  {
    "_id": {
      "$oid": "30topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-40"
  },
  {
    "_id": {
      "$oid": "30topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-41"
  },
  {
    "_id": {
      "$oid": "30topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-42"
  },
  {
    "_id": {
      "$oid": "30topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-43"
  },
  {
    "_id": {
      "$oid": "30topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-44"
  },
  {
    "_id": {
      "$oid": "30topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-45"
  },
  {
    "_id": {
      "$oid": "30topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-46"
  },
  {
    "_id": {
      "$oid": "30topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-47"
  },
  {
    "_id": {
      "$oid": "30topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-48"
  },
  {
    "_id": {
      "$oid": "30topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-49"
  },
  {
    "_id": {
      "$oid": "30topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "30-Nuclei-50"
  },
    {
    "_id": {
      "$oid": "31topernotephy1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CP31",
    "pagename": "31-Semiconductors-01"
  },
  {
    "_id": {
      "$oid": "31topernotephy2"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-02"
  },
  {
    "_id": {
      "$oid": "31topernotephy3"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-03"
  },
  {
    "_id": {
      "$oid": "31topernotephy4"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-04"
  },
  {
    "_id": {
      "$oid": "31topernotephy5"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-05"
  },
  {
    "_id": {
      "$oid": "31topernotephy6"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-06"
  },
  {
    "_id": {
      "$oid": "31topernotephy7"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-07"
  },
  {
    "_id": {
      "$oid": "31topernotephy8"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-08"
  },
  {
    "_id": {
      "$oid": "31topernotephy9"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-09"
  },
  {
    "_id": {
      "$oid": "31topernotephy10"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-10"
  },
  {
    "_id": {
      "$oid": "31topernotephy11"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-11"
  },
  {
    "_id": {
      "$oid": "31topernotephy12"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-12"
  },
  {
    "_id": {
      "$oid": "31topernotephy13"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-13"
  },
  {
    "_id": {
      "$oid": "31topernotephy14"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-14"
  },
  {
    "_id": {
      "$oid": "31topernotephy15"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-15"
  },
  {
    "_id": {
      "$oid": "31topernotephy16"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-16"
  },
  {
    "_id": {
      "$oid": "31topernotephy17"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-17"
  },
  {
    "_id": {
      "$oid": "31topernotephy18"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-18"
  },
  {
    "_id": {
      "$oid": "31topernotephy19"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-19"
  },
  {
    "_id": {
      "$oid": "31topernotephy20"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-20"
  },
  {
    "_id": {
      "$oid": "31topernotephy21"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-21"
  },
  {
    "_id": {
      "$oid": "31topernotephy22"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-22"
  },
  {
    "_id": {
      "$oid": "31topernotephy23"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-23"
  },
  {
    "_id": {
      "$oid": "31topernotephy24"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-24"
  },
  {
    "_id": {
      "$oid": "31topernotephy25"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-25"
  },
  {
    "_id": {
      "$oid": "31topernotephy26"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-26"
  },
  {
    "_id": {
      "$oid": "31topernotephy27"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-27"
  },
  {
    "_id": {
      "$oid": "31topernotephy28"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-28"
  },
  {
    "_id": {
      "$oid": "31topernotephy29"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-29"
  },
  {
    "_id": {
      "$oid": "31topernotephy30"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-30"
  },
  {
    "_id": {
      "$oid": "31topernotephy31"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-31"
  },
  {
    "_id": {
      "$oid": "31topernotephy32"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-32"
  },
  {
    "_id": {
      "$oid": "31topernotephy33"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-33"
  },
  {
    "_id": {
      "$oid": "31topernotephy34"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-34"
  },
  {
    "_id": {
      "$oid": "31topernotephy35"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-35"
  },
  {
    "_id": {
      "$oid": "31topernotephy36"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-36"
  },
  {
    "_id": {
      "$oid": "31topernotephy37"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-37"
  },
  {
    "_id": {
      "$oid": "31topernotephy38"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-38"
  },
  {
    "_id": {
      "$oid": "31topernotephy39"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-39"
  },
  {
    "_id": {
      "$oid": "31topernotephy40"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-40"
  },
  {
    "_id": {
      "$oid": "31topernotephy41"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-41"
  },
  {
    "_id": {
      "$oid": "31topernotephy42"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-42"
  },
  {
    "_id": {
      "$oid": "31topernotephy43"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-43"
  },
  {
    "_id": {
      "$oid": "31topernotephy44"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-44"
  },
  {
    "_id": {
      "$oid": "31topernotephy45"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-45"
  },
  {
    "_id": {
      "$oid": "31topernotephy46"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-46"
  },
  {
    "_id": {
      "$oid": "31topernotephy47"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-47"
  },
  {
    "_id": {
      "$oid": "31topernotephy48"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-48"
  },
  {
    "_id": {
      "$oid": "31topernotephy49"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-49"
  },
  {
    "_id": {
      "$oid": "31topernotephy50"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-50"
  },
  {
    "_id": {
      "$oid": "31topernotephy51"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-51"
  },
  {
    "_id": {
      "$oid": "31topernotephy52"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-52"
  },
  {
    "_id": {
      "$oid": "31topernotephy53"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-53"
  },
  {
    "_id": {
      "$oid": "31topernotephy54"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-54"
  },
  {
    "_id": {
      "$oid": "31topernotephy55"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-55"
  },
  {
    "_id": {
      "$oid": "31topernotephy56"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-56"
  },
  {
    "_id": {
      "$oid": "31topernotephy57"
    },
    "type": "topernote",
    "subject": "physics",
    "topic": "CP31",
    "pagename": "31-Semiconductors-57"
  },



  {
    "_id": {
      "$oid": "01topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC01",
    "pagename": "1-Mole Concept-1"
  },
  {
    "_id": {
      "$oid": "01topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "1-Mole Concept-2"
  },
  {
    "_id": {
      "$oid": "01topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "1-Mole Concept-3"
  },
  {
    "_id": {
      "$oid": "01topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "1-Mole Concept-4"
  },
  {
    "_id": {
      "$oid": "01topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "1-Mole Concept-5"
  },
  {
    "_id": {
      "$oid": "02topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-01"
  },
  {
    "_id": {
      "$oid": "02topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-02"
  },
  {
    "_id": {
      "$oid": "02topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-03"
  },
  {
    "_id": {
      "$oid": "02topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-04"
  },
  {
    "_id": {
      "$oid": "02topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-05"
  },
  {
    "_id": {
      "$oid": "02topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-06"
  },
  {
    "_id": {
      "$oid": "02topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-07"
  },
  {
    "_id": {
      "$oid": "02topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-08"
  },
  {
    "_id": {
      "$oid": "02topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-09"
  },
  {
    "_id": {
      "$oid": "02topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-10"
  },
  {
    "_id": {
      "$oid": "02topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-11"
  },
  {
    "_id": {
      "$oid": "02topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-12"
  },
  {
    "_id": {
      "$oid": "02topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "2-Structure of Atom-13"
  },
  {
    "_id": {
      "$oid": "03topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC03",
    "pagename": "3-Periodic Table-01"
  },
  {
    "_id": {
      "$oid": "03topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-02"
  },
  {
    "_id": {
      "$oid": "03topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-03"
  },
  {
    "_id": {
      "$oid": "03topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-04"
  },
  {
    "_id": {
      "$oid": "03topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-05"
  },
  {
    "_id": {
      "$oid": "03topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-06"
  },
  {
    "_id": {
      "$oid": "03topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-07"
  },
  {
    "_id": {
      "$oid": "03topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-08"
  },
  {
    "_id": {
      "$oid": "03topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-09"
  },
  {
    "_id": {
      "$oid": "03topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-10"
  },
  {
    "_id": {
      "$oid": "03topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-11"
  },
  {
    "_id": {
      "$oid": "03topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-12"
  },
  {
    "_id": {
      "$oid": "03topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-13"
  },
  {
    "_id": {
      "$oid": "03topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-14"
  },
  {
    "_id": {
      "$oid": "03topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-15"
  },
  {
    "_id": {
      "$oid": "03topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-16"
  },
  {
    "_id": {
      "$oid": "03topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-17"
  },
  {
    "_id": {
      "$oid": "03topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-18"
  },
  {
    "_id": {
      "$oid": "03topernoteche19"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-19"
  },
  {
    "_id": {
      "$oid": "03topernoteche20"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-20"
  },
  {
    "_id": {
      "$oid": "03topernoteche21"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-21"
  },
  {
    "_id": {
      "$oid": "03topernoteche22"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-22"
  },
  {
    "_id": {
      "$oid": "03topernoteche23"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-23"
  },
  {
    "_id": {
      "$oid": "03topernoteche24"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-24"
  },
  {
    "_id": {
      "$oid": "03topernoteche25"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "3-Periodic Table-25"
  },
  {
    "_id": {
      "$oid": "04topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-01"
  },
  {
    "_id": {
      "$oid": "04topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-02"
  },
  {
    "_id": {
      "$oid": "04topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-03"
  },
  {
    "_id": {
      "$oid": "04topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-04"
  },
  {
    "_id": {
      "$oid": "04topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-05"
  },
  {
    "_id": {
      "$oid": "04topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-06"
  },
  {
    "_id": {
      "$oid": "04topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-07"
  },
  {
    "_id": {
      "$oid": "04topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-08"
  },
  {
    "_id": {
      "$oid": "04topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-09"
  },
  {
    "_id": {
      "$oid": "04topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-10"
  },
  {
    "_id": {
      "$oid": "04topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-11"
  },
  {
    "_id": {
      "$oid": "04topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-12"
  },
  {
    "_id": {
      "$oid": "04topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-13"
  },
  {
    "_id": {
      "$oid": "04topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "4-Chemical Bonding-14"
  },
  {
    "_id": {
      "$oid": "05topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC05",
    "pagename": "5-States of Matter-01"
  },
  {
    "_id": {
      "$oid": "05topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-02"
  },
  {
    "_id": {
      "$oid": "05topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-03"
  },
  {
    "_id": {
      "$oid": "05topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-04"
  },
  {
    "_id": {
      "$oid": "05topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-05"
  },
  {
    "_id": {
      "$oid": "05topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-06"
  },
  {
    "_id": {
      "$oid": "05topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-07"
  },
  {
    "_id": {
      "$oid": "05topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-08"
  },
  {
    "_id": {
      "$oid": "05topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-09"
  },
  {
    "_id": {
      "$oid": "05topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-10"
  },
  {
    "_id": {
      "$oid": "05topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-11"
  },
  {
    "_id": {
      "$oid": "05topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-12"
  },
  {
    "_id": {
      "$oid": "05topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-13"
  },
  {
    "_id": {
      "$oid": "05topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-14"
  },
  {
    "_id": {
      "$oid": "05topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "5-States of Matter-15"
  },
  {
    "_id": {
      "$oid": "06topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC06",
    "pagename": "6-Thermodynamics-1"
  },
  {
    "_id": {
      "$oid": "06topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "6-Thermodynamics-2"
  },
  {
    "_id": {
      "$oid": "06topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "6-Thermodynamics-3"
  },
  {
    "_id": {
      "$oid": "06topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "6-Thermodynamics-4"
  },
  {
    "_id": {
      "$oid": "06topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "6-Thermodynamics-5"
  },

  {
    "_id": {
      "$oid": "07topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC07",
    "pagename": "7-Chemical Equilibrium-1"
  },
  {
    "_id": {
      "$oid": "07topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "7-Chemical Equilibrium-2"
  },
  {
    "_id": {
      "$oid": "07topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "7-Chemical Equilibrium-3"
  },
  {
    "_id": {
      "$oid": "07topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "7-Chemical Equilibrium-4"
  },
  {
    "_id": {
      "$oid": "07topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "7-Chemical Equilibrium-5"
  },
  {
    "_id": {
      "$oid": "07topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "7-Chemical Equilibrium-6"
  },
  {
    "_id": {
      "$oid": "07topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "7-Chemical Equilibrium-7"
  },
  {
    "_id": {
      "$oid": "08topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-01"
  },
  {
    "_id": {
      "$oid": "08topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-02"
  },
  {
    "_id": {
      "$oid": "08topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-03"
  },
  {
    "_id": {
      "$oid": "08topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-04"
  },
  {
    "_id": {
      "$oid": "08topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-05"
  },
  {
    "_id": {
      "$oid": "08topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-06"
  },
  {
    "_id": {
      "$oid": "08topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-07"
  },
  {
    "_id": {
      "$oid": "08topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-08"
  },
  {
    "_id": {
      "$oid": "08topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-09"
  },
  {
    "_id": {
      "$oid": "08topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-10"
  },
  {
    "_id": {
      "$oid": "08topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-11"
  },
  {
    "_id": {
      "$oid": "08topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-12"
  },
  {
    "_id": {
      "$oid": "08topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-13"
  },
  {
    "_id": {
      "$oid": "08topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-14"
  },
  {
    "_id": {
      "$oid": "08topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "8-Ionic Equilibrium-15"
  },
  {
    "_id": {
      "$oid": "09topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC09",
    "pagename": "9-Hydrogen-01"
  },
  {
    "_id": {
      "$oid": "09topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-02"
  },
  {
    "_id": {
      "$oid": "09topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-03"
  },
  {
    "_id": {
      "$oid": "09topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-04"
  },
  {
    "_id": {
      "$oid": "09topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-05"
  },
  {
    "_id": {
      "$oid": "09topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-06"
  },
  {
    "_id": {
      "$oid": "09topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-07"
  },
  {
    "_id": {
      "$oid": "09topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-08"
  },
  {
    "_id": {
      "$oid": "09topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-09"
  },
  {
    "_id": {
      "$oid": "09topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-10"
  },
  {
    "_id": {
      "$oid": "09topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-11"
  },
  {
    "_id": {
      "$oid": "09topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-12"
  },
  {
    "_id": {
      "$oid": "09topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-13"
  },
  {
    "_id": {
      "$oid": "09topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-14"
  },
  {
    "_id": {
      "$oid": "09topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-15"
  },
  {
    "_id": {
      "$oid": "09topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-16"
  },
  {
    "_id": {
      "$oid": "09topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "9-Hydrogen-17"
  },
  {
    "_id": {
      "$oid": "10topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC10",
    "pagename": "10-S Block-01"
  },
  {
    "_id": {
      "$oid": "10topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-02"
  },
  {
    "_id": {
      "$oid": "10topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-03"
  },
  {
    "_id": {
      "$oid": "10topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-04"
  },
  {
    "_id": {
      "$oid": "10topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-05"
  },
  {
    "_id": {
      "$oid": "10topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-06"
  },
  {
    "_id": {
      "$oid": "10topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-07"
  },
  {
    "_id": {
      "$oid": "10topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-08"
  },
  {
    "_id": {
      "$oid": "10topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-09"
  },
  {
    "_id": {
      "$oid": "10topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-10"
  },
  {
    "_id": {
      "$oid": "10topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-11"
  },
  {
    "_id": {
      "$oid": "10topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-12"
  },
  {
    "_id": {
      "$oid": "10topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-13"
  },
  {
    "_id": {
      "$oid": "10topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-14"
  },
  {
    "_id": {
      "$oid": "10topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-15"
  },
  {
    "_id": {
      "$oid": "10topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-16"
  },
  {
    "_id": {
      "$oid": "10topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "10-S Block-17"
  },
  {
    "_id": {
      "$oid": "11topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC11",
    "pagename": "11- P Block-01"
  },
  {
    "_id": {
      "$oid": "11topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-02"
  },
  {
    "_id": {
      "$oid": "11topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-03"
  },
  {
    "_id": {
      "$oid": "11topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-04"
  },
  {
    "_id": {
      "$oid": "11topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-05"
  },
  {
    "_id": {
      "$oid": "11topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-06"
  },
  {
    "_id": {
      "$oid": "11topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-07"
  },
  {
    "_id": {
      "$oid": "11topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-08"
  },
  {
    "_id": {
      "$oid": "11topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-09"
  },
  {
    "_id": {
      "$oid": "11topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-10"
  },
  {
    "_id": {
      "$oid": "11topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-11"
  },
  {
    "_id": {
      "$oid": "11topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-12"
  },
  {
    "_id": {
      "$oid": "11topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-13"
  },
  {
    "_id": {
      "$oid": "11topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-14"
  },
  {
    "_id": {
      "$oid": "11topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-15"
  },
  {
    "_id": {
      "$oid": "11topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-16"
  },
  {
    "_id": {
      "$oid": "11topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-17"
  },
  {
    "_id": {
      "$oid": "11topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-18"
  },
  {
    "_id": {
      "$oid": "11topernoteche19"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-19"
  },
  {
    "_id": {
      "$oid": "11topernoteche20"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-20"
  },
  {
    "_id": {
      "$oid": "11topernoteche21"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-21"
  },
  {
    "_id": {
      "$oid": "11topernoteche22"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-22"
  },
  {
    "_id": {
      "$oid": "11topernoteche23"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-23"
  },
  {
    "_id": {
      "$oid": "11topernoteche24"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-24"
  },
  {
    "_id": {
      "$oid": "11topernoteche25"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "11- P Block-25"
  },
  {
    "_id": {
      "$oid": "12topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-01"
  },
  {
    "_id": {
      "$oid": "12topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-02"
  },
  {
    "_id": {
      "$oid": "12topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-03"
  },
  {
    "_id": {
      "$oid": "12topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-04"
  },
  {
    "_id": {
      "$oid": "12topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-05"
  },
  {
    "_id": {
      "$oid": "12topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-06"
  },
  {
    "_id": {
      "$oid": "12topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-07"
  },
  {
    "_id": {
      "$oid": "12topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-08"
  },
  {
    "_id": {
      "$oid": "12topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-09"
  },
  {
    "_id": {
      "$oid": "12topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-10"
  },
  {
    "_id": {
      "$oid": "12topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-11"
  },
  {
    "_id": {
      "$oid": "12topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-12"
  },
  {
    "_id": {
      "$oid": "12topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-13"
  },
  {
    "_id": {
      "$oid": "12topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-14"
  },
  {
    "_id": {
      "$oid": "12topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-15"
  },
  {
    "_id": {
      "$oid": "12topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-16"
  },
  {
    "_id": {
      "$oid": "12topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-17"
  },
  {
    "_id": {
      "$oid": "12topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-18"
  },
  {
    "_id": {
      "$oid": "12topernoteche19"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-19"
  },
  {
    "_id": {
      "$oid": "12topernoteche20"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-20"
  },
  {
    "_id": {
      "$oid": "12topernoteche21"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-21"
  },
  {
    "_id": {
      "$oid": "12topernoteche22"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-22"
  },
  {
    "_id": {
      "$oid": "12topernoteche23"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-23"
  },
  {
    "_id": {
      "$oid": "12topernoteche24"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-24"
  },
  {
    "_id": {
      "$oid": "12topernoteche25"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-25"
  },
  {
    "_id": {
      "$oid": "12topernoteche26"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-26"
  },
  {
    "_id": {
      "$oid": "12topernoteche27"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-27"
  },
  {
    "_id": {
      "$oid": "12topernoteche28"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-28"
  },
  {
    "_id": {
      "$oid": "12topernoteche29"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-29"
  },
  {
    "_id": {
      "$oid": "12topernoteche30"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-30"
  },
  {
    "_id": {
      "$oid": "12topernoteche31"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-31"
  },
  {
    "_id": {
      "$oid": "12topernoteche32"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-32"
  },
  {
    "_id": {
      "$oid": "12topernoteche33"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-33"
  },
  {
    "_id": {
      "$oid": "12topernoteche34"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-34"
  },
  {
    "_id": {
      "$oid": "12topernoteche35"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-35"
  },
  {
    "_id": {
      "$oid": "12topernoteche36"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-36"
  },
  {
    "_id": {
      "$oid": "12topernoteche37"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-37"
  },
  {
    "_id": {
      "$oid": "12topernoteche38"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-38"
  },
  {
    "_id": {
      "$oid": "12topernoteche39"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-39"
  },
  {
    "_id": {
      "$oid": "12topernoteche40"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-40"
  },
  {
    "_id": {
      "$oid": "12topernoteche41"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-41"
  },
  {
    "_id": {
      "$oid": "12topernoteche42"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-42"
  },
  {
    "_id": {
      "$oid": "12topernoteche43"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "12- P Block (G - 15)-43"
  },
  {
    "_id": {
      "$oid": "13topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC13",
    "pagename": "13-Solid State-1"
  },
  {
    "_id": {
      "$oid": "13topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "13-Solid State-2"
  },
  {
    "_id": {
      "$oid": "13topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "13-Solid State-3"
  },
  {
    "_id": {
      "$oid": "13topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "13-Solid State-4"
  },
  {
    "_id": {
      "$oid": "13topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "13-Solid State-5"
  },
  {
    "_id": {
      "$oid": "13topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "13-Solid State-6"
  },
  {
    "_id": {
      "$oid": "13topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "13-Solid State-7"
  },
  {
    "_id": {
      "$oid": "13topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "13-Solid State-8"
  },
  {
    "_id": {
      "$oid": "14topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC14",
    "pagename": "14-Surface Chemistry-1"
  },
  {
    "_id": {
      "$oid": "14topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "14-Surface Chemistry-2"
  },
  {
    "_id": {
      "$oid": "14topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "14-Surface Chemistry-3"
  },
  {
    "_id": {
      "$oid": "14topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "14-Surface Chemistry-4"
  },
  {
    "_id": {
      "$oid": "14topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "14-Surface Chemistry-5"
  },
  {
    "_id": {
      "$oid": "14topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "14-Surface Chemistry-6"
  },
  {
    "_id": {
      "$oid": "14topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "14-Surface Chemistry-7"
  },
  {
    "_id": {
      "$oid": "15topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC15",
    "pagename": "15-Enviornmental Chemistry-1"
  },
  {
    "_id": {
      "$oid": "15topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "15-Enviornmental Chemistry-2"
  },
  {
    "_id": {
      "$oid": "15topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "15-Enviornmental Chemistry-3"
  },
  {
    "_id": {
      "$oid": "15topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "15-Enviornmental Chemistry-4"
  },
  {
    "_id": {
      "$oid": "15topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "15-Enviornmental Chemistry-5"
  },
  {
    "_id": {
      "$oid": "15topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "15-Enviornmental Chemistry-6"
  },
  {
    "_id": {
      "$oid": "15topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "15-Enviornmental Chemistry-7"
  },
  {
    "_id": {
      "$oid": "15topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "15-Enviornmental Chemistry-8"
  },
  {
    "_id": {
      "$oid": "16topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC16",
    "pagename": "16-Solutions-01"
  },
  {
    "_id": {
      "$oid": "16topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "16-Solutions-02"
  },
  {
    "_id": {
      "$oid": "16topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "16-Solutions-03"
  },
  {
    "_id": {
      "$oid": "16topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "16-Solutions-04"
  },
  {
    "_id": {
      "$oid": "16topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "16-Solutions-05"
  },
  {
    "_id": {
      "$oid": "16topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "16-Solutions-06"
  },
  {
    "_id": {
      "$oid": "16topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "16-Solutions-07"
  },
  {
    "_id": {
      "$oid": "16topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "16-Solutions-08"
  },
  {
    "_id": {
      "$oid": "16topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "16-Solutions-09"
  },
  {
    "_id": {
      "$oid": "16topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "16-Solutions-10"
  },
  {
    "_id": {
      "$oid": "17topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC17",
    "pagename": "17-Electrochemistry-1"
  },
  {
    "_id": {
      "$oid": "17topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "17-Electrochemistry-2"
  },
  {
    "_id": {
      "$oid": "17topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "17-Electrochemistry-3"
  },
  {
    "_id": {
      "$oid": "17topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "17-Electrochemistry-4"
  },
  {
    "_id": {
      "$oid": "17topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "17-Electrochemistry-5"
  },
  {
    "_id": {
      "$oid": "17topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "17-Electrochemistry-6"
  },
  {
    "_id": {
      "$oid": "17topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "17-Electrochemistry-7"
  },
  {
    "_id": {
      "$oid": "18topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC18",
    "pagename": "18-Chemical Kinetics-1"
  },
  {
    "_id": {
      "$oid": "18topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "18-Chemical Kinetics-2"
  },
  {
    "_id": {
      "$oid": "18topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "18-Chemical Kinetics-3"
  },
  {
    "_id": {
      "$oid": "18topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "18-Chemical Kinetics-4"
  },
  {
    "_id": {
      "$oid": "18topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "18-Chemical Kinetics-5"
  },
  {
    "_id": {
      "$oid": "18topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "18-Chemical Kinetics-6"
  },
  {
    "_id": {
      "$oid": "18topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "18-Chemical Kinetics-7"
  },
  {
    "_id": {
      "$oid": "18topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "18-Chemical Kinetics-8"
  },
  {
    "_id": {
      "$oid": "19topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC19",
    "pagename": "19-D and F Block-01"
  },
  {
    "_id": {
      "$oid": "19topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-02"
  },
  {
    "_id": {
      "$oid": "19topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-03"
  },
  {
    "_id": {
      "$oid": "19topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-04"
  },
  {
    "_id": {
      "$oid": "19topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-05"
  },
  {
    "_id": {
      "$oid": "19topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-06"
  },
  {
    "_id": {
      "$oid": "19topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-07"
  },
  {
    "_id": {
      "$oid": "19topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-08"
  },
  {
    "_id": {
      "$oid": "19topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-09"
  },
  {
    "_id": {
      "$oid": "19topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-10"
  },
  {
    "_id": {
      "$oid": "19topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-11"
  },
  {
    "_id": {
      "$oid": "19topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-12"
  },
  {
    "_id": {
      "$oid": "19topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-13"
  },
  {
    "_id": {
      "$oid": "19topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-14"
  },
  {
    "_id": {
      "$oid": "19topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-15"
  },
  {
    "_id": {
      "$oid": "19topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-16"
  },
  {
    "_id": {
      "$oid": "19topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-17"
  },
  {
    "_id": {
      "$oid": "19topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-18"
  },
  {
    "_id": {
      "$oid": "19topernoteche19"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "19-D and F Block-19"
  },
  {
    "_id": {
      "$oid": "20topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-01"
  },
  {
    "_id": {
      "$oid": "20topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-02"
  },
  {
    "_id": {
      "$oid": "20topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-03"
  },
  {
    "_id": {
      "$oid": "20topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-04"
  },
  {
    "_id": {
      "$oid": "20topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-05"
  },
  {
    "_id": {
      "$oid": "20topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-06"
  },
  {
    "_id": {
      "$oid": "20topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-07"
  },
  {
    "_id": {
      "$oid": "20topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-08"
  },
  {
    "_id": {
      "$oid": "20topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-09"
  },
  {
    "_id": {
      "$oid": "20topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-10"
  },
  {
    "_id": {
      "$oid": "20topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-11"
  },
  {
    "_id": {
      "$oid": "20topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-12"
  },
  {
    "_id": {
      "$oid": "20topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-13"
  },
  {
    "_id": {
      "$oid": "20topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-14"
  },
  {
    "_id": {
      "$oid": "20topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-15"
  },
  {
    "_id": {
      "$oid": "20topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-16"
  },
  {
    "_id": {
      "$oid": "20topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-17"
  },
  {
    "_id": {
      "$oid": "20topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "20-Coordination Compound-18"
  },
  {
    "_id": {
      "$oid": "21topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC21",
    "pagename": "21-Metallurgy-01"
  },
  {
    "_id": {
      "$oid": "21topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-02"
  },
  {
    "_id": {
      "$oid": "21topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-03"
  },
  {
    "_id": {
      "$oid": "21topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-04"
  },
  {
    "_id": {
      "$oid": "21topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-05"
  },
  {
    "_id": {
      "$oid": "21topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-06"
  },
  {
    "_id": {
      "$oid": "21topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-07"
  },
  {
    "_id": {
      "$oid": "21topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-08"
  },
  {
    "_id": {
      "$oid": "21topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-09"
  },
  {
    "_id": {
      "$oid": "21topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-10"
  },
  {
    "_id": {
      "$oid": "21topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-11"
  },
  {
    "_id": {
      "$oid": "21topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-12"
  },
  {
    "_id": {
      "$oid": "21topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-13"
  },
  {
    "_id": {
      "$oid": "21topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-14"
  },
  {
    "_id": {
      "$oid": "21topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "21-Metallurgy-15"
  },
  {
    "_id": {
      "$oid": "22topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-01"
  },
  {
    "_id": {
      "$oid": "22topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-02"
  },
  {
    "_id": {
      "$oid": "22topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-03"
  },
  {
    "_id": {
      "$oid": "22topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-04"
  },
  {
    "_id": {
      "$oid": "22topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-05"
  },
  {
    "_id": {
      "$oid": "22topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-06"
  },
  {
    "_id": {
      "$oid": "22topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-07"
  },
  {
    "_id": {
      "$oid": "22topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-08"
  },
  {
    "_id": {
      "$oid": "22topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-09"
  },
  {
    "_id": {
      "$oid": "22topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "22-Haloalkane  Haloarenes-10"
  },
  {
    "_id": {
      "$oid": "23topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-01"
  },
  {
    "_id": {
      "$oid": "23topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-02"
  },
  {
    "_id": {
      "$oid": "23topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-03"
  },
  {
    "_id": {
      "$oid": "23topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-04"
  },
  {
    "_id": {
      "$oid": "23topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-05"
  },
  {
    "_id": {
      "$oid": "23topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-06"
  },
  {
    "_id": {
      "$oid": "23topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-07"
  },
  {
    "_id": {
      "$oid": "23topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-08"
  },
  {
    "_id": {
      "$oid": "23topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-09"
  },
  {
    "_id": {
      "$oid": "23topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-10"
  },
  {
    "_id": {
      "$oid": "23topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-11"
  },
  {
    "_id": {
      "$oid": "23topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-12"
  },
  {
    "_id": {
      "$oid": "23topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-13"
  },
  {
    "_id": {
      "$oid": "23topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-14"
  },
  {
    "_id": {
      "$oid": "23topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-15"
  },
  {
    "_id": {
      "$oid": "23topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-16"
  },
  {
    "_id": {
      "$oid": "23topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-17"
  },
  {
    "_id": {
      "$oid": "23topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-18"
  },
  {
    "_id": {
      "$oid": "23topernoteche19"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-19"
  },
  {
    "_id": {
      "$oid": "23topernoteche20"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-20"
  },
  {
    "_id": {
      "$oid": "23topernoteche21"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-21"
  },
  {
    "_id": {
      "$oid": "23topernoteche22"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-22"
  },
  {
    "_id": {
      "$oid": "23topernoteche23"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-23"
  },
  {
    "_id": {
      "$oid": "23topernoteche24"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-24"
  },
  {
    "_id": {
      "$oid": "23topernoteche25"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-25"
  },
  {
    "_id": {
      "$oid": "23topernoteche26"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "23-Alcohol Phenol and Ether-26"
  },
  {
    "_id": {
      "$oid": "24topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-01"
  },
  {
    "_id": {
      "$oid": "24topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-02"
  },
  {
    "_id": {
      "$oid": "24topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-03"
  },
  {
    "_id": {
      "$oid": "24topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-04"
  },
  {
    "_id": {
      "$oid": "24topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-05"
  },
  {
    "_id": {
      "$oid": "24topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-06"
  },
  {
    "_id": {
      "$oid": "24topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-07"
  },
  {
    "_id": {
      "$oid": "24topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-08"
  },
  {
    "_id": {
      "$oid": "24topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-09"
  },
  {
    "_id": {
      "$oid": "24topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-10"
  },
  {
    "_id": {
      "$oid": "24topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-11"
  },
  {
    "_id": {
      "$oid": "24topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-12"
  },
  {
    "_id": {
      "$oid": "24topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-13"
  },
  {
    "_id": {
      "$oid": "24topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-14"
  },
  {
    "_id": {
      "$oid": "24topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-15"
  },
  {
    "_id": {
      "$oid": "24topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-16"
  },
  {
    "_id": {
      "$oid": "24topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-17"
  },
  {
    "_id": {
      "$oid": "24topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-18"
  },
  {
    "_id": {
      "$oid": "24topernoteche19"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-19"
  },
  {
    "_id": {
      "$oid": "24topernoteche20"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-20"
  },
  {
    "_id": {
      "$oid": "24topernoteche21"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-21"
  },
  {
    "_id": {
      "$oid": "24topernoteche22"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-22"
  },
  {
    "_id": {
      "$oid": "24topernoteche23"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-23"
  },
  {
    "_id": {
      "$oid": "24topernoteche24"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-24"
  },
  {
    "_id": {
      "$oid": "24topernoteche25"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-25"
  },
  {
    "_id": {
      "$oid": "24topernoteche26"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-26"
  },
  {
    "_id": {
      "$oid": "24topernoteche27"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-27"
  },
  {
    "_id": {
      "$oid": "24topernoteche28"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-28"
  },
  {
    "_id": {
      "$oid": "24topernoteche29"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-29"
  },
  {
    "_id": {
      "$oid": "24topernoteche30"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-30"
  },
  {
    "_id": {
      "$oid": "24topernoteche31"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-31"
  },
  {
    "_id": {
      "$oid": "24topernoteche32"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-32"
  },
  {
    "_id": {
      "$oid": "24topernoteche33"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-33"
  },
  {
    "_id": {
      "$oid": "24topernoteche34"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-34"
  },
  {
    "_id": {
      "$oid": "24topernoteche35"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-35"
  },
  {
    "_id": {
      "$oid": "24topernoteche36"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-36"
  },
  {
    "_id": {
      "$oid": "24topernoteche37"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-37"
  },
  {
    "_id": {
      "$oid": "24topernoteche38"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-38"
  },
  {
    "_id": {
      "$oid": "24topernoteche39"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-39"
  },
  {
    "_id": {
      "$oid": "24topernoteche40"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "24-Aldehyde, Ketone and Carboxylic acid-40"
  },
  {
    "_id": {
      "$oid": "25topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC25",
    "pagename": "25-Amines-1"
  },
  {
    "_id": {
      "$oid": "25topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "25-Amines-2"
  },
  {
    "_id": {
      "$oid": "25topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "25-Amines-3"
  },
  {
    "_id": {
      "$oid": "25topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "25-Amines-4"
  },
  {
    "_id": {
      "$oid": "25topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "25-Amines-5"
  },
  {
    "_id": {
      "$oid": "25topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "25-Amines-6"
  },
  {
    "_id": {
      "$oid": "25topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "25-Amines-7"
  },
  {
    "_id": {
      "$oid": "25topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "25-Amines-8"
  },
  {
    "_id": {
      "$oid": "26topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC26",
    "pagename": "26-Biomolecules-01"
  },
  {
    "_id": {
      "$oid": "26topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-02"
  },
  {
    "_id": {
      "$oid": "26topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-03"
  },
  {
    "_id": {
      "$oid": "26topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-04"
  },
  {
    "_id": {
      "$oid": "26topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-05"
  },
  {
    "_id": {
      "$oid": "26topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-06"
  },
  {
    "_id": {
      "$oid": "26topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-07"
  },
  {
    "_id": {
      "$oid": "26topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-08"
  },
  {
    "_id": {
      "$oid": "26topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-09"
  },
  {
    "_id": {
      "$oid": "26topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-10"
  },
  {
    "_id": {
      "$oid": "26topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-11"
  },
  {
    "_id": {
      "$oid": "26topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-12"
  },
  {
    "_id": {
      "$oid": "26topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-13"
  },
  {
    "_id": {
      "$oid": "26topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-14"
  },
  {
    "_id": {
      "$oid": "26topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-15"
  },
  {
    "_id": {
      "$oid": "26topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-16"
  },
  {
    "_id": {
      "$oid": "26topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-17"
  },
  {
    "_id": {
      "$oid": "26topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-18"
  },
  {
    "_id": {
      "$oid": "26topernoteche19"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-19"
  },
  {
    "_id": {
      "$oid": "26topernoteche20"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-20"
  },
  {
    "_id": {
      "$oid": "26topernoteche21"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-21"
  },
  {
    "_id": {
      "$oid": "26topernoteche22"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-22"
  },
  {
    "_id": {
      "$oid": "26topernoteche23"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-23"
  },
  {
    "_id": {
      "$oid": "26topernoteche24"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "26-Biomolecules-24"
  },
  {
    "_id": {
      "$oid": "27topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC27",
    "pagename": "27-Polymers-1"
  },
  {
    "_id": {
      "$oid": "27topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "27-Polymers-2"
  },
  {
    "_id": {
      "$oid": "27topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "27-Polymers-3"
  },
  {
    "_id": {
      "$oid": "27topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "27-Polymers-4"
  },
  {
    "_id": {
      "$oid": "27topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "27-Polymers-5"
  },
  {
    "_id": {
      "$oid": "27topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "27-Polymers-6"
  },
  {
    "_id": {
      "$oid": "27topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "27-Polymers-7"
  },
  {
    "_id": {
      "$oid": "27topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "27-Polymers-8"
  },
  {
    "_id": {
      "$oid": "27topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "27-Polymers-9"
  },
  {
    "_id": {
      "$oid": "28topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-01"
  },
  {
    "_id": {
      "$oid": "28topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-02"
  },
  {
    "_id": {
      "$oid": "28topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-03"
  },
  {
    "_id": {
      "$oid": "28topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-04"
  },
  {
    "_id": {
      "$oid": "28topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-05"
  },
  {
    "_id": {
      "$oid": "28topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-06"
  },
  {
    "_id": {
      "$oid": "28topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-07"
  },
  {
    "_id": {
      "$oid": "28topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-08"
  },
  {
    "_id": {
      "$oid": "28topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-09"
  },
  {
    "_id": {
      "$oid": "28topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-10"
  },
  {
    "_id": {
      "$oid": "28topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-11"
  },
  {
    "_id": {
      "$oid": "28topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-12"
  },
  {
    "_id": {
      "$oid": "28topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-13"
  },
  {
    "_id": {
      "$oid": "28topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-14"
  },
  {
    "_id": {
      "$oid": "28topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-15"
  },
  {
    "_id": {
      "$oid": "28topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-16"
  },
  {
    "_id": {
      "$oid": "28topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-17"
  },
  {
    "_id": {
      "$oid": "28topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "28-General Organic Chemistry-18"
  },
  {
    "_id": {
      "$oid": "29topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-01"
  },
  {
    "_id": {
      "$oid": "29topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-02"
  },
  {
    "_id": {
      "$oid": "29topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-03"
  },
  {
    "_id": {
      "$oid": "29topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-04"
  },
  {
    "_id": {
      "$oid": "29topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-05"
  },
  {
    "_id": {
      "$oid": "29topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-06"
  },
  {
    "_id": {
      "$oid": "29topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-07"
  },
  {
    "_id": {
      "$oid": "29topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-08"
  },
  {
    "_id": {
      "$oid": "29topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-09"
  },
  {
    "_id": {
      "$oid": "29topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-10"
  },
  {
    "_id": {
      "$oid": "29topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-11"
  },
  {
    "_id": {
      "$oid": "29topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-12"
  },
  {
    "_id": {
      "$oid": "29topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-13"
  },
  {
    "_id": {
      "$oid": "29topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-14"
  },
  {
    "_id": {
      "$oid": "29topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-15"
  },
  {
    "_id": {
      "$oid": "29topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-16"
  },
  {
    "_id": {
      "$oid": "29topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-17"
  },
  {
    "_id": {
      "$oid": "29topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "29-Hydrocarbon-18"
  },
  {
    "_id": {
      "$oid": "30topernoteche1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-01"
  },
  {
    "_id": {
      "$oid": "30topernoteche2"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-02"
  },
  {
    "_id": {
      "$oid": "30topernoteche3"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-03"
  },
  {
    "_id": {
      "$oid": "30topernoteche4"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-04"
  },
  {
    "_id": {
      "$oid": "30topernoteche5"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-05"
  },
  {
    "_id": {
      "$oid": "30topernoteche6"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-06"
  },
  {
    "_id": {
      "$oid": "30topernoteche7"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-07"
  },
  {
    "_id": {
      "$oid": "30topernoteche8"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-08"
  },
  {
    "_id": {
      "$oid": "30topernoteche9"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-09"
  },
  {
    "_id": {
      "$oid": "30topernoteche10"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-10"
  },
  {
    "_id": {
      "$oid": "30topernoteche11"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-11"
  },
  {
    "_id": {
      "$oid": "30topernoteche12"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-12"
  },
  {
    "_id": {
      "$oid": "30topernoteche13"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-13"
  },
  {
    "_id": {
      "$oid": "30topernoteche14"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-14"
  },
  {
    "_id": {
      "$oid": "30topernoteche15"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-15"
  },
  {
    "_id": {
      "$oid": "30topernoteche16"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-16"
  },
  {
    "_id": {
      "$oid": "30topernoteche17"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-17"
  },
  {
    "_id": {
      "$oid": "30topernoteche18"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-18"
  },
  {
    "_id": {
      "$oid": "30topernoteche19"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-19"
  },
  {
    "_id": {
      "$oid": "30topernoteche20"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-20"
  },
  {
    "_id": {
      "$oid": "30topernoteche21"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-21"
  },
  {
    "_id": {
      "$oid": "30topernoteche22"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-22"
  },
  {
    "_id": {
      "$oid": "30topernoteche23"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-23"
  },
  {
    "_id": {
      "$oid": "30topernoteche24"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-24"
  },
  {
    "_id": {
      "$oid": "30topernoteche25"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-25"
  },
  {
    "_id": {
      "$oid": "30topernoteche26"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-26"
  },
  {
    "_id": {
      "$oid": "30topernoteche27"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-27"
  },
  {
    "_id": {
      "$oid": "30topernoteche28"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-28"
  },
  {
    "_id": {
      "$oid": "30topernoteche29"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-29"
  },
  {
    "_id": {
      "$oid": "30topernoteche30"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-30"
  },
  {
    "_id": {
      "$oid": "30topernoteche31"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-31"
  },
  {
    "_id": {
      "$oid": "30topernoteche32"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-32"
  },
  {
    "_id": {
      "$oid": "30topernoteche33"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-33"
  },
  {
    "_id": {
      "$oid": "30topernoteche34"
    },
    "type": "topernote",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "30-IUPAC Nomenclature-34"
  },


  {
    "_id": {
      "$oid": "01topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-01"
  },
  {
    "_id": {
      "$oid": "01topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-02"
  },
  {
    "_id": {
      "$oid": "01topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-03"
  },
  {
    "_id": {
      "$oid": "01topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-04"
  },
  {
    "_id": {
      "$oid": "01topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-05"
  },
  {
    "_id": {
      "$oid": "01topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-06"
  },
  {
    "_id": {
      "$oid": "01topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-07"
  },
  {
    "_id": {
      "$oid": "01topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-08"
  },
  {
    "_id": {
      "$oid": "01topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-09"
  },
  {
    "_id": {
      "$oid": "01topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-10"
  },
  {
    "_id": {
      "$oid": "01topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "1-Application of Biotechnology-11"
  },
  {
    "_id": {
      "$oid": "02topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-01"
  },
  {
    "_id": {
      "$oid": "02topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-02"
  },
  {
    "_id": {
      "$oid": "02topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-03"
  },
  {
    "_id": {
      "$oid": "02topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-04"
  },
  {
    "_id": {
      "$oid": "02topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-05"
  },
  {
    "_id": {
      "$oid": "02topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-06"
  },
  {
    "_id": {
      "$oid": "02topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-07"
  },
  {
    "_id": {
      "$oid": "02topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-08"
  },
  {
    "_id": {
      "$oid": "02topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-09"
  },
  {
    "_id": {
      "$oid": "02topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-10"
  },
  {
    "_id": {
      "$oid": "02topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-11"
  },
  {
    "_id": {
      "$oid": "02topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-12"
  },
  {
    "_id": {
      "$oid": "02topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-13"
  },
  {
    "_id": {
      "$oid": "02topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-14"
  },
  {
    "_id": {
      "$oid": "02topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-15"
  },
  {
    "_id": {
      "$oid": "02topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-16"
  },
  {
    "_id": {
      "$oid": "02topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-17"
  },
  {
    "_id": {
      "$oid": "02topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-18"
  },
  {
    "_id": {
      "$oid": "02topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-19"
  },
  {
    "_id": {
      "$oid": "02topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-20"
  },
  {
    "_id": {
      "$oid": "02topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-21"
  },
  {
    "_id": {
      "$oid": "02topernotebio22"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-22"
  },
  {
    "_id": {
      "$oid": "02topernotebio23"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-23"
  },
  {
    "_id": {
      "$oid": "02topernotebio24"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-24"
  },
  {
    "_id": {
      "$oid": "02topernotebio25"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-25"
  },
  {
    "_id": {
      "$oid": "02topernotebio26"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-26"
  },
  {
    "_id": {
      "$oid": "02topernotebio27"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-27"
  },
  {
    "_id": {
      "$oid": "02topernotebio28"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-28"
  },
  {
    "_id": {
      "$oid": "02topernotebio29"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "2-Animal Diversity-29"
  },
  {
    "_id": {
      "$oid": "03topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-01"
  },
  {
    "_id": {
      "$oid": "03topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-02"
  },
  {
    "_id": {
      "$oid": "03topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-03"
  },
  {
    "_id": {
      "$oid": "03topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-04"
  },
  {
    "_id": {
      "$oid": "03topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-05"
  },
  {
    "_id": {
      "$oid": "03topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-06"
  },
  {
    "_id": {
      "$oid": "03topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-07"
  },
  {
    "_id": {
      "$oid": "03topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-08"
  },
  {
    "_id": {
      "$oid": "03topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-09"
  },
  {
    "_id": {
      "$oid": "03topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-10"
  },
  {
    "_id": {
      "$oid": "03topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-11"
  },
  {
    "_id": {
      "$oid": "03topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-12"
  },
  {
    "_id": {
      "$oid": "03topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "3-Animal Husbandry-13"
  },
  {
    "_id": {
      "$oid": "04topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB04",
    "pagename": "4-Biomolecules-01"
  },
  {
    "_id": {
      "$oid": "04topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-02"
  },
  {
    "_id": {
      "$oid": "04topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-03"
  },
  {
    "_id": {
      "$oid": "04topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-04"
  },
  {
    "_id": {
      "$oid": "04topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-05"
  },
  {
    "_id": {
      "$oid": "04topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-06"
  },
  {
    "_id": {
      "$oid": "04topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-07"
  },
  {
    "_id": {
      "$oid": "04topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-08"
  },
  {
    "_id": {
      "$oid": "04topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-09"
  },
  {
    "_id": {
      "$oid": "04topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-10"
  },
  {
    "_id": {
      "$oid": "04topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-11"
  },
  {
    "_id": {
      "$oid": "04topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "4-Biomolecules-12"
  },
  {
    "_id": {
      "$oid": "05topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB05",
    "pagename": "5-Biotechnology-01"
  },
  {
    "_id": {
      "$oid": "05topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-02"
  },
  {
    "_id": {
      "$oid": "05topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-03"
  },
  {
    "_id": {
      "$oid": "05topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-04"
  },
  {
    "_id": {
      "$oid": "05topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-05"
  },
  {
    "_id": {
      "$oid": "05topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-06"
  },
  {
    "_id": {
      "$oid": "05topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-07"
  },
  {
    "_id": {
      "$oid": "05topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-08"
  },
  {
    "_id": {
      "$oid": "05topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-09"
  },
  {
    "_id": {
      "$oid": "05topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-10"
  },
  {
    "_id": {
      "$oid": "05topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-11"
  },
  {
    "_id": {
      "$oid": "05topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-12"
  },
  {
    "_id": {
      "$oid": "05topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-13"
  },
  {
    "_id": {
      "$oid": "05topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-14"
  },
  {
    "_id": {
      "$oid": "05topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-15"
  },
  {
    "_id": {
      "$oid": "05topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-16"
  },
  {
    "_id": {
      "$oid": "05topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-17"
  },
  {
    "_id": {
      "$oid": "05topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-18"
  },
  {
    "_id": {
      "$oid": "05topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-19"
  },
  {
    "_id": {
      "$oid": "05topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "5-Biotechnology-20"
  },

  {
    "_id": {
      "$oid": "06topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-01"
  },
  {
    "_id": {
      "$oid": "06topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-02"
  },
  {
    "_id": {
      "$oid": "06topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-03"
  },
  {
    "_id": {
      "$oid": "06topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-04"
  },
  {
    "_id": {
      "$oid": "06topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-05"
  },
  {
    "_id": {
      "$oid": "06topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-06"
  },
  {
    "_id": {
      "$oid": "06topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-07"
  },
  {
    "_id": {
      "$oid": "06topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-08"
  },
  {
    "_id": {
      "$oid": "06topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-09"
  },
  {
    "_id": {
      "$oid": "06topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-10"
  },
  {
    "_id": {
      "$oid": "06topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-11"
  },
  {
    "_id": {
      "$oid": "06topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-12"
  },
  {
    "_id": {
      "$oid": "06topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-13"
  },
  {
    "_id": {
      "$oid": "06topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-14"
  },
  {
    "_id": {
      "$oid": "06topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-15"
  },
  {
    "_id": {
      "$oid": "06topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-16"
  },
  {
    "_id": {
      "$oid": "06topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-17"
  },
  {
    "_id": {
      "$oid": "06topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-18"
  },
  {
    "_id": {
      "$oid": "06topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "6-Body fluid and circulation-19"
  },
  {
    "_id": {
      "$oid": "07topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-01"
  },
  {
    "_id": {
      "$oid": "07topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-02"
  },
  {
    "_id": {
      "$oid": "07topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-03"
  },
  {
    "_id": {
      "$oid": "07topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-04"
  },
  {
    "_id": {
      "$oid": "07topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-05"
  },
  {
    "_id": {
      "$oid": "07topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-06"
  },
  {
    "_id": {
      "$oid": "07topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-07"
  },
  {
    "_id": {
      "$oid": "07topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-08"
  },
  {
    "_id": {
      "$oid": "07topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-09"
  },
  {
    "_id": {
      "$oid": "07topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-10"
  },
  {
    "_id": {
      "$oid": "07topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-11"
  },
  {
    "_id": {
      "$oid": "07topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-12"
  },
  {
    "_id": {
      "$oid": "07topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-13"
  },
  {
    "_id": {
      "$oid": "07topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-14"
  },
  {
    "_id": {
      "$oid": "07topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-15"
  },
  {
    "_id": {
      "$oid": "07topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-16"
  },
  {
    "_id": {
      "$oid": "07topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-17"
  },
  {
    "_id": {
      "$oid": "07topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-18"
  },
  {
    "_id": {
      "$oid": "07topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-19"
  },
  {
    "_id": {
      "$oid": "07topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-20"
  },
  {
    "_id": {
      "$oid": "07topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "7-Breathing and exchange of gases-21"
  },
  {
    "_id": {
      "$oid": "08topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-01"
  },
  {
    "_id": {
      "$oid": "08topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-02"
  },
  {
    "_id": {
      "$oid": "08topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-03"
  },
  {
    "_id": {
      "$oid": "08topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-04"
  },
  {
    "_id": {
      "$oid": "08topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-05"
  },
  {
    "_id": {
      "$oid": "08topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-06"
  },
  {
    "_id": {
      "$oid": "08topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-07"
  },
  {
    "_id": {
      "$oid": "08topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-08"
  },
  {
    "_id": {
      "$oid": "08topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-09"
  },
  {
    "_id": {
      "$oid": "08topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-10"
  },
  {
    "_id": {
      "$oid": "08topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-11"
  },
  {
    "_id": {
      "$oid": "08topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-12"
  },
  {
    "_id": {
      "$oid": "08topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-13"
  },
  {
    "_id": {
      "$oid": "08topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-14"
  },
  {
    "_id": {
      "$oid": "08topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-15"
  },
  {
    "_id": {
      "$oid": "08topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-16"
  },
  {
    "_id": {
      "$oid": "08topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "8-Bigestion and absorption-17"
  },
  {
    "_id": {
      "$oid": "09topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB09",
    "pagename": "9-Ecosystem-01"
  },
  {
    "_id": {
      "$oid": "09topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-02"
  },
  {
    "_id": {
      "$oid": "09topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-03"
  },
  {
    "_id": {
      "$oid": "09topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-04"
  },
  {
    "_id": {
      "$oid": "09topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-05"
  },
  {
    "_id": {
      "$oid": "09topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-06"
  },
  {
    "_id": {
      "$oid": "09topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-07"
  },
  {
    "_id": {
      "$oid": "09topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-08"
  },
  {
    "_id": {
      "$oid": "09topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-09"
  },
  {
    "_id": {
      "$oid": "09topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-10"
  },
  {
    "_id": {
      "$oid": "09topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-11"
  },
  {
    "_id": {
      "$oid": "09topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-12"
  },
  {
    "_id": {
      "$oid": "09topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-13"
  },
  {
    "_id": {
      "$oid": "09topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-14"
  },
  {
    "_id": {
      "$oid": "09topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-15"
  },
  {
    "_id": {
      "$oid": "09topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-16"
  },
  {
    "_id": {
      "$oid": "09topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-17"
  },
  {
    "_id": {
      "$oid": "09topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-18"
  },
  {
    "_id": {
      "$oid": "09topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-19"
  },
  {
    "_id": {
      "$oid": "09topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-20"
  },
  {
    "_id": {
      "$oid": "09topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-21"
  },
  {
    "_id": {
      "$oid": "09topernotebio22"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-22"
  },
  {
    "_id": {
      "$oid": "09topernotebio23"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-23"
  },
  {
    "_id": {
      "$oid": "09topernotebio24"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-24"
  },
  {
    "_id": {
      "$oid": "09topernotebio25"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-25"
  },
  {
    "_id": {
      "$oid": "09topernotebio26"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-26"
  },
  {
    "_id": {
      "$oid": "09topernotebio27"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-27"
  },
  {
    "_id": {
      "$oid": "09topernotebio28"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-28"
  },
  {
    "_id": {
      "$oid": "09topernotebio29"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-29"
  },
  {
    "_id": {
      "$oid": "09topernotebio30"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-30"
  },
  {
    "_id": {
      "$oid": "09topernotebio31"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-31"
  },
  {
    "_id": {
      "$oid": "09topernotebio32"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-32"
  },
  {
    "_id": {
      "$oid": "09topernotebio33"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-33"
  },
  {
    "_id": {
      "$oid": "09topernotebio34"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "9-Ecosystem-34"
  },
  {
    "_id": {
      "$oid": "10topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB10",
    "pagename": "10-Environmental issue-01"
  },
  {
    "_id": {
      "$oid": "10topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-02"
  },
  {
    "_id": {
      "$oid": "10topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-03"
  },
  {
    "_id": {
      "$oid": "10topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-04"
  },
  {
    "_id": {
      "$oid": "10topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-05"
  },
  {
    "_id": {
      "$oid": "10topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-06"
  },
  {
    "_id": {
      "$oid": "10topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-07"
  },
  {
    "_id": {
      "$oid": "10topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-08"
  },
  {
    "_id": {
      "$oid": "10topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-09"
  },
  {
    "_id": {
      "$oid": "10topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-10"
  },
  {
    "_id": {
      "$oid": "10topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-11"
  },
  {
    "_id": {
      "$oid": "10topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-12"
  },
  {
    "_id": {
      "$oid": "10topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-13"
  },
  {
    "_id": {
      "$oid": "10topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-14"
  },
  {
    "_id": {
      "$oid": "10topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-15"
  },
  {
    "_id": {
      "$oid": "10topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-16"
  },
  {
    "_id": {
      "$oid": "10topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-17"
  },
  {
    "_id": {
      "$oid": "10topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-18"
  },
  {
    "_id": {
      "$oid": "10topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-19"
  },
  {
    "_id": {
      "$oid": "10topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-20"
  },
  {
    "_id": {
      "$oid": "10topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "10-Environmental issue-21"
  },
  {
    "_id": {
      "$oid": "11topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB11",
    "pagename": "11-Evolution-1"
  },
  {
    "_id": {
      "$oid": "11topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "11-Evolution-2"
  },
  {
    "_id": {
      "$oid": "11topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "11-Evolution-3"
  },
  {
    "_id": {
      "$oid": "11topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "11-Evolution-4"
  },
  {
    "_id": {
      "$oid": "11topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "11-Evolution-5"
  },
  {
    "_id": {
      "$oid": "11topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "11-Evolution-6"
  },
  {
    "_id": {
      "$oid": "11topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "11-Evolution-7"
  },
  {
    "_id": {
      "$oid": "12topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB12",
    "pagename": "12-Excretory system-01"
  },
  {
    "_id": {
      "$oid": "12topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-02"
  },
  {
    "_id": {
      "$oid": "12topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-03"
  },
  {
    "_id": {
      "$oid": "12topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-04"
  },
  {
    "_id": {
      "$oid": "12topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-05"
  },
  {
    "_id": {
      "$oid": "12topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-06"
  },
  {
    "_id": {
      "$oid": "12topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-07"
  },
  {
    "_id": {
      "$oid": "12topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-08"
  },
  {
    "_id": {
      "$oid": "12topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-09"
  },
  {
    "_id": {
      "$oid": "12topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-10"
  },
  {
    "_id": {
      "$oid": "12topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-11"
  },
  {
    "_id": {
      "$oid": "12topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-12"
  },
  {
    "_id": {
      "$oid": "12topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-13"
  },
  {
    "_id": {
      "$oid": "12topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-14"
  },
  {
    "_id": {
      "$oid": "12topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-15"
  },
  {
    "_id": {
      "$oid": "12topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-16"
  },
  {
    "_id": {
      "$oid": "12topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-17"
  },
  {
    "_id": {
      "$oid": "12topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-18"
  },
  {
    "_id": {
      "$oid": "12topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-19"
  },
  {
    "_id": {
      "$oid": "12topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-20"
  },
  {
    "_id": {
      "$oid": "12topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-21"
  },
  {
    "_id": {
      "$oid": "12topernotebio22"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-22"
  },
  {
    "_id": {
      "$oid": "12topernotebio23"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-23"
  },
  {
    "_id": {
      "$oid": "12topernotebio24"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-24"
  },
  {
    "_id": {
      "$oid": "12topernotebio25"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "12-Excretory system-25"
  },
  {
    "_id": {
      "$oid": "13topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB13",
    "pagename": "13-Human genetics-01"
  },
  {
    "_id": {
      "$oid": "13topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-02"
  },
  {
    "_id": {
      "$oid": "13topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-03"
  },
  {
    "_id": {
      "$oid": "13topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-04"
  },
  {
    "_id": {
      "$oid": "13topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-05"
  },
  {
    "_id": {
      "$oid": "13topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-06"
  },
  {
    "_id": {
      "$oid": "13topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-07"
  },
  {
    "_id": {
      "$oid": "13topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-08"
  },
  {
    "_id": {
      "$oid": "13topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-09"
  },
  {
    "_id": {
      "$oid": "13topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-10"
  },
  {
    "_id": {
      "$oid": "13topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-11"
  },
  {
    "_id": {
      "$oid": "13topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "13-Human genetics-12"
  },
  {
    "_id": {
      "$oid": "14topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB14",
    "pagename": "14-Human health and disease-01"
  },
  {
    "_id": {
      "$oid": "14topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-02"
  },
  {
    "_id": {
      "$oid": "14topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-03"
  },
  {
    "_id": {
      "$oid": "14topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-04"
  },
  {
    "_id": {
      "$oid": "14topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-05"
  },
  {
    "_id": {
      "$oid": "14topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-06"
  },
  {
    "_id": {
      "$oid": "14topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-07"
  },
  {
    "_id": {
      "$oid": "14topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-08"
  },
  {
    "_id": {
      "$oid": "14topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-09"
  },
  {
    "_id": {
      "$oid": "14topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-10"
  },
  {
    "_id": {
      "$oid": "14topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-11"
  },
  {
    "_id": {
      "$oid": "14topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-12"
  },
  {
    "_id": {
      "$oid": "14topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-13"
  },
  {
    "_id": {
      "$oid": "14topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-14"
  },
  {
    "_id": {
      "$oid": "14topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-15"
  },
  {
    "_id": {
      "$oid": "14topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-16"
  },
  {
    "_id": {
      "$oid": "14topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "14-Human health and disease-17"
  },
  {
    "_id": {
      "$oid": "15topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB15",
    "pagename": "15-Human physiology-01"
  },
  {
    "_id": {
      "$oid": "15topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-02"
  },
  {
    "_id": {
      "$oid": "15topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-03"
  },
  {
    "_id": {
      "$oid": "15topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-04"
  },
  {
    "_id": {
      "$oid": "15topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-05"
  },
  {
    "_id": {
      "$oid": "15topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-06"
  },
  {
    "_id": {
      "$oid": "15topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-07"
  },
  {
    "_id": {
      "$oid": "15topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-08"
  },
  {
    "_id": {
      "$oid": "15topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-09"
  },
  {
    "_id": {
      "$oid": "15topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-10"
  },
  {
    "_id": {
      "$oid": "15topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-11"
  },
  {
    "_id": {
      "$oid": "15topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-12"
  },
  {
    "_id": {
      "$oid": "15topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-13"
  },
  {
    "_id": {
      "$oid": "15topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-14"
  },
  {
    "_id": {
      "$oid": "15topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-15"
  },
  {
    "_id": {
      "$oid": "15topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-16"
  },
  {
    "_id": {
      "$oid": "15topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-17"
  },
  {
    "_id": {
      "$oid": "15topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-18"
  },
  {
    "_id": {
      "$oid": "15topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-19"
  },
  {
    "_id": {
      "$oid": "15topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-20"
  },
  {
    "_id": {
      "$oid": "15topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-21"
  },
  {
    "_id": {
      "$oid": "15topernotebio22"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-22"
  },
  {
    "_id": {
      "$oid": "15topernotebio23"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-23"
  },
  {
    "_id": {
      "$oid": "15topernotebio24"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-24"
  },
  {
    "_id": {
      "$oid": "15topernotebio25"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-25"
  },
  {
    "_id": {
      "$oid": "15topernotebio26"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-26"
  },
  {
    "_id": {
      "$oid": "15topernotebio27"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-27"
  },
  {
    "_id": {
      "$oid": "15topernotebio28"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-28"
  },
  {
    "_id": {
      "$oid": "15topernotebio29"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-29"
  },
  {
    "_id": {
      "$oid": "15topernotebio30"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-30"
  },
  {
    "_id": {
      "$oid": "15topernotebio31"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-31"
  },
  {
    "_id": {
      "$oid": "15topernotebio32"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-32"
  },
  {
    "_id": {
      "$oid": "15topernotebio33"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-33"
  },
  {
    "_id": {
      "$oid": "15topernotebio34"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-34"
  },
  {
    "_id": {
      "$oid": "15topernotebio35"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-35"
  },
  {
    "_id": {
      "$oid": "15topernotebio36"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-36"
  },
  {
    "_id": {
      "$oid": "15topernotebio37"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-37"
  },
  {
    "_id": {
      "$oid": "15topernotebio38"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-38"
  },
  {
    "_id": {
      "$oid": "15topernotebio39"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-39"
  },
  {
    "_id": {
      "$oid": "15topernotebio40"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-40"
  },
  {
    "_id": {
      "$oid": "15topernotebio41"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "15-Human physiology-41"
  },
  {
    "_id": {
      "$oid": "16topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-01"
  },
  {
    "_id": {
      "$oid": "16topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-02"
  },
  {
    "_id": {
      "$oid": "16topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-03"
  },
  {
    "_id": {
      "$oid": "16topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-04"
  },
  {
    "_id": {
      "$oid": "16topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-05"
  },
  {
    "_id": {
      "$oid": "16topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-06"
  },
  {
    "_id": {
      "$oid": "16topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-07"
  },
  {
    "_id": {
      "$oid": "16topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-08"
  },
  {
    "_id": {
      "$oid": "16topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-09"
  },
  {
    "_id": {
      "$oid": "16topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-10"
  },
  {
    "_id": {
      "$oid": "16topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-11"
  },
  {
    "_id": {
      "$oid": "16topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-12"
  },
  {
    "_id": {
      "$oid": "16topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-13"
  },
  {
    "_id": {
      "$oid": "16topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-14"
  },
  {
    "_id": {
      "$oid": "16topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-15"
  },
  {
    "_id": {
      "$oid": "16topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-16"
  },
  {
    "_id": {
      "$oid": "16topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-17"
  },
  {
    "_id": {
      "$oid": "16topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-18"
  },
  {
    "_id": {
      "$oid": "16topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-19"
  },
  {
    "_id": {
      "$oid": "16topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-20"
  },
  {
    "_id": {
      "$oid": "16topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-21"
  },
  {
    "_id": {
      "$oid": "16topernotebio22"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-22"
  },
  {
    "_id": {
      "$oid": "16topernotebio23"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-23"
  },
  {
    "_id": {
      "$oid": "16topernotebio24"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-24"
  },
  {
    "_id": {
      "$oid": "16topernotebio25"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-25"
  },
  {
    "_id": {
      "$oid": "16topernotebio26"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-26"
  },
  {
    "_id": {
      "$oid": "16topernotebio27"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-27"
  },
  {
    "_id": {
      "$oid": "16topernotebio28"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-28"
  },
  {
    "_id": {
      "$oid": "16topernotebio29"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-29"
  },
  {
    "_id": {
      "$oid": "16topernotebio30"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-30"
  },
  {
    "_id": {
      "$oid": "16topernotebio31"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-31"
  },
  {
    "_id": {
      "$oid": "16topernotebio32"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-32"
  },
  {
    "_id": {
      "$oid": "16topernotebio33"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-33"
  },
  {
    "_id": {
      "$oid": "16topernotebio34"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-34"
  },
  {
    "_id": {
      "$oid": "16topernotebio35"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-35"
  },
  {
    "_id": {
      "$oid": "16topernotebio36"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-36"
  },
  {
    "_id": {
      "$oid": "16topernotebio37"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-37"
  },
  {
    "_id": {
      "$oid": "16topernotebio38"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-38"
  },
  {
    "_id": {
      "$oid": "16topernotebio39"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-39"
  },
  {
    "_id": {
      "$oid": "16topernotebio40"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-40"
  },
  {
    "_id": {
      "$oid": "16topernotebio41"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-41"
  },
  {
    "_id": {
      "$oid": "16topernotebio42"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-42"
  },
  {
    "_id": {
      "$oid": "16topernotebio43"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-43"
  },
  {
    "_id": {
      "$oid": "16topernotebio44"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-44"
  },
  {
    "_id": {
      "$oid": "16topernotebio45"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-45"
  },
  {
    "_id": {
      "$oid": "16topernotebio46"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-46"
  },
  {
    "_id": {
      "$oid": "16topernotebio47"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-47"
  },
  {
    "_id": {
      "$oid": "16topernotebio48"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-48"
  },
  {
    "_id": {
      "$oid": "16topernotebio49"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-49"
  },
  {
    "_id": {
      "$oid": "16topernotebio50"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-50"
  },
  {
    "_id": {
      "$oid": "16topernotebio51"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-51"
  },
  {
    "_id": {
      "$oid": "16topernotebio52"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-52"
  },
  {
    "_id": {
      "$oid": "16topernotebio53"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-53"
  },
  {
    "_id": {
      "$oid": "16topernotebio54"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-54"
  },
  {
    "_id": {
      "$oid": "16topernotebio55"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-55"
  },
  {
    "_id": {
      "$oid": "16topernotebio56"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-56"
  },
  {
    "_id": {
      "$oid": "16topernotebio57"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-57"
  },
  {
    "_id": {
      "$oid": "16topernotebio58"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-58"
  },
  {
    "_id": {
      "$oid": "16topernotebio59"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-59"
  },
  {
    "_id": {
      "$oid": "16topernotebio60"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-60"
  },
  {
    "_id": {
      "$oid": "16topernotebio61"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-61"
  },
  {
    "_id": {
      "$oid": "16topernotebio62"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-62"
  },
  {
    "_id": {
      "$oid": "16topernotebio63"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-63"
  },
  {
    "_id": {
      "$oid": "16topernotebio64"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-64"
  },
  {
    "_id": {
      "$oid": "16topernotebio65"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "16-Microbesin Human Welfare-65"
  },
  {
    "_id": {
      "$oid": "17topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-01"
  },
  {
    "_id": {
      "$oid": "17topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-02"
  },
  {
    "_id": {
      "$oid": "17topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-03"
  },
  {
    "_id": {
      "$oid": "17topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-04"
  },
  {
    "_id": {
      "$oid": "17topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-05"
  },
  {
    "_id": {
      "$oid": "17topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-06"
  },
  {
    "_id": {
      "$oid": "17topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-07"
  },
  {
    "_id": {
      "$oid": "17topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-08"
  },
  {
    "_id": {
      "$oid": "17topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-09"
  },
  {
    "_id": {
      "$oid": "17topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-10"
  },
  {
    "_id": {
      "$oid": "17topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-11"
  },
  {
    "_id": {
      "$oid": "17topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-12"
  },
  {
    "_id": {
      "$oid": "17topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-13"
  },
  {
    "_id": {
      "$oid": "17topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "17-Plant Breeding-14"
  },
  {
    "_id": {
      "$oid": "18topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB18",
    "pagename": "18-Reproduction-01"
  },
  {
    "_id": {
      "$oid": "18topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-02"
  },
  {
    "_id": {
      "$oid": "18topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-03"
  },
  {
    "_id": {
      "$oid": "18topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-04"
  },
  {
    "_id": {
      "$oid": "18topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-05"
  },
  {
    "_id": {
      "$oid": "18topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-06"
  },
  {
    "_id": {
      "$oid": "18topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-07"
  },
  {
    "_id": {
      "$oid": "18topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-08"
  },
  {
    "_id": {
      "$oid": "18topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-09"
  },
  {
    "_id": {
      "$oid": "18topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-10"
  },
  {
    "_id": {
      "$oid": "18topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-11"
  },
  {
    "_id": {
      "$oid": "18topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-12"
  },
  {
    "_id": {
      "$oid": "18topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-13"
  },
  {
    "_id": {
      "$oid": "18topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-14"
  },
  {
    "_id": {
      "$oid": "18topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-15"
  },
  {
    "_id": {
      "$oid": "18topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-16"
  },
  {
    "_id": {
      "$oid": "18topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-17"
  },
  {
    "_id": {
      "$oid": "18topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-18"
  },
  {
    "_id": {
      "$oid": "18topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-19"
  },
  {
    "_id": {
      "$oid": "18topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-20"
  },
  {
    "_id": {
      "$oid": "18topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-21"
  },
  {
    "_id": {
      "$oid": "18topernotebio22"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-22"
  },
  {
    "_id": {
      "$oid": "18topernotebio23"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-23"
  },
  {
    "_id": {
      "$oid": "18topernotebio24"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-24"
  },
  {
    "_id": {
      "$oid": "18topernotebio25"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-25"
  },
  {
    "_id": {
      "$oid": "18topernotebio26"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-26"
  },
  {
    "_id": {
      "$oid": "18topernotebio27"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-27"
  },
  {
    "_id": {
      "$oid": "18topernotebio28"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-28"
  },
  {
    "_id": {
      "$oid": "18topernotebio29"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-29"
  },
  {
    "_id": {
      "$oid": "18topernotebio30"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-30"
  },
  {
    "_id": {
      "$oid": "18topernotebio31"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-31"
  },
  {
    "_id": {
      "$oid": "18topernotebio32"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-32"
  },
  {
    "_id": {
      "$oid": "18topernotebio33"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-33"
  },
  {
    "_id": {
      "$oid": "18topernotebio34"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-34"
  },
  {
    "_id": {
      "$oid": "18topernotebio35"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-35"
  },
  {
    "_id": {
      "$oid": "18topernotebio36"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-36"
  },
  {
    "_id": {
      "$oid": "18topernotebio37"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-37"
  },
  {
    "_id": {
      "$oid": "18topernotebio38"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-38"
  },
  {
    "_id": {
      "$oid": "18topernotebio39"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-39"
  },
  {
    "_id": {
      "$oid": "18topernotebio40"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-40"
  },
  {
    "_id": {
      "$oid": "18topernotebio41"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-41"
  },
  {
    "_id": {
      "$oid": "18topernotebio42"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-42"
  },
  {
    "_id": {
      "$oid": "18topernotebio43"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-43"
  },
  {
    "_id": {
      "$oid": "18topernotebio44"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-44"
  },
  {
    "_id": {
      "$oid": "18topernotebio45"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-45"
  },
  {
    "_id": {
      "$oid": "18topernotebio46"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-46"
  },
  {
    "_id": {
      "$oid": "18topernotebio47"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "18-Reproduction-47"
  },
  {
    "_id": {
      "$oid": "19topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB19",
    "pagename": "19-Reproductive Health-1"
  },
  {
    "_id": {
      "$oid": "19topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "19-Reproductive Health-2"
  },
  {
    "_id": {
      "$oid": "19topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "19-Reproductive Health-3"
  },
  {
    "_id": {
      "$oid": "19topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "19-Reproductive Health-4"
  },
  {
    "_id": {
      "$oid": "19topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "19-Reproductive Health-5"
  },
  {
    "_id": {
      "$oid": "19topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "19-Reproductive Health-6"
  },
  {
    "_id": {
      "$oid": "19topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "19-Reproductive Health-7"
  },
  {
    "_id": {
      "$oid": "20topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-01"
  },
  {
    "_id": {
      "$oid": "20topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-02"
  },
  {
    "_id": {
      "$oid": "20topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-03"
  },
  {
    "_id": {
      "$oid": "20topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-04"
  },
  {
    "_id": {
      "$oid": "20topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-05"
  },
  {
    "_id": {
      "$oid": "20topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-06"
  },
  {
    "_id": {
      "$oid": "20topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-07"
  },
  {
    "_id": {
      "$oid": "20topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-08"
  },
  {
    "_id": {
      "$oid": "20topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-09"
  },
  {
    "_id": {
      "$oid": "20topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-10"
  },
  {
    "_id": {
      "$oid": "20topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-11"
  },
  {
    "_id": {
      "$oid": "20topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-12"
  },
  {
    "_id": {
      "$oid": "20topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-13"
  },
  {
    "_id": {
      "$oid": "20topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-14"
  },
  {
    "_id": {
      "$oid": "20topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-15"
  },
  {
    "_id": {
      "$oid": "20topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-16"
  },
  {
    "_id": {
      "$oid": "20topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-17"
  },
  {
    "_id": {
      "$oid": "20topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-18"
  },
  {
    "_id": {
      "$oid": "20topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-19"
  },
  {
    "_id": {
      "$oid": "20topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-20"
  },
  {
    "_id": {
      "$oid": "20topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-21"
  },
  {
    "_id": {
      "$oid": "20topernotebio22"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-22"
  },
  {
    "_id": {
      "$oid": "20topernotebio23"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "20-Structural Organisation-23"
  },
  {
    "_id": {
      "$oid": "21topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB21",
    "pagename": "21-Genetics-01"
  },
  {
    "_id": {
      "$oid": "21topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-02"
  },
  {
    "_id": {
      "$oid": "21topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-03"
  },
  {
    "_id": {
      "$oid": "21topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-04"
  },
  {
    "_id": {
      "$oid": "21topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-05"
  },
  {
    "_id": {
      "$oid": "21topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-06"
  },
  {
    "_id": {
      "$oid": "21topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-07"
  },
  {
    "_id": {
      "$oid": "21topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-08"
  },
  {
    "_id": {
      "$oid": "21topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-09"
  },
  {
    "_id": {
      "$oid": "21topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-10"
  },
  {
    "_id": {
      "$oid": "21topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-11"
  },
  {
    "_id": {
      "$oid": "21topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-12"
  },
  {
    "_id": {
      "$oid": "21topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-13"
  },
  {
    "_id": {
      "$oid": "21topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-14"
  },
  {
    "_id": {
      "$oid": "21topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-15"
  },
  {
    "_id": {
      "$oid": "21topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-16"
  },
  {
    "_id": {
      "$oid": "21topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-17"
  },
  {
    "_id": {
      "$oid": "21topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-18"
  },
  {
    "_id": {
      "$oid": "21topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-19"
  },
  {
    "_id": {
      "$oid": "21topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-20"
  },
  {
    "_id": {
      "$oid": "21topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-21"
  },
  {
    "_id": {
      "$oid": "21topernotebio22"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-22"
  },
  {
    "_id": {
      "$oid": "21topernotebio23"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-23"
  },
  {
    "_id": {
      "$oid": "21topernotebio24"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-24"
  },
  {
    "_id": {
      "$oid": "21topernotebio25"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-25"
  },
  {
    "_id": {
      "$oid": "21topernotebio26"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-26"
  },
  {
    "_id": {
      "$oid": "21topernotebio27"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-27"
  },
  {
    "_id": {
      "$oid": "21topernotebio28"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-28"
  },
  {
    "_id": {
      "$oid": "21topernotebio29"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-29"
  },
  {
    "_id": {
      "$oid": "21topernotebio30"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-30"
  },
  {
    "_id": {
      "$oid": "21topernotebio31"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-31"
  },
  {
    "_id": {
      "$oid": "21topernotebio32"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-32"
  },
  {
    "_id": {
      "$oid": "21topernotebio33"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-33"
  },
  {
    "_id": {
      "$oid": "21topernotebio34"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-34"
  },
  {
    "_id": {
      "$oid": "21topernotebio35"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-35"
  },
  {
    "_id": {
      "$oid": "21topernotebio36"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-36"
  },
  {
    "_id": {
      "$oid": "21topernotebio37"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-37"
  },
  {
    "_id": {
      "$oid": "21topernotebio38"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-38"
  },
  {
    "_id": {
      "$oid": "21topernotebio39"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-39"
  },
  {
    "_id": {
      "$oid": "21topernotebio40"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-40"
  },
  {
    "_id": {
      "$oid": "21topernotebio41"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-41"
  },
  {
    "_id": {
      "$oid": "21topernotebio42"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-42"
  },
  {
    "_id": {
      "$oid": "21topernotebio43"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-43"
  },
  {
    "_id": {
      "$oid": "21topernotebio44"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-44"
  },
  {
    "_id": {
      "$oid": "21topernotebio45"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-45"
  },
  {
    "_id": {
      "$oid": "21topernotebio46"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-46"
  },
  {
    "_id": {
      "$oid": "21topernotebio47"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-47"
  },
  {
    "_id": {
      "$oid": "21topernotebio48"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-48"
  },
  {
    "_id": {
      "$oid": "21topernotebio49"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-49"
  },
  {
    "_id": {
      "$oid": "21topernotebio50"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-50"
  },
  {
    "_id": {
      "$oid": "21topernotebio51"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-51"
  },
  {
    "_id": {
      "$oid": "21topernotebio52"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-52"
  },
  {
    "_id": {
      "$oid": "21topernotebio53"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-53"
  },
  {
    "_id": {
      "$oid": "21topernotebio54"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-54"
  },
  {
    "_id": {
      "$oid": "21topernotebio55"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-55"
  },
  {
    "_id": {
      "$oid": "21topernotebio56"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-56"
  },
  {
    "_id": {
      "$oid": "21topernotebio57"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-57"
  },
  {
    "_id": {
      "$oid": "21topernotebio58"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-58"
  },
  {
    "_id": {
      "$oid": "21topernotebio59"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-59"
  },
  {
    "_id": {
      "$oid": "21topernotebio60"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-60"
  },
  {
    "_id": {
      "$oid": "21topernotebio61"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-61"
  },
  {
    "_id": {
      "$oid": "21topernotebio62"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-62"
  },
  {
    "_id": {
      "$oid": "21topernotebio63"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-63"
  },
  {
    "_id": {
      "$oid": "21topernotebio64"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-64"
  },
  {
    "_id": {
      "$oid": "21topernotebio65"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-65"
  },
  {
    "_id": {
      "$oid": "21topernotebio66"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-66"
  },
  {
    "_id": {
      "$oid": "21topernotebio67"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-67"
  },
  {
    "_id": {
      "$oid": "21topernotebio68"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-68"
  },
  {
    "_id": {
      "$oid": "21topernotebio69"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-69"
  },
  {
    "_id": {
      "$oid": "21topernotebio70"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-70"
  },
  {
    "_id": {
      "$oid": "21topernotebio71"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-71"
  },
  {
    "_id": {
      "$oid": "21topernotebio72"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "21-Genetics-72"
  },
  {
    "_id": {
      "$oid": "22topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-01"
  },
  {
    "_id": {
      "$oid": "22topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-02"
  },
  {
    "_id": {
      "$oid": "22topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-03"
  },
  {
    "_id": {
      "$oid": "22topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-04"
  },
  {
    "_id": {
      "$oid": "22topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-05"
  },
  {
    "_id": {
      "$oid": "22topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-06"
  },
  {
    "_id": {
      "$oid": "22topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-07"
  },
  {
    "_id": {
      "$oid": "22topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-08"
  },
  {
    "_id": {
      "$oid": "22topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-09"
  },
  {
    "_id": {
      "$oid": "22topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-10"
  },
  {
    "_id": {
      "$oid": "22topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-11"
  },
  {
    "_id": {
      "$oid": "22topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-12"
  },
  {
    "_id": {
      "$oid": "22topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-13"
  },
  {
    "_id": {
      "$oid": "22topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-14"
  },
  {
    "_id": {
      "$oid": "22topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-15"
  },
  {
    "_id": {
      "$oid": "22topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-16"
  },
  {
    "_id": {
      "$oid": "22topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-17"
  },
  {
    "_id": {
      "$oid": "22topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-18"
  },
  {
    "_id": {
      "$oid": "22topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-19"
  },
  {
    "_id": {
      "$oid": "22topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-20"
  },
  {
    "_id": {
      "$oid": "22topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-21"
  },
  {
    "_id": {
      "$oid": "22topernotebio22"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-22"
  },
  {
    "_id": {
      "$oid": "22topernotebio23"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-23"
  },
  {
    "_id": {
      "$oid": "22topernotebio24"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-24"
  },
  {
    "_id": {
      "$oid": "22topernotebio25"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-25"
  },
  {
    "_id": {
      "$oid": "22topernotebio26"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "22-Organisms and Theri-26"
  },
  {
    "_id": {
      "$oid": "23topernotebio1"
    },
    "type": "topernote",
    "subject": "subject",
    "topic": "CB23",
    "pagename": "23-Biodiversity-01"
  },
  {
    "_id": {
      "$oid": "23topernotebio2"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-02"
  },
  {
    "_id": {
      "$oid": "23topernotebio3"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-03"
  },
  {
    "_id": {
      "$oid": "23topernotebio4"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-04"
  },
  {
    "_id": {
      "$oid": "23topernotebio5"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-05"
  },
  {
    "_id": {
      "$oid": "23topernotebio6"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-06"
  },
  {
    "_id": {
      "$oid": "23topernotebio7"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-07"
  },
  {
    "_id": {
      "$oid": "23topernotebio8"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-08"
  },
  {
    "_id": {
      "$oid": "23topernotebio9"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-09"
  },
  {
    "_id": {
      "$oid": "23topernotebio10"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-10"
  },
  {
    "_id": {
      "$oid": "23topernotebio11"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-11"
  },
  {
    "_id": {
      "$oid": "23topernotebio12"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-12"
  },
  {
    "_id": {
      "$oid": "23topernotebio13"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-13"
  },
  {
    "_id": {
      "$oid": "23topernotebio14"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-14"
  },
  {
    "_id": {
      "$oid": "23topernotebio15"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-15"
  },
  {
    "_id": {
      "$oid": "23topernotebio16"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-16"
  },
  {
    "_id": {
      "$oid": "23topernotebio17"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-17"
  },
  {
    "_id": {
      "$oid": "23topernotebio18"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-18"
  },
  {
    "_id": {
      "$oid": "23topernotebio19"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-19"
  },
  {
    "_id": {
      "$oid": "23topernotebio20"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-20"
  },
  {
    "_id": {
      "$oid": "23topernotebio21"
    },
    "type": "topernote",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "23-Biodiversity-21"
  },


  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy1"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertbookphy1-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy2"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertbookphy2-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy3"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertbookphy3-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy4"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertbookphy4-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy5"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertbookphy5-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-24"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-25"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-26"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-27"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-28"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-29"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-30"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-31"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-32"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-33"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-34"
  },
  {
    "_id": {
      "$oid": "ncertbookphy6"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertbookphy6-35"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy7"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertbookphy7-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy8"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertbookphy8-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy9"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertbookphy9-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy10"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertbookphy10-24"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy11"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertbookphy11-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy12"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertbookphy12-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy13"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertbookphy13-19"
  },  
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy14"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertbookphy14-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-24"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-25"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-26"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-27"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-28"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-29"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-30"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-31"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-32"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-33"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-34"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-35"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-36"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-37"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-38"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-39"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-40"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-41"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-42"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-43"
  },
  {
    "_id": {
      "$oid": "ncertbookphy15"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertbookphy15-44"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-24"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-25"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-26"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-27"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-28"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-29"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-30"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-31"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-32"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-33"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-34"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-35"
  },
  {
    "_id": {
      "$oid": "ncertbookphy16"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertbookphy16-36"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-24"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-25"
  },
  {
    "_id": {
      "$oid": "ncertbookphy17"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertbookphy17-26"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-24"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-25"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-26"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-27"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-28"
  },
  {
    "_id": {
      "$oid": "ncertbookphy18"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertbookphy18-29"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy19"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertbookphy19-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy20"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertbookphy20-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy21"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertbookphy21-24"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy22"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertbookphy22-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-24"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-25"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-26"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-27"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-28"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-29"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-30"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-31"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-32"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-33"
  },
  {
    "_id": {
      "$oid": "ncertbookphy23"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertbookphy23-34"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy24"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertbookphy24-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy25"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertbookphy25-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy26"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertbookphy26-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy27"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertbookphy27-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-01"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-02"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-03"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-04"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-05"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-06"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-07"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-08"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-09"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-10"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-11"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-12"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-13"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-14"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-15"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-16"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-17"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-18"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-19"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-20"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-21"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-22"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-23"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-24"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-25"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-26"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-27"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-28"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-29"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-30"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-31"
  },
  {
    "_id": {
      "$oid": "ncertbookphy28"
    },
    "type": "ncertbook",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertbookphy28-32"
  },
     
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertbookche1-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-31"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-32"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-33"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-34"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-35"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-36"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-37"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-38"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-39"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-40"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-41"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-42"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-43"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-44"
  },
  {
    "_id": {
      "$oid": "ncertbookche28"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertbookche2-45"
  },  
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche38"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertbookche3-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-31"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-32"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-33"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-34"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-35"
  },
  {
    "_id": {
      "$oid": "ncertbookche48"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertbookche4-36"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-31"
  },
  {
    "_id": {
      "$oid": "ncertbookche58"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertbookche5-32"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-31"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-32"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-33"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-34"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-35"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-36"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-37"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-38"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-39"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-40"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-41"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-42"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-43"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-44"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-45"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-46"
  },
  {
    "_id": {
      "$oid": "ncertbookche68"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertbookche6-47"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche78"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertbookche7-21"
  },
 {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-31"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-32"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-33"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-34"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-35"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-36"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-37"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-38"
  },
  {
    "_id": {
      "$oid": "ncertbookche88"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertbookche8-39"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-31"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-32"
  },
  {
    "_id": {
      "$oid": "ncertbookche98"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertbookche9-33"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche108"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertbookche10-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche118"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertbookche11-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche128"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertbookche12-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche138"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertbookche13-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche148"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertbookche14-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-31"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-32"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-33"
  },
  {
    "_id": {
      "$oid": "ncertbookche158"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertbookche15-34"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-31"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-32"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-33"
  },
  {
    "_id": {
      "$oid": "ncertbookche168"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertbookche16-34"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-23"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-24"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-25"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-26"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-27"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-28"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-29"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-30"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-31"
  },
  {
    "_id": {
      "$oid": "ncertbookche178"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertbookche17-32"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche188"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertbookche18-22"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-01"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-02"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-03"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-04"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-05"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-06"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-07"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-08"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-09"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-10"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-11"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-12"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-13"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-14"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-15"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-16"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-17"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-18"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-19"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-20"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-21"
  },
  {
    "_id": {
      "$oid": "ncertbookche198"
    },
    "type": "ncertbook",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertbookche19-22"
  },
  
  {
    "_id": {
      "$oid": "ncertbookbio1-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertbookbio1-1"
  },
  {
    "_id": {
      "$oid": "ncertbookbio1-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertbookbio1-2"
  },
  {
    "_id": {
      "$oid": "ncertbookbio1-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertbookbio1-3"
  },
  {
    "_id": {
      "$oid": "ncertbookbio1-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertbookbio1-4"
  },
  {
    "_id": {
      "$oid": "ncertbookbio1-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertbookbio1-5"
  },
  {
    "_id": {
      "$oid": "ncertbookbio1-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertbookbio1-6"
  },
  {
    "_id": {
      "$oid": "ncertbookbio1-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertbookbio1-7"
  },
  {
    "_id": {
      "$oid": "ncertbookbio1-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertbookbio1-8"
  },
  {
    "_id": {
      "$oid": "ncertbookbio1-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertbookbio1-9"
  },
    {
    "_id": {
      "$oid": "ncertbookbio2-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio2-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertbookbio2-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio3-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertbookbio3-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-17"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-17"
  },
  {
    "_id": {
      "$oid": "ncertbookbio4-18"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertbookbio4-18"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio5-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertbookbio5-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio6-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertbookbio6-1"
  },
  {
    "_id": {
      "$oid": "ncertbookbio6-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertbookbio6-2"
  },
  {
    "_id": {
      "$oid": "ncertbookbio6-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertbookbio6-3"
  },
  {
    "_id": {
      "$oid": "ncertbookbio6-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertbookbio6-4"
  },
  {
    "_id": {
      "$oid": "ncertbookbio6-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertbookbio6-5"
  },
  {
    "_id": {
      "$oid": "ncertbookbio6-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertbookbio6-6"
  },
  {
    "_id": {
      "$oid": "ncertbookbio6-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertbookbio6-7"
  },
  {
    "_id": {
      "$oid": "ncertbookbio6-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertbookbio6-8"
  },
  {
    "_id": {
      "$oid": "ncertbookbio7-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertbookbio7-1"
  },
  {
    "_id": {
      "$oid": "ncertbookbio7-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertbookbio7-2"
  },
  {
    "_id": {
      "$oid": "ncertbookbio7-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertbookbio7-3"
  },
  {
    "_id": {
      "$oid": "ncertbookbio7-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertbookbio7-4"
  },
  {
    "_id": {
      "$oid": "ncertbookbio7-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertbookbio7-5"
  },
  {
    "_id": {
      "$oid": "ncertbookbio7-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertbookbio7-6"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-17"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-17"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-18"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-18"
  },
  {
    "_id": {
      "$oid": "ncertbookbio8-19"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertbookbio8-19"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio9-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertbookbio9-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio10-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertbookbio10-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-17"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-17"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-18"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-18"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-19"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-19"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-20"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-20"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-21"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-21"
  },
  {
    "_id": {
      "$oid": "ncertbookbio11-22"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertbookbio11-22"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio12-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertbookbio12-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio13-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertbookbio13-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio14-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertbookbio14-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio15-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertbookbio15-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio16-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertbookbio16-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio17-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertbookbio17-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio18-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertbookbio18-1"
  },
  {
    "_id": {
      "$oid": "ncertbookbio18-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertbookbio18-2"
  },
  {
    "_id": {
      "$oid": "ncertbookbio18-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertbookbio18-3"
  },
  {
    "_id": {
      "$oid": "ncertbookbio18-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertbookbio18-4"
  },
  {
    "_id": {
      "$oid": "ncertbookbio18-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertbookbio18-5"
  },
  {
    "_id": {
      "$oid": "ncertbookbio18-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertbookbio18-6"
  },
  {
    "_id": {
      "$oid": "ncertbookbio18-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertbookbio18-7"
  },
  {
    "_id": {
      "$oid": "ncertbookbio18-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertbookbio18-8"
  },
  {
    "_id": {
      "$oid": "ncertbookbio18-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertbookbio18-9"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio19-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertbookbio19-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-17"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-17"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-18"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-18"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-19"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-19"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-20"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-20"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-21"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-21"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-22"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-22"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-23"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-23"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-24"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-24"
  },
  {
    "_id": {
      "$oid": "ncertbookbio20-25"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertbookbio20-25"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio21-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertbookbio21-15"
  },
   
  {
    "_id": {
      "$oid": "ncertbookbio22-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio22-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio22-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio22-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio22-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio22-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio22-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio22-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio22-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio22-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertbookbio22-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-17"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-17"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-18"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-18"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-19"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-19"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-20"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-20"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-21"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-21"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-22"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-22"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-23"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-23"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-24"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-24"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-25"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-25"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-26"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-26"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-27"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-27"
  },
  {
    "_id": {
      "$oid": "ncertbookbio23-28"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertbookbio23-28"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-17"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-17"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-18"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-18"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-19"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-19"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-20"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-20"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-21"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-21"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-22"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-22"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-23"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-23"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-24"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-24"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-25"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-25"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-26"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-26"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-27"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-27"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-28"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-28"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-29"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-29"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-30"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-30"
  },
  {
    "_id": {
      "$oid": "ncertbookbio24-31"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertbookbio24-31"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio25-17"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertbookbio25-17"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-17"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-17"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-18"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-18"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-19"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-19"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-20"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-20"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-21"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-21"
  },
  {
    "_id": {
      "$oid": "ncertbookbio26-22"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertbookbio26-22"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio27-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertbookbio27-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio28-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertbookbio28-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio29-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertbookbio29-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-13"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-14"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-14"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-15"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-15"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-16"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-16"
  },
  {
    "_id": {
      "$oid": "ncertbookbio30-17"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertbookbio30-17"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio31-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertbookbio31-11"
  },
    {
    "_id": {
      "$oid": "ncertbookbio32-1"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-01"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-2"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-02"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-3"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-03"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-4"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-04"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-5"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-05"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-6"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-06"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-7"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-07"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-8"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-08"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-9"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-09"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-10"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-10"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-11"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-11"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-12"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-12"
  },
  {
    "_id": {
      "$oid": "ncertbookbio32-13"
    },
    "type": "ncertbook",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertbookbio32-13"
  },






  
  
  {
    "_id": {
      "$oid": "ncertsolutionphy1-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertsolutionphy1-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy1-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertsolutionphy1-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy1-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertsolutionphy1-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy1-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertsolutionphy1-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy1-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertsolutionphy1-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy1-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertsolutionphy1-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy1-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP01",
    "pagename": "ncertsolutionphy1-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy2-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP02",
    "pagename": "ncertsolutionphy2-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy3-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP03",
    "pagename": "ncertsolutionphy3-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-29"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-30"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy4-31"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP04",
    "pagename": "ncertsolutionphy4-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-29"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-30"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-31"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-32"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-33"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-34"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-35"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-35"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy5-36"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP05",
    "pagename": "ncertsolutionphy5-36"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy6-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP06",
    "pagename": "ncertsolutionphy6-28"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-1" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-001"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-2" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-002"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-3" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-003"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-4" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-004"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-5" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-005"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-6" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-006"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-7" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-007"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-8" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-008"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-9" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-009"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-10" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-010"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-11" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-011"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-12" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-012"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-13" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-013"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-14" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-014"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-15" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-015"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-16" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-016"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-17" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-017"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-18" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-018"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-19" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-019"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-20" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-020"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-21" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-021"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-22" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-022"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-23" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-023"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-24" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-024"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-25" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-025"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-26" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-026"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-27" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-027"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-28" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-028"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-29" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-029"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-30" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-030"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-31" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-031"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-32" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-032"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-33" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-033"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-34" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-034"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-35" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-035"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-36" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-036"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-37" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-037"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-38" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-038"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-39" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-039"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-40" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-040"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy8-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP08",
    "pagename": "ncertsolutionphy8-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy9-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP09",
    "pagename": "ncertsolutionphy9-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-29"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-30"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-31"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-32"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-33"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-34"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-35"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-35"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-36"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-36"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-37"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-37"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-38"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-38"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-39"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-39"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-40"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-40"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-41"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-41"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-42"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-42"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-43"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-43"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-44"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-44"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-45"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-45"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-46"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-46"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-47"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-47"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-48"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-48"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-49"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-49"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-50"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-50"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-51"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-51"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-52"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-52"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-53"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-53"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-54"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-54"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-55"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-55"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-56"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-56"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-57"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-57"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-58"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-58"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-59"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-59"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy10-60"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP10",
    "pagename": "ncertsolutionphy10-60"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-61" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-61"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-62" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-62"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-63" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-63"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-64" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-64"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-65" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-65"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-66" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-66"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-67" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-67"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-68" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-68"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-69" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-69"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-70" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-70"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-71" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-71"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-72" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-72"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-73" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-73"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy11-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP11",
    "pagename": "ncertsolutionphy11-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy12-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertsolutionphy12-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy12-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertsolutionphy12-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy12-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertsolutionphy12-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy12-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertsolutionphy12-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy12-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertsolutionphy12-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy12-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertsolutionphy12-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy12-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP12",
    "pagename": "ncertsolutionphy12-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy13-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP13",
    "pagename": "ncertsolutionphy13-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy14-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP14",
    "pagename": "ncertsolutionphy14-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy15-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP15",
    "pagename": "ncertsolutionphy15-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-29"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-30"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-31"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-32"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-33"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-34"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-35"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-35"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-36"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-36"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-37"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-37"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-38"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-38"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-39"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-39"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-40"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-40"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-41"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-41"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-42"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-42"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-43"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-43"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-44"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-44"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-45"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-45"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-46"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-46"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-47"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-47"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-48"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-48"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-49"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-49"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-50"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-50"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-51"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-51"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-52"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-52"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-53"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-53"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-54"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-54"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-55"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-55"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-56"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-56"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-57"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-57"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-58"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-58"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-59"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-59"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy16-60"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP16",
    "pagename": "ncertsolutionphy16-60"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-61" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-61"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-62" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-62"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-63" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-63"
  },
  {
    "_id": { "$oid": "ncertsolutionphy7-64" },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP07",
    "pagename": "ncertsolutionphy7-64"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-29"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-30"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-31"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-32"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-33"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-34"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-35"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-35"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-36"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-36"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-37"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-37"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy17-38"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP17",
    "pagename": "ncertsolutionphy17-38"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy18-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP18",
    "pagename": "ncertsolutionphy18-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy19-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP19",
    "pagename": "ncertsolutionphy19-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy20-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP20",
    "pagename": "ncertsolutionphy20-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy21-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP21",
    "pagename": "ncertsolutionphy21-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy22-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP22",
    "pagename": "ncertsolutionphy22-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy23-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP23",
    "pagename": "ncertsolutionphy23-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-29"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-30"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-31"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-32"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-33"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-34"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-35"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-35"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-36"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-36"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-37"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-37"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-38"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-38"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-39"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-39"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-40"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-40"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy24-41"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP24",
    "pagename": "ncertsolutionphy24-41"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy25-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP25",
    "pagename": "ncertsolutionphy25-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-29"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-30"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-31"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-32"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-33"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy26-34"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP26",
    "pagename": "ncertsolutionphy26-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy27-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP27",
    "pagename": "ncertsolutionphy27-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-15"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-16"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-17"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-18"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-19"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-20"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-21"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-22"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-23"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-24"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-25"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-26"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-27"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-28"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-29"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-30"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy28-31"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP28",
    "pagename": "ncertsolutionphy28-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-6"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-7"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-8"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-9"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-10"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-11"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-12"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-13"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy29-14"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP29",
    "pagename": "ncertsolutionphy29-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy30-1"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "ncertsolutionphy30-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy30-2"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "ncertsolutionphy30-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy30-3"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "ncertsolutionphy30-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy30-4"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "ncertsolutionphy30-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionphy30-5"
    },
    "type": "ncertsolution",
    "subject": "physics",
    "topic": "CP30",
    "pagename": "ncertsolutionphy30-5"
  },

   
  {
    "_id": {
      "$oid": "ncertsolutionche1-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche1-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC01",
    "pagename": "ncertsolutionche1-20"
  },

  {
    "_id": {
      "$oid": "ncertsolutionche2-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-28"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-29"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-30"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-31"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-32"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-33"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-34"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-35"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-35"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-36"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-36"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-37"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-37"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-38"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-38"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-39"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-39"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-40"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-40"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-41"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-41"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-42"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-42"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-43"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-43"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-44"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-44"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-45"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-45"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-46"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-46"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-47"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-47"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-48"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-48"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-49"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-49"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-50"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-50"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche2-51"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC02",
    "pagename": "ncertsolutionche2-51"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche3-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC03",
    "pagename": "ncertsolutionche3-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche4-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC04",
    "pagename": "ncertsolutionche4-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche5-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC05",
    "pagename": "ncertsolutionche5-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche6-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC06",
    "pagename": "ncertsolutionche6-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-28"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-29"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-30"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-31"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-32"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-33"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-34"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-35"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-35"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-36"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-36"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-37"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-37"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-38"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-38"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-39"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-39"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-40"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-40"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-41"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-41"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-42"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-42"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-43"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-43"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-44"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-44"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-45"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-45"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-46"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-46"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-47"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-47"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-48"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-48"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-49"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-49"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-50"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-50"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-51"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-51"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-52"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-52"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-53"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-53"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-54"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-54"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-55"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-55"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche7-56"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC07",
    "pagename": "ncertsolutionche7-56"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-28"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-29"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche8-30"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC08",
    "pagename": "ncertsolutionche8-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche9-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC09",
    "pagename": "ncertsolutionche9-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche10-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC10",
    "pagename": "ncertsolutionche10-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche11-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC11",
    "pagename": "ncertsolutionche11-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-28"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-29"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-30"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-31"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche12-32"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC12",
    "pagename": "ncertsolutionche12-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche13-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC13",
    "pagename": "ncertsolutionche13-22"
  },
   
  {
    "_id": {
      "$oid": "ncertsolutionche14-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche14-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC14",
    "pagename": "ncertsolutionche14-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche15-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC15",
    "pagename": "ncertsolutionche15-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-28"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-29"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-30"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-31"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-32"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche16-33"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC16",
    "pagename": "ncertsolutionche16-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche17-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC17",
    "pagename": "ncertsolutionche17-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche18-28"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC18",
    "pagename": "ncertsolutionche18-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche19-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC19",
    "pagename": "ncertsolutionche19-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche20-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC20",
    "pagename": "ncertsolutionche20-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche21-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC21",
    "pagename": "ncertsolutionche21-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche22-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC22",
    "pagename": "ncertsolutionche22-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-28"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-29"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-30"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche23-31"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC23",
    "pagename": "ncertsolutionche23-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche24-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC24",
    "pagename": "ncertsolutionche24-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-28"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-29"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-30"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-31"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-32"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-33"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-34"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-35"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-35"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche25-36"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC25",
    "pagename": "ncertsolutionche25-36"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-22"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-22"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-23"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-23"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-24"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-24"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-25"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-25"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-26"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-26"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-27"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-27"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-28"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-28"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-29"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-29"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-30"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-30"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-31"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-31"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-32"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-32"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-33"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-33"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-34"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-34"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche26-35"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC26",
    "pagename": "ncertsolutionche26-35"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-16"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-16"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-17"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-17"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-18"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-18"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-19"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-19"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-20"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-20"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche27-21"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC27",
    "pagename": "ncertsolutionche27-21"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-12"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-13"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-14"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche28-15"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC28",
    "pagename": "ncertsolutionche28-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche29-11"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC29",
    "pagename": "ncertsolutionche29-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-1"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-2"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-3"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-4"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-5"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-6"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-7"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-8"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-9"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionche30-10"
    },
    "type": "ncertsolution",
    "subject": "chemistry",
    "topic": "CC30",
    "pagename": "ncertsolutionche30-10"
  },

  {
    "_id": {
      "$oid": "ncertsolutionbio1-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertsolutionbio1-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio1-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertsolutionbio1-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio1-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertsolutionbio1-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio1-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB01",
    "pagename": "ncertsolutionbio1-4"
  },
    {
    "_id": {
      "$oid": "ncertsolutionbio2-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertsolutionbio2-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio2-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertsolutionbio2-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio2-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertsolutionbio2-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio2-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertsolutionbio2-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio2-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertsolutionbio2-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio2-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertsolutionbio2-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio2-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertsolutionbio2-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio2-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB02",
    "pagename": "ncertsolutionbio2-8"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio3-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertsolutionbio3-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio3-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertsolutionbio3-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio3-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertsolutionbio3-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio3-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertsolutionbio3-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio3-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertsolutionbio3-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio3-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertsolutionbio3-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio3-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB03",
    "pagename": "ncertsolutionbio3-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio4-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertsolutionbio4-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio4-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertsolutionbio4-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio4-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertsolutionbio4-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio4-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertsolutionbio4-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio4-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertsolutionbio4-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio4-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB04",
    "pagename": "ncertsolutionbio4-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-11"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-12"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-13"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-14"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-14"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio5-15"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB05",
    "pagename": "ncertsolutionbio5-15"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio6-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB06",
    "pagename": "ncertsolutionbio6-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio7-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertsolutionbio7-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio7-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertsolutionbio7-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio7-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertsolutionbio7-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio7-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertsolutionbio7-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio7-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertsolutionbio7-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio7-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertsolutionbio7-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio7-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertsolutionbio7-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio7-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB07",
    "pagename": "ncertsolutionbio7-8"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio8-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertsolutionbio8-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio8-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertsolutionbio8-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio8-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertsolutionbio8-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio8-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertsolutionbio8-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio8-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertsolutionbio8-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio8-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertsolutionbio8-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio8-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertsolutionbio8-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio8-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB08",
    "pagename": "ncertsolutionbio8-8"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio9-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertsolutionbio9-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio9-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertsolutionbio9-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio9-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertsolutionbio9-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio9-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertsolutionbio9-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio9-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertsolutionbio9-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio9-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertsolutionbio9-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio9-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertsolutionbio9-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio9-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertsolutionbio9-8"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio9-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB09",
    "pagename": "ncertsolutionbio9-9"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio10-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertsolutionbio10-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio10-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertsolutionbio10-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio10-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertsolutionbio10-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio10-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertsolutionbio10-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio10-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertsolutionbio10-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio10-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertsolutionbio10-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio10-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertsolutionbio10-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio10-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertsolutionbio10-8"
  },
   {
    "_id": {
      "$oid": "ncertsolutionbio10-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB10",
    "pagename": "ncertsolutionbio10-9"
  },
    {
    "_id": {
      "$oid": "ncertsolutionbio11-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertsolutionbio11-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio11-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertsolutionbio11-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio11-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertsolutionbio11-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio11-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertsolutionbio11-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio11-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertsolutionbio11-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio11-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertsolutionbio11-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio11-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertsolutionbio11-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio11-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB11",
    "pagename": "ncertsolutionbio11-8"
  },
   
  {
    "_id": {
      "$oid": "ncertsolutionbio12-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertsolutionbio12-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio12-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertsolutionbio12-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio12-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertsolutionbio12-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio12-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertsolutionbio12-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio12-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB12",
    "pagename": "ncertsolutionbio12-5"
  },
   
  {
    "_id": {
      "$oid": "ncertsolutionbio13-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertsolutionbio13-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio13-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertsolutionbio13-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio13-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertsolutionbio13-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio13-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertsolutionbio13-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio13-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB13",
    "pagename": "ncertsolutionbio13-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio14-11"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB14",
    "pagename": "ncertsolutionbio14-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio15-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertsolutionbio15-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio15-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertsolutionbio15-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio15-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertsolutionbio15-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio15-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertsolutionbio15-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio15-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertsolutionbio15-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio15-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB15",
    "pagename": "ncertsolutionbio15-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio16-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB16",
    "pagename": "ncertsolutionbio16-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio17-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertsolutionbio17-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio17-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertsolutionbio17-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio17-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertsolutionbio17-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio17-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertsolutionbio17-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio17-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertsolutionbio17-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio17-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertsolutionbio17-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio17-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertsolutionbio17-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio17-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB17",
    "pagename": "ncertsolutionbio17-8"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio18-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertsolutionbio18-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio18-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertsolutionbio18-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio18-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertsolutionbio18-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio18-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertsolutionbio18-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio18-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertsolutionbio18-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio18-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB18",
    "pagename": "ncertsolutionbio18-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio19-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertsolutionbio19-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio19-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertsolutionbio19-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio19-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertsolutionbio19-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio19-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertsolutionbio19-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio19-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertsolutionbio19-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio19-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB19",
    "pagename": "ncertsolutionbio19-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio20-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertsolutionbio20-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio20-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertsolutionbio20-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio20-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertsolutionbio20-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio20-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertsolutionbio20-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio20-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertsolutionbio20-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio20-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertsolutionbio20-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio20-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB20",
    "pagename": "ncertsolutionbio20-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-11"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-12"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio21-13"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB21",
    "pagename": "ncertsolutionbio21-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio22-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertsolutionbio22-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio22-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertsolutionbio22-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio22-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertsolutionbio22-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio22-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertsolutionbio22-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio22-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertsolutionbio22-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio22-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertsolutionbio22-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio22-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB22",
    "pagename": "ncertsolutionbio22-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio23-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertsolutionbio23-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio23-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertsolutionbio23-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio23-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertsolutionbio23-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio23-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertsolutionbio23-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio23-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertsolutionbio23-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio23-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertsolutionbio23-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio23-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB23",
    "pagename": "ncertsolutionbio23-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio24-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertsolutionbio24-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio24-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertsolutionbio24-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio24-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertsolutionbio24-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio24-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertsolutionbio24-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio24-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertsolutionbio24-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio24-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertsolutionbio24-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio24-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB24",
    "pagename": "ncertsolutionbio24-7"
  },
   
  {
    "_id": {
      "$oid": "ncertsolutionbio25-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio25-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio25-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio25-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio25-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio25-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio25-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio25-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio25-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio25-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB25",
    "pagename": "ncertsolutionbio25-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio26-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertsolutionbio26-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio26-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertsolutionbio26-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio26-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertsolutionbio26-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio26-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB26",
    "pagename": "ncertsolutionbio26-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-11"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio27-12"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB27",
    "pagename": "ncertsolutionbio27-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio28-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB28",
    "pagename": "ncertsolutionbio28-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio29-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertsolutionbio29-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio29-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertsolutionbio29-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio29-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertsolutionbio29-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio29-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertsolutionbio29-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio29-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB29",
    "pagename": "ncertsolutionbio29-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio30-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertsolutionbio30-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio30-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertsolutionbio30-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio30-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertsolutionbio30-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio30-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertsolutionbio30-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio30-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertsolutionbio30-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio30-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertsolutionbio30-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio30-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertsolutionbio30-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio30-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB30",
    "pagename": "ncertsolutionbio30-8"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio31-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertsolutionbio31-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio31-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertsolutionbio31-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio31-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertsolutionbio31-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio31-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertsolutionbio31-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio31-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertsolutionbio31-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio31-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB31",
    "pagename": "ncertsolutionbio31-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio32-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertsolutionbio32-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio32-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertsolutionbio32-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio32-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertsolutionbio32-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio32-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertsolutionbio32-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio32-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertsolutionbio32-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio32-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB32",
    "pagename": "ncertsolutionbio32-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio33-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB33",
    "pagename": "ncertsolutionbio33-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio33-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB33",
    "pagename": "ncertsolutionbio33-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio33-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB33",
    "pagename": "ncertsolutionbio33-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio33-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB33",
    "pagename": "ncertsolutionbio33-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio33-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB33",
    "pagename": "ncertsolutionbio33-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio33-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB33",
    "pagename": "ncertsolutionbio33-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio33-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB33",
    "pagename": "ncertsolutionbio33-7"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio34-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB34",
    "pagename": "ncertsolutionbio34-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio34-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB34",
    "pagename": "ncertsolutionbio34-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio34-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB34",
    "pagename": "ncertsolutionbio34-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio34-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB34",
    "pagename": "ncertsolutionbio34-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio34-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB34",
    "pagename": "ncertsolutionbio34-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-11"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-11"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-12"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-12"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio35-13"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB35",
    "pagename": "ncertsolutionbio35-13"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-01"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-02"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-03"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-04"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-05"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-06"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-07"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-8"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-08"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-9"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-09"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio36-10"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB36",
    "pagename": "ncertsolutionbio36-10"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio37-1"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB37",
    "pagename": "ncertsolutionbio37-1"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio37-2"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB37",
    "pagename": "ncertsolutionbio37-2"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio37-3"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB37",
    "pagename": "ncertsolutionbio37-3"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio37-4"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB37",
    "pagename": "ncertsolutionbio37-4"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio37-5"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB37",
    "pagename": "ncertsolutionbio37-5"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio37-6"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB37",
    "pagename": "ncertsolutionbio37-6"
  },
  {
    "_id": {
      "$oid": "ncertsolutionbio37-7"
    },
    "type": "ncertsolution",
    "subject": "biology",
    "topic": "CB37",
    "pagename": "ncertsolutionbio37-7"
  },









  
  











]

export default AllBookPage;